
import React, { useState, useEffect, useRef, useMemo } from 'react';
import * as lamejs from 'lamejs';
import { auth, db, storage, functions } from './firebase';
import { httpsCallable } from 'firebase/functions';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import {
  doc, setDoc, getDoc, collection,
  addDoc, getDocs, deleteDoc, updateDoc, deleteField
} from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';

const C = {
  primary: '#40A0DC',
  
  teal: '#2DD4BF',
  bg: '#0D1B2A',
  bgMid: '#111D28',
  bgLight: '#162030',
  censor: '#E74C3C',
  censorOn: '#27AE60',
};

// ── SVG Icons ─────────────────────────────────────────────────────────────────
const IcoMusic = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>;
const IcoFilm = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="2"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="2" y1="7" x2="7" y2="7"/><line x1="2" y1="17" x2="7" y2="17"/><line x1="17" y1="17" x2="22" y2="17"/><line x1="17" y1="7" x2="22" y2="7"/></svg>;
const IcoDownload = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const IcoUpload = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>;
const IcoStar = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IcoClock = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IcoDoc = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>;
const IcoFlag = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>;
const IcoTrash = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>;
const IcoPin = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="17" x2="12" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17z"/></svg>;
const IcoEye = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IcoRepeat = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>;
const IcoPencilSVG = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IcoUndo = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 0 0-4-4H4"/></svg>;
const IcoMic = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>;
const IcoCpu = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>;
const IcoVolumeX = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>;
const IcoVolume = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>;
const IcoList = ({size=14,col='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={col} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;

const MONETIZATION_SAFE = [
  'fuck','fucking','fucker','fucked','fuckhead','fucks','motherfucker','motherfucking','motherfucked',
  'shit','shitting','shitted','bullshit','bullshitting','shits',
  'bitch','bitches','bitching','bitched',
  'asshole','assholes',
  'bastard','bastards',
  'cock','cocks','dick','dicks','pussy','pussies','cunt','cunts',
  'penis','vagina','balls','tit','tits','titty','titties','boob','boobs',
  'cum','cumshot','jizz','jizzing','jizzed',
  'nigger','niggers','nigga','niggas',
  'faggot','faggots','fag','fags',
  'whore','whores','slut','sluts','skank','skanks',
  'rape','raping','raped','raper','rapist','rapists',
  'boner','erection','blowjob','handjob','rimjob',
  'dildo','vibrator',
  'retard','retarded',
  'suicide','suicided','suiciding','suicidal',
];

const FULLY_CLEAN = [
  ...MONETIZATION_SAFE,
  'damn','damnit','damned','damning',
  'hell',
  'crap','crapping','crapped',
  'piss','pissed','pissing',
  'ass','asses',
  'goddamn','goddammit','god damn',
];

const BUILT_IN_PROFANITY = MONETIZATION_SAFE;

const PLANS = {
  clipper: { name: 'Clipper', price: '$4.99', period: 'month', features: ['Transcription', 'Auto profanity detection', 'Mute or bleep censoring', 'Clean MP3 & video export', '1.5 hrs of processing / month'] },
  family:      { name: 'Family Plan', price: '$19.99', period: 'month', features: ['20 hours of watching & listening', 'Profanity detection', 'Mute or bleep censoring', 'Live censor preview on dashboard', 'Private in-home viewing only'] },
  family_plus: { name: 'Family Plus', price: '$39.99', period: 'month', features: ['40 hours of watching & listening', 'Profanity detection', 'Mute or bleep censoring', 'Live censor preview on dashboard', 'Private in-home viewing only'] },
  creator: { name: 'Creator', price: '$300', period: 'month', features: ['Everything in Clipper', 'Full transcript with speaker labels', 'Interactive waveform viewer', 'Show notes generator', 'YouTube chapter markers', '3 hrs of processing / week (~12 hrs/month)'] },
};

const PLAN_LIMITS = {
  clipper:     { maxProcessingSeconds: 1.5 * 3600, canExport: true,  maxWatchSeconds: Infinity },
  family:      { maxProcessingSeconds: Infinity,    canExport: false, maxWatchSeconds: 20 * 3600 },
  family_plus: { maxProcessingSeconds: Infinity,    canExport: false, maxWatchSeconds: 40 * 3600 },
  creator:     { maxProcessingSeconds: 12 * 3600,   canExport: true,  maxWatchSeconds: Infinity },
  enterprise:  { maxProcessingSeconds: Infinity,    canExport: true,  maxWatchSeconds: Infinity },
};
const FAMILY_PLANS  = new Set(['family', 'family_plus']);
const ADMIN_EMAILS  = ['gijoeclean@gmail.com', 'omar@sensorlogic.io', 'matt@sensorlogic.io'];
const isAdmin        = (u) => ADMIN_EMAILS.includes(u?.email);
const isFamily       = (ud) => FAMILY_PLANS.has(ud?.plan);
const canExport      = (u, ud) => isAdmin(u) || (PLAN_LIMITS[ud?.plan]?.canExport ?? false);
const canProcess     = (u, ud) => isAdmin(u) || ((ud?.processingSecondsUsed ?? 0) < (PLAN_LIMITS[ud?.plan]?.maxProcessingSeconds ?? Infinity));
const canWatch       = (u, ud) => isAdmin(u) || !isFamily(ud) || ((ud?.watchSecondsUsed ?? 0) < (PLAN_LIMITS[ud?.plan]?.maxWatchSeconds ?? Infinity));
const getResetDate   = (ud) => {
  const start = new Date(ud?.usagePeriodStart || ud?.signedUpAt || Date.now());
  return new Date(start.getTime() + 30 * 24 * 60 * 60 * 1000)
    .toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};
const getWatchResetDate = (ud) => {
  const start = new Date(ud?.watchPeriodStart || ud?.signedUpAt || Date.now());
  return new Date(start.getTime() + 30 * 24 * 60 * 60 * 1000)
    .toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

const SPEAKER_COLORS = ['#40A0DC','#2DD4BF','#F59E0B','#A78BFA','#F472B6','#34D399'];

const S = {
  app: { backgroundColor: C.bg, minHeight: '100vh', fontFamily: "'Montserrat', sans-serif", color: 'white' },
  appBar: { backgroundColor: C.bg, borderBottom: `1px solid ${C.primary}26`, padding: '0 16px', display: 'flex', alignItems: 'center', height: 60 },
  body: { display: 'flex', flexDirection: 'column', height: 'calc(100vh - 60px)' },
  controls: { backgroundColor: C.bgMid, padding: '8px 16px' },
  toolbar: { backgroundColor: C.bg, padding: '8px 16px', display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' },
  hints: { backgroundColor: '#0A1520', padding: '4px 16px', display: 'flex', gap: 16 },
  list: { flex: 1, overflowY: 'auto', padding: '8px 12px' },
  card: (active) => ({
    backgroundColor: active ? C.bgLight : C.bgMid,
    borderRadius: 10,
    border: `1px solid ${active ? C.primary + '88' : C.primary + '18'}`,
    marginBottom: 8,
    overflow: 'hidden',
  }),
  input: { backgroundColor: 'rgba(255,255,255,0.06)', border: `1px solid ${C.primary}26`, borderRadius: 8, color: 'white', padding: '6px 12px', fontSize: 13, outline: 'none' },
  btn: (color = C.primary) => ({ backgroundColor: color + '22', border: `1px solid ${color}44`, borderRadius: 8, color: color, padding: '6px 12px', fontSize: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }),
  iconBtn: (active) => ({ backgroundColor: active ? C.primary + '26' : 'rgba(255,255,255,0.06)', border: `1px solid ${active ? C.primary + '66' : 'transparent'}`, borderRadius: 6, color: active ? C.primary : 'rgba(255,255,255,0.3)', padding: 6, cursor: 'pointer' }),
  chip: (color) => ({ backgroundColor: color + '1a', border: `1px solid ${color}4d`, borderRadius: 4, color: color, padding: '2px 8px', fontSize: 10, fontWeight: 'bold' }),
};

// ── Audio Processing Helpers ──────────────────────────────────────────────────

function applyNoiseGate(audioBuffer, threshold = 0.015) {
  const windowSize = Math.floor(audioBuffer.sampleRate * 0.02);
  for (let ch = 0; ch < audioBuffer.numberOfChannels; ch++) {
    const data = audioBuffer.getChannelData(ch);
    for (let i = 0; i < data.length; i += windowSize) {
      const end = Math.min(i + windowSize, data.length);
      let rms = 0;
      for (let j = i; j < end; j++) rms += data[j] * data[j];
      rms = Math.sqrt(rms / (end - i));
      if (rms < threshold) {
        const gain = Math.max(0, rms / threshold) * 0.1;
        for (let j = i; j < end; j++) data[j] *= gain;
      }
    }
  }
}

const CENSOR_SOUNDS = [
  { value: 'mute',  label: '🔇 Mute' },
  { value: 'bleep', label: '📢 Bleep' },
];

function censorSample(i, sr, style) {
  switch (style) {
    case 'bleep': return 0.25 * Math.sin(2 * Math.PI * 1000 * i / sr);
    case 'honk':  return 0.18 * (Math.sin(2 * Math.PI * 370 * i / sr) + Math.sin(2 * Math.PI * 496 * i / sr));
    case 'horn':  return 0.18 * (Math.sin(2 * Math.PI * 261 * i / sr) + Math.sin(2 * Math.PI * 392 * i / sr) + 0.5 * Math.sin(2 * Math.PI * 523 * i / sr));
    case 'ring':  return 0.2 * (Math.sin(2 * Math.PI * 480 * i / sr) + Math.sin(2 * Math.PI * 620 * i / sr));
    case 'bark': {
      const decay = Math.exp(-i / (sr * 0.08));
      return 0.35 * decay * (Math.sin(2 * Math.PI * 220 * i / sr) + (Math.random() * 2 - 1) * 0.4);
    }
    case 'meow': {
      const freq = 700 + 400 * Math.exp(-i / (sr * 0.15));
      const env = Math.sin(Math.PI * Math.min(i / (sr * 0.4), 1)) * Math.exp(-i / (sr * 0.6));
      return 0.3 * env * Math.sin(2 * Math.PI * freq * i / sr);
    }
    default: return 0;
  }
}

function applyCensoring(audioBuffer, censorPoints, style = 'mute') {
  const sr = audioBuffer.sampleRate;
  for (const pt of censorPoints) {
    const s = Math.floor(pt.start * sr);
    const e = Math.ceil(pt.end * sr);
    for (let ch = 0; ch < audioBuffer.numberOfChannels; ch++) {
      const data = audioBuffer.getChannelData(ch);
      for (let i = s; i <= e && i < data.length; i++) {
        data[i] = style === 'mute' ? 0 : censorSample(i - s, sr, style);
      }
    }
  }
}

function normalizeLoudness(audioBuffer, targetDB = -16) {
  let sumSq = 0, count = 0;
  for (let ch = 0; ch < audioBuffer.numberOfChannels; ch++) {
    const data = audioBuffer.getChannelData(ch);
    for (let i = 0; i < data.length; i++) { sumSq += data[i] ** 2; count++; }
  }
  const rms = Math.sqrt(sumSq / count);
  if (rms === 0) return;
  const gain = Math.pow(10, (targetDB - 20 * Math.log10(rms)) / 20);
  for (let ch = 0; ch < audioBuffer.numberOfChannels; ch++) {
    const data = audioBuffer.getChannelData(ch);
    for (let i = 0; i < data.length; i++) data[i] = Math.max(-1, Math.min(1, data[i] * gain));
  }
}

function trimSilence(audioBuffer, threshold = 0.01) {
  const ch0 = audioBuffer.getChannelData(0);
  let start = 0, end = ch0.length - 1;
  while (start < end && Math.abs(ch0[start]) < threshold) start++;
  while (end > start && Math.abs(ch0[end]) < threshold) end--;
  const pad = Math.floor(0.1 * audioBuffer.sampleRate);
  start = Math.max(0, start - pad);
  end = Math.min(ch0.length - 1, end + pad);
  const len = end - start + 1;
  const out = new AudioBuffer({ numberOfChannels: audioBuffer.numberOfChannels, length: len, sampleRate: audioBuffer.sampleRate });
  for (let c = 0; c < audioBuffer.numberOfChannels; c++) {
    out.getChannelData(c).set(audioBuffer.getChannelData(c).subarray(start, end + 1));
  }
  return out;
}

function encodeWAV(audioBuffer) {
  const nc = audioBuffer.numberOfChannels, sr = audioBuffer.sampleRate, ns = audioBuffer.length;
  const buf = new ArrayBuffer(44 + ns * nc * 2);
  const v = new DataView(buf);
  const ws = (o, s) => { for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); };
  ws(0, 'RIFF'); v.setUint32(4, 36 + ns * nc * 2, true);
  ws(8, 'WAVE'); ws(12, 'fmt ');
  v.setUint32(16, 16, true); v.setUint16(20, 1, true);
  v.setUint16(22, nc, true); v.setUint32(24, sr, true);
  v.setUint32(28, sr * nc * 2, true); v.setUint16(32, nc * 2, true);
  v.setUint16(34, 16, true); ws(36, 'data'); v.setUint32(40, ns * nc * 2, true);
  let off = 44;
  for (let i = 0; i < ns; i++) {
    for (let c = 0; c < nc; c++) {
      const s = Math.max(-1, Math.min(1, audioBuffer.getChannelData(c)[i]));
      v.setInt16(off, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
      off += 2;
    }
  }
  return buf;
}

function encodeMP3(audioBuffer) {
  const nc = audioBuffer.numberOfChannels;
  const sr = audioBuffer.sampleRate;
  const mp3enc = new lamejs.Mp3Encoder(Math.min(nc, 2), sr, 128);
  const blockSize = 1152;
  const toInt16 = (f32) => {
    const int16 = new Int16Array(f32.length);
    for (let i = 0; i < f32.length; i++) int16[i] = Math.max(-32768, Math.min(32767, Math.round(f32[i] * 32767)));
    return int16;
  };
  const left = toInt16(audioBuffer.getChannelData(0));
  const right = nc > 1 ? toInt16(audioBuffer.getChannelData(1)) : null;
  const mp3Data = [];
  for (let i = 0; i < left.length; i += blockSize) {
    const l = left.subarray(i, i + blockSize);
    const mp3buf = right ? mp3enc.encodeBuffer(l, right.subarray(i, i + blockSize)) : mp3enc.encodeBuffer(l);
    if (mp3buf.length > 0) mp3Data.push(new Int8Array(mp3buf));
  }
  const end = mp3enc.flush();
  if (end.length > 0) mp3Data.push(new Int8Array(end));
  return new Blob(mp3Data, { type: 'audio/mp3' });
}

const migrateCensorPoints = (points) => {
  if (!points?.length) return [];
  if (typeof points[0] === 'number') return points.map(t => ({ start: t, end: t + 0.8 }));
  return points;
};

const fmt = (s) => {
  const m = Math.floor((s || 0) / 60).toString().padStart(2, '0');
  const sec = ((s || 0) % 60).toFixed(1).padStart(4, '0');
  return `${m}:${sec}`;
};

const fmtChapter = (s) => {
  const h = Math.floor((s || 0) / 3600);
  const m = Math.floor(((s || 0) % 3600) / 60);
  const sec = Math.floor((s || 0) % 60);
  if (h > 0) return `${h}:${m.toString().padStart(2,'0')}:${sec.toString().padStart(2,'0')}`;
  return `${m}:${sec.toString().padStart(2,'0')}`;
};

// ── DMCA Page ─────────────────────────────────────────────────────────────────
function DmcaPage() {
  const h2 = { fontSize: 16, fontWeight: 700, color: C.primary, marginTop: 32, marginBottom: 8, letterSpacing: 0.5 };
  const p = { color: 'rgba(255,255,255,0.7)', lineHeight: 1.8, marginBottom: 12, fontSize: 15 };
  const li = { color: 'rgba(255,255,255,0.7)', lineHeight: 1.8, marginBottom: 6, fontSize: 15 };
  return (
    <div style={{ backgroundColor: C.bg, minHeight: '100vh', fontFamily: "'Montserrat', sans-serif", color: 'white' }}>
      {/* Header */}
      <div style={{ borderBottom: `1px solid ${C.primary}22`, padding: '0 24px', height: 60, display: 'flex', alignItems: 'center' }}>
        <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
          <WaveLogo compact size={28} />
          <span style={{ fontSize: 18, fontWeight: 900, letterSpacing: 2, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>SENSOR</span>
        </a>
      </div>
      {/* Body */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '52px 24px 80px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 900, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: 6 }}>DMCA Copyright Policy</h1>
        <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13, marginBottom: 36 }}>Last updated: June 22, 2026</div>

        <p style={p}>OAR Technologies Inc. (doing business as "Sensor Logic," operating the website sensorlogic.io and the SENSOR application, collectively the "Service") respects the intellectual property rights of others and expects its users to do the same. In accordance with the Digital Millennium Copyright Act of 1998 ("DMCA"), we will respond expeditiously to valid notices of claimed copyright infringement reported to our Designated Copyright Agent identified below.</p>

        <h2 style={h2}>User Responsibility</h2>
        <p style={p}>The Service is a tool that allows users to upload audio and video content they own or are otherwise authorized to use, in order to detect and filter profanity and produce filtered versions for their own permitted purposes. Users are solely responsible for ensuring they hold all necessary rights to any content they upload, process, store, or export through the Service. Uploading, processing, or distributing content you do not own or are not authorized to use is prohibited under our Terms of Service.</p>

        <h2 style={h2}>Designated Copyright Agent</h2>
        <p style={p}>Notifications of claimed copyright infringement should be sent to our Designated Agent, registered with the United States Copyright Office:</p>
        <ul style={{ paddingLeft: 20, margin: '0 0 16px' }}>
          <li style={li}>Designated Agent: Omar Anderson, DMCA Agent</li>
          <li style={li}>Organization: OAR Technologies Inc.</li>
          <li style={li}>Address: 401 Arcadia Loop, Apt A, Yorktown, VA 23692, United States</li>
          <li style={li}>Email: <a href="mailto:omar@sensorlogic.io" style={{ color: C.teal }}>omar@sensorlogic.io</a></li>
          <li style={li}>Copyright Office Registration Number: DMCA-1074567</li>
        </ul>

        <h2 style={h2}>Filing a Notice of Claimed Infringement</h2>
        <p style={p}>If you believe material on the Service infringes your copyright, submit a written notice to our Designated Agent that includes substantially all of the following, as required by 17 U.S.C. § 512(c)(3):</p>
        <ol style={{ paddingLeft: 20, margin: '0 0 16px' }}>
          <li style={li}>A physical or electronic signature of the copyright owner or a person authorized to act on their behalf.</li>
          <li style={li}>Identification of the copyrighted work claimed to have been infringed, or a representative list if multiple works are covered.</li>
          <li style={li}>Identification of the material claimed to be infringing and information reasonably sufficient to permit us to locate it.</li>
          <li style={li}>Information reasonably sufficient to permit us to contact you (name, address, telephone number, email).</li>
          <li style={li}>A statement that you have a good-faith belief that use of the material is not authorized by the copyright owner, its agent, or the law.</li>
          <li style={li}>A statement that the information is accurate, and under penalty of perjury, that you are the copyright owner or authorized to act on their behalf.</li>
        </ol>
        <p style={p}>Under 17 U.S.C. § 512(f), any person who knowingly materially misrepresents that material is infringing may be liable for damages.</p>

        <h2 style={h2}>Counter-Notification</h2>
        <p style={p}>If you believe your material was removed or disabled by mistake or misidentification, you may submit a written counter-notification to our Designated Agent that includes substantially all of the following, as required by 17 U.S.C. § 512(g)(3):</p>
        <ol style={{ paddingLeft: 20, margin: '0 0 16px' }}>
          <li style={li}>Your physical or electronic signature.</li>
          <li style={li}>Identification of the material removed and the location at which it appeared before removal.</li>
          <li style={li}>A statement under penalty of perjury that you have a good-faith belief the material was removed as a result of mistake or misidentification.</li>
          <li style={li}>Your name, address, and telephone number, and a statement that you consent to the jurisdiction of the Federal District Court for the judicial district in which your address is located (or, if outside the United States, any district in which we may be found), and that you will accept service of process from the person who provided the original notification.</li>
        </ol>
        <p style={p}>Upon receipt of a valid counter-notification, we may restore the material in not less than 10 and not more than 14 business days, unless our Designated Agent first receives notice that the complaining party has filed an action seeking a court order.</p>

        <h2 style={h2}>Repeat Infringer Policy</h2>
        <p style={p}>OAR Technologies Inc. has adopted a policy of terminating, in appropriate circumstances and at our sole discretion, the accounts of users determined to be repeat infringers. We may also limit access to or terminate the accounts of any users who infringe the intellectual property rights of others.</p>

        <h2 style={h2}>Modifications</h2>
        <p style={p}>We reserve the right to modify this policy at any time. Changes will be posted on this page with an updated effective date.</p>
        <p style={p}>This policy applies to all tiers of the Service, including the Clipper, Family, Creator, and Enterprise plans.</p>

        <div style={{ marginTop: 52, paddingTop: 24, borderTop: `1px solid ${C.primary}22`, color: 'rgba(255,255,255,0.2)', fontSize: 12 }}>
          © 2026 O.A.R. Technologies Inc. · <a href="/" style={{ color: 'rgba(255,255,255,0.2)', textDecoration: 'none' }}>sensorlogic.io</a>
        </div>
      </div>
    </div>
  );
}

// ── Terms Page ────────────────────────────────────────────────────────────────
function TermsPage() {
  const lk = { color: C.teal, textDecoration: 'none' };
  const h2s = { fontSize: 17, fontWeight: 800, color: C.primary, marginTop: 36, marginBottom: 10, letterSpacing: 0.3 };
  const h3s = { fontSize: 14, fontWeight: 700, color: 'rgba(255,255,255,0.75)', marginTop: 20, marginBottom: 6 };
  const ps = { color: 'rgba(255,255,255,0.68)', lineHeight: 1.85, marginBottom: 14, fontSize: 14.5 };
  const lis = { color: 'rgba(255,255,255,0.68)', lineHeight: 1.85, marginBottom: 6, fontSize: 14.5 };
  return (
    <div style={{ backgroundColor: C.bg, minHeight: '100vh', fontFamily: "'Montserrat', sans-serif", color: 'white' }}>
      <div style={{ borderBottom: `1px solid ${C.primary}22`, padding: '0 24px', height: 60, display: 'flex', alignItems: 'center' }}>
        <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
          <WaveLogo compact size={28} />
          <span style={{ fontSize: 18, fontWeight: 900, letterSpacing: 2, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>SENSOR</span>
        </a>
      </div>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '52px 24px 80px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 900, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: 6 }}>Terms of Service</h1>
        <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13, marginBottom: 16 }}>Last updated: June 22, 2026</div>
        <p style={ps}>These Terms of Service ("Terms") are a binding agreement between you ("you," "your," or "User") and OAR Technologies Inc., a Virginia corporation doing business as "Sensor Logic" ("Sensor Logic," "we," "us," or "our"), governing your access to and use of the website sensorlogic.io, the SENSOR application, and all related services (collectively, the "Service").</p>
        <p style={ps}>By creating an account, subscribing to a plan, or otherwise accessing or using the Service, you agree to be bound by these Terms. If you do not agree, do not use the Service.</p>
        <p style={{ ...ps, fontWeight: 700, color: 'rgba(255,255,255,0.85)' }}>PLEASE READ THESE TERMS CAREFULLY. THEY INCLUDE A BINDING ARBITRATION PROVISION AND A CLASS ACTION WAIVER (SECTION 16) THAT AFFECT YOUR LEGAL RIGHTS.</p>

        <h2 style={h2s}>1. Description of the Service</h2>
        <p style={ps}>Sensor Logic provides software that allows users to upload audio and video content, automatically detect profanity and other flagged words, and produce filtered ("censored") versions of that content through muting or bleeping. Depending on the subscription tier, the Service may allow exporting filtered files, private in-application playback of filtered content, transcription, and related post-production features.</p>
        <p style={ps}>The Service is a tool for processing content that you own or are otherwise authorized to use. It is not a content library, distribution platform, or streaming service.</p>

        <h2 style={h2s}>1A. Intended Use and Prohibited Conduct</h2>
        <p style={ps}>The Service is intended solely as an editing and censoring tool that allows users to filter profanity in content they own or are authorized to use, and to produce filtered versions of that content for their own lawful purposes — such as creators preparing clean or sponsor-safe versions of their own work, or individuals filtering content they own for private personal viewing.</p>
        <p style={ps}>The Service is <strong style={{ color: 'rgba(255,255,255,0.85)' }}>not</strong> intended for, and may <strong style={{ color: 'rgba(255,255,255,0.85)' }}>not</strong> be used for, the redistribution, piracy, unauthorized copying, or unauthorized distribution of any copyrighted or third-party content. OAR Technologies Inc. does not condone, approve, encourage, or authorize any such conduct. The design and intended nature of the Service is to facilitate lawful filtering of content the user is entitled to use — not to enable or facilitate infringement.</p>
        <p style={ps}>We reserve the right, at our sole discretion, to investigate, remove content, and suspend or terminate the account of any user whose activity appears to fall outside the intended nature and lawful purpose of the Service, including any activity that appears to involve redistribution, piracy, circumvention of tier restrictions, or the unauthorized use of content the user does not own. We may take such action with or without prior notice and without any obligation to provide a reason.</p>

        <h2 style={h2s}>2. Eligibility and Accounts</h2>
        <p style={ps}>You must be at least 18 years old, or the age of majority in your jurisdiction, to use the Service. By using the Service you represent that you meet this requirement.</p>
        <p style={ps}>You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. You agree to provide accurate and complete information when creating your account and to keep it current. You may not share your account or allow others to use it except as expressly permitted by your subscription tier.</p>

        <h2 style={h2s}>3. Content Ownership and User Warranties</h2>
        <p style={ps}>You retain all ownership rights in the content you upload to the Service ("User Content"). We do not claim ownership of your User Content.</p>
        <p style={{ ...ps, fontWeight: 600, color: 'rgba(255,255,255,0.82)' }}>By uploading, processing, storing, or exporting any User Content, you represent and warrant that:</p>
        <p style={ps}>(a) you own the User Content or have obtained all rights, licenses, consents, and permissions necessary to use it with the Service;</p>
        <p style={ps}>(b) your upload, processing, storage, filtering, export, playback, and any subsequent use or distribution of the User Content does not and will not infringe, misappropriate, or violate the intellectual property rights, privacy rights, publicity rights, or any other rights of any third party, and does not violate any applicable law; and</p>
        <p style={ps}>(c) you will not use the Service to process or distribute any content that you do not own or are not authorized to use.</p>
        <p style={ps}>You are solely responsible for your User Content and for ensuring you have the rights described above. Sensor Logic does not pre-screen User Content and is not responsible for content uploaded by users.</p>

        <h2 style={h2s}>4. Subscription Tiers and License Grants</h2>
        <p style={ps}>Your rights to use the Service depend on your subscription tier. The tiers differ in material respects, including whether filtered content may be exported or downloaded.</p>
        <h3 style={h3s}>4.1 Clipper and Creator Tiers (Export-Enabled)</h3>
        <p style={ps}>The Clipper and Creator tiers are intended for creators producing filtered versions of content they own — such as podcasters, video creators, and other content producers preparing clean or sponsor-safe versions of their own material.</p>
        <p style={ps}>Subject to these Terms, we grant you a limited, non-exclusive, non-transferable license to upload your own content, process it through the Service, and export or download the resulting filtered files for your own lawful purposes.</p>
        <p style={ps}>Because these tiers allow export, you are solely responsible under the warranties in Section 3 for ensuring you hold all rights to any content you upload and export. Exporting a filtered file does not grant you any rights in the underlying content that you did not already possess.</p>
        <h3 style={h3s}>4.2 Family Tier (View-Only)</h3>
        <p style={ps}>The Family tier is intended for private, in-home watching and listening — for example, filtering language in movies or home videos for personal family viewing.</p>
        <p style={ps}>Subject to these Terms, we grant you a limited, non-exclusive, non-transferable license to upload content you own and view the filtered version privately within the Service.</p>
        <p style={{ ...ps, fontWeight: 600, color: 'rgba(255,255,255,0.82)' }}>The Family tier is view-only. It does not permit downloading, exporting, or redistribution of any content or filtered output. You may not use the Family tier to copy, distribute, publicly perform, publicly display, or otherwise share any content or filtered output outside of private personal viewing within the Service.</p>
        <p style={ps}>The Family tier includes up to 20 hours of in-app watching and listening per billing period. Usage is metered; when the limit is reached, in-app viewing is paused for the remainder of the period unless you upgrade or add hours. No automatic overage charges are applied. Your hours reset at the start of each new billing period.</p>
        <p style={ps}>Family tier content is stored on a per-user basis, is not shared with or accessible to other users, and is retained only to support your private viewing. Uploaded Family content is automatically deleted 90 days after it was last played, after which it may be re-uploaded if you wish to view it again. We may notify you before deletion.</p>
        <h3 style={h3s}>4.3 Enterprise Tier</h3>
        <p style={ps}>Enterprise tier terms, including processing volume, multiple-show access, and other features, are governed by these Terms together with any separate written agreement between you and Sensor Logic.</p>

        <h2 style={h2s}>5. Acceptable Use</h2>
        <p style={ps}>You agree not to:</p>
        <ol style={{ paddingLeft: 20, margin: '0 0 14px' }}>
          {[
            'upload, process, or distribute content you do not own or are not authorized to use;',
            'use the Service to infringe or facilitate infringement of any third party\'s intellectual property or other rights;',
            'attempt to circumvent, disable, or interfere with any technical limitation of your subscription tier, including any restriction on downloading or exporting;',
            'reverse engineer, decompile, or attempt to extract the source code of the Service, except to the extent permitted by law;',
            'use the Service to violate any applicable law or regulation;',
            'resell, sublicense, or commercially exploit the Service except as expressly permitted; or',
            'interfere with or disrupt the integrity or performance of the Service.',
          ].map((item, i) => <li key={i} style={lis}>{item}</li>)}
        </ol>
        <p style={ps}>Violation of this Section may result in suspension or termination of your account.</p>

        <h2 style={h2s}>6. Subscriptions, Billing, and Cancellation</h2>
        <p style={ps}>Paid subscriptions are billed in advance on a recurring monthly basis through our third-party payment processor, Stripe. By subscribing, you authorize us and Stripe to charge your payment method on a recurring basis until you cancel.</p>
        <p style={ps}>Subscription fees are as displayed at the time of purchase and are subject to change with notice. Processing-time allowances reset monthly and do not roll over.</p>
        <p style={ps}>You may cancel at any time through the customer billing portal. Cancellation takes effect at the end of your current billing period. Except where required by law, fees already paid are non-refundable.</p>

        <h2 style={h2s}>7. DMCA and Copyright</h2>
        <p style={ps}>We respond to notices of claimed copyright infringement in accordance with the Digital Millennium Copyright Act. Our DMCA Copyright Policy, including the contact information for our registered Designated Agent and our repeat-infringer policy, is available at <a href="/dmca" style={lk}>sensorlogic.io/dmca</a> and is incorporated into these Terms by reference.</p>
        <p style={ps}>We reserve the right to remove content and to suspend or terminate accounts of users who infringe, or repeatedly infringe, the intellectual property rights of others.</p>

        <h2 style={h2s}>8. Indemnification</h2>
        <p style={ps}>You agree to indemnify, defend, and hold harmless OAR Technologies Inc., its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of or in any way connected with: (a) your User Content; (b) your use of the Service; (c) your violation of these Terms; (d) your violation of any rights of a third party, including any intellectual property right; or (e) your breach of any representation or warranty in Section 3.</p>
        <p style={ps}>This indemnification obligation survives termination of these Terms and your use of the Service.</p>

        <h2 style={h2s}>9. Intellectual Property of the Service</h2>
        <p style={ps}>The Service, including all software, design, text, graphics, logos, and the "Sensor Logic" and "SENSOR" names and marks, is owned by OAR Technologies Inc. and is protected by intellectual property laws. Except for the limited license to use the Service granted in these Terms, nothing grants you any right, title, or interest in the Service.</p>

        <h2 style={h2s}>10. Privacy</h2>
        <p style={ps}>Your use of the Service is also governed by our Privacy Policy, available at <a href="/privacy" style={lk}>sensorlogic.io/privacy</a>, which is incorporated into these Terms by reference.</p>

        <h2 style={h2s}>11. Disclaimers</h2>
        <p style={{ ...ps, fontWeight: 600, color: 'rgba(255,255,255,0.82)' }}>THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING WITHOUT LIMITATION IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.</p>
        <p style={ps}>We do not warrant that the Service will be uninterrupted, error-free, or secure, or that profanity detection or filtering will be complete, accurate, or suitable for any particular purpose. You are responsible for reviewing filtered output before relying on or distributing it.</p>

        <h2 style={h2s}>12. Limitation of Liability</h2>
        <p style={{ ...ps, fontWeight: 600, color: 'rgba(255,255,255,0.82)' }}>TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL OAR TECHNOLOGIES INC. BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL, ARISING OUT OF OR RELATED TO YOUR USE OF OR INABILITY TO USE THE SERVICE.</p>
        <p style={{ ...ps, fontWeight: 600, color: 'rgba(255,255,255,0.82)' }}>TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR TOTAL AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THESE TERMS OR THE SERVICE WILL NOT EXCEED THE GREATER OF (A) THE AMOUNT YOU PAID US IN THE TWELVE MONTHS PRECEDING THE EVENT GIVING RISE TO THE LIABILITY, OR (B) ONE HUNDRED U.S. DOLLARS ($100).</p>

        <h2 style={h2s}>13. Termination</h2>
        <p style={ps}>You may stop using the Service and cancel your subscription at any time. We may suspend or terminate your access to the Service at any time, with or without cause, including for violation of these Terms. Upon termination, your license to use the Service ends and we may delete your User Content. Sections that by their nature should survive termination — including Sections 3, 8, 9, 11, 12, 14, 15, and 16 — will survive.</p>

        <h2 style={h2s}>14. Changes to These Terms</h2>
        <p style={ps}>We may modify these Terms from time to time. If we make material changes, we will post the updated Terms on this page with a new effective date and, where appropriate, provide additional notice. Your continued use of the Service after changes take effect constitutes acceptance of the revised Terms.</p>

        <h2 style={h2s}>15. Governing Law</h2>
        <p style={ps}>These Terms are governed by and construed in accordance with the laws of the Commonwealth of Virginia, without regard to its conflict-of-laws principles. Subject to the arbitration provision in Section 16, you agree that any dispute not subject to arbitration will be brought exclusively in the state or federal courts located in Virginia, and you consent to the personal jurisdiction of those courts.</p>

        <h2 style={h2s}>16. Binding Arbitration and Class Action Waiver</h2>
        <p style={{ ...ps, fontWeight: 700, color: 'rgba(255,255,255,0.85)' }}>PLEASE READ THIS SECTION CAREFULLY. IT AFFECTS YOUR LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT.</p>
        <p style={ps}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Agreement to Arbitrate.</strong> You and OAR Technologies Inc. agree that any dispute, claim, or controversy arising out of or relating to these Terms or the Service ("Dispute") will be resolved by binding individual arbitration, rather than in court, except that either party may bring an individual claim in small claims court if it qualifies.</p>
        <p style={ps}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Arbitration Procedures.</strong> The arbitration will be administered by a recognized arbitration provider under its applicable rules, and may be conducted in Virginia or, where permitted, remotely. The arbitrator has exclusive authority to resolve any Dispute, including the scope and enforceability of this arbitration provision.</p>
        <p style={{ ...ps, fontWeight: 600, color: 'rgba(255,255,255,0.82)' }}>Class Action Waiver. YOU AND OAR TECHNOLOGIES INC. AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN AN INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS, COLLECTIVE, OR REPRESENTATIVE PROCEEDING. The arbitrator may not consolidate more than one person's claims or preside over any form of class or representative proceeding.</p>
        <p style={ps}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Opt-Out.</strong> You may opt out of this arbitration provision by sending written notice to <a href="mailto:omar@sensorlogic.io" style={lk}>omar@sensorlogic.io</a> within 30 days of first accepting these Terms. If you opt out, the governing-law and venue provisions in Section 15 will apply to any Dispute.</p>

        <h2 style={h2s}>17. Miscellaneous</h2>
        <p style={ps}>These Terms, together with the DMCA Copyright Policy and Privacy Policy, constitute the entire agreement between you and OAR Technologies Inc. regarding the Service. If any provision is found unenforceable, the remaining provisions will remain in effect. Our failure to enforce any provision is not a waiver of it. You may not assign these Terms without our consent; we may assign them freely. Nothing in these Terms creates any agency, partnership, or joint venture between you and us.</p>

        <h2 style={h2s}>18. Contact</h2>
        <p style={ps}>Questions about these Terms may be sent to:</p>
        <p style={ps}>OAR Technologies Inc. (Sensor Logic)<br /><a href="mailto:support@sensorlogic.io" style={lk}>support@sensorlogic.io</a></p>

        <div style={{ marginTop: 52, paddingTop: 24, borderTop: `1px solid ${C.primary}22`, color: 'rgba(255,255,255,0.2)', fontSize: 12, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <span>© 2026 O.A.R. Technologies Inc.</span>
          <a href="/dmca" style={{ color: 'rgba(255,255,255,0.2)', textDecoration: 'none' }}>Copyright / DMCA</a>
          <a href="/" style={{ color: 'rgba(255,255,255,0.2)', textDecoration: 'none' }}>sensorlogic.io</a>
        </div>
      </div>
    </div>
  );
}

// ── Privacy Page ──────────────────────────────────────────────────────────────
function PrivacyPage() {
  const lk = { color: C.teal, textDecoration: 'none' };
  const h2s = { fontSize: 17, fontWeight: 800, color: C.primary, marginTop: 36, marginBottom: 10, letterSpacing: 0.3 };
  const ps = { color: 'rgba(255,255,255,0.68)', lineHeight: 1.85, marginBottom: 14, fontSize: 14.5 };
  const lis = { color: 'rgba(255,255,255,0.68)', lineHeight: 1.85, marginBottom: 6, fontSize: 14.5 };
  return (
    <div style={{ backgroundColor: C.bg, minHeight: '100vh', fontFamily: "'Montserrat', sans-serif", color: 'white' }}>
      <div style={{ borderBottom: `1px solid ${C.primary}22`, padding: '0 24px', height: 60, display: 'flex', alignItems: 'center' }}>
        <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
          <WaveLogo compact size={28} />
          <span style={{ fontSize: 18, fontWeight: 900, letterSpacing: 2, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>SENSOR</span>
        </a>
      </div>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '52px 24px 80px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 900, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: 6 }}>Privacy Policy</h1>
        <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13, marginBottom: 36 }}>Last updated: June 22, 2026</div>

        <p style={ps}>This Privacy Policy explains how OAR Technologies Inc., doing business as "Sensor Logic" ("Sensor Logic," "we," "us," or "our"), collects, uses, and protects your information when you use the website sensorlogic.io, the SENSOR application, and related services (collectively, the "Service").</p>
        <p style={ps}>By using the Service, you agree to the collection and use of information in accordance with this Policy. This Policy is incorporated into and subject to our <a href="/terms" style={lk}>Terms of Service</a>.</p>

        <h2 style={h2s}>1. Information We Collect</h2>
        <p style={ps}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Account information.</strong> When you create an account, we collect your name, email address, and a password. Authentication is handled through Google Firebase Authentication.</p>
        <p style={ps}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Payment information.</strong> When you subscribe to a paid plan, payment is processed by our third-party payment processor, Stripe. We do not collect or store your full card number or other complete payment-card details on our servers. We receive limited billing-related information from Stripe, such as your subscription status and a customer identifier, to manage your account.</p>
        <p style={ps}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Content you upload.</strong> When you use the Service, you upload audio and video files ("User Content"). This content, along with derived data such as transcripts, detected word timestamps, chapter markers, and related metadata, is stored to provide the Service to you. User Content is stored using Google Firebase Storage and associated data in Google Firestore.</p>
        <p style={ps}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Usage and device information.</strong> We collect limited information about how you access the Service, which may include your device or browser information (such as your user-agent string), account creation time, and basic activity related to your use of the Service. We use this to operate, secure, and improve the Service, and to understand sign-up and usage patterns.</p>

        <h2 style={h2s}>2. How We Use Your Information</h2>
        <p style={ps}>We use the information we collect to:</p>
        <ul style={{ paddingLeft: 20, margin: '0 0 16px' }}>
          {[
            'provide, operate, and maintain the Service;',
            'create and manage your account and authenticate you;',
            'process your subscription and payments through Stripe;',
            'transcribe, analyze, and filter the content you upload;',
            'store your content and settings so they are available to you;',
            'communicate with you about your account, including service-related and transactional messages;',
            'monitor and improve the Service and develop new features; and',
            'detect, prevent, and address security issues, fraud, or violations of our Terms of Service.',
          ].map((item, i) => <li key={i} style={lis}>{item}</li>)}
        </ul>

        <h2 style={h2s}>3. Third-Party Service Providers</h2>
        <p style={ps}>We rely on trusted third-party providers to deliver the Service. These providers process information on our behalf and are subject to their own privacy and security practices:</p>
        <ul style={{ paddingLeft: 20, margin: '0 0 16px' }}>
          <li style={lis}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Google Firebase</strong> (Authentication, Firestore, Storage) — account authentication, database, and file storage.</li>
          <li style={lis}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>Stripe</strong> — payment processing and subscription billing. Stripe's handling of your payment information is governed by Stripe's own privacy policy.</li>
          <li style={lis}><strong style={{ color: 'rgba(255,255,255,0.85)' }}>AssemblyAI</strong> — automated transcription and speech analysis of the audio you submit for processing.</li>
        </ul>
        <p style={ps}>When you run analysis on your content, the audio is transmitted to AssemblyAI for transcription. We share only what is necessary to perform the requested processing.</p>
        <p style={ps}>We do not sell your personal information.</p>

        <h2 style={h2s}>4. Your Content and How It Is Handled</h2>
        <p style={ps}>Your User Content is used to provide the Service to you — for example, to transcribe audio, detect flagged words, and produce filtered output. We do not use your User Content to train our own models, and we do not share it with third parties except the service providers listed above that are necessary to perform the processing you request.</p>
        <p style={ps}>You may delete your User Content from within the Service. Deleting content removes it from your account; residual copies may persist temporarily in backups or provider systems before being overwritten in the ordinary course.</p>

        <h2 style={h2s}>5. Data Retention</h2>
        <p style={ps}>We retain your account information for as long as your account is active. We retain User Content as long as it remains in your account, subject to any tier-specific retention rules described in our Terms of Service (for example, automatic deletion of certain content after a defined period). When you delete content or close your account, we take reasonable steps to delete the associated data, subject to the residual-copy limitations noted above and any retention required by law.</p>

        <h2 style={h2s}>6. Data Security</h2>
        <p style={ps}>We use reasonable technical and organizational measures, including the security infrastructure provided by Google Firebase and Stripe, to protect your information. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>

        <h2 style={h2s}>7. Your Rights and Choices</h2>
        <p style={ps}>Depending on your jurisdiction, you may have rights regarding your personal information, including the right to access, correct, or delete it. You can update your account information within the Service, delete your uploaded content, and cancel your subscription at any time. To make a privacy-related request, contact us at the address below. We will respond consistent with applicable law.</p>

        <h2 style={h2s}>8. Children's Privacy</h2>
        <p style={ps}>The Service is not directed to children under 18, and we do not knowingly collect personal information from anyone under 18. If you believe a minor has provided us personal information, contact us and we will take appropriate steps to delete it.</p>

        <h2 style={h2s}>9. International Users</h2>
        <p style={ps}>The Service is operated in the United States, and your information is processed and stored in the United States and in the locations used by our service providers. By using the Service, you understand that your information may be transferred to and processed in the United States.</p>

        <h2 style={h2s}>10. Changes to This Policy</h2>
        <p style={ps}>We may update this Privacy Policy from time to time. We will post the updated Policy on this page with a new effective date. Your continued use of the Service after changes take effect constitutes acceptance of the updated Policy.</p>

        <h2 style={h2s}>11. Contact Us</h2>
        <p style={ps}>If you have questions about this Privacy Policy or our data practices, contact us at:</p>
        <p style={ps}>OAR Technologies Inc. (Sensor Logic)<br /><a href="mailto:support@sensorlogic.io" style={lk}>support@sensorlogic.io</a></p>

        <div style={{ marginTop: 52, paddingTop: 24, borderTop: `1px solid ${C.primary}22`, color: 'rgba(255,255,255,0.2)', fontSize: 12, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <span>© 2026 O.A.R. Technologies Inc.</span>
          <a href="/terms" style={{ color: 'rgba(255,255,255,0.2)', textDecoration: 'none' }}>Terms of Service</a>
          <a href="/dmca" style={{ color: 'rgba(255,255,255,0.2)', textDecoration: 'none' }}>Copyright / DMCA</a>
          <a href="/" style={{ color: 'rgba(255,255,255,0.2)', textDecoration: 'none' }}>sensorlogic.io</a>
        </div>
      </div>
    </div>
  );
}

// ── Auth Screen ───────────────────────────────────────────────────────────────
function LandingPage({ onGetStarted, onSubscribe, paymentStatus }) {
  return (
    <div style={{ backgroundColor: C.bg, minHeight: '100vh', fontFamily: "'Montserrat', sans-serif", color: 'white', display: 'flex', flexDirection: 'column' }}>

      {/* Payment status banner */}
      {paymentStatus === 'success' && (
        <div style={{ background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, padding: '14px 24px', textAlign: 'center', fontWeight: 'bold', fontSize: 15 }}>
          Payment successful! Sign in below to access your plan.
        </div>
      )}
      {paymentStatus === 'cancelled' && (
        <div style={{ background: '#333', padding: '14px 24px', textAlign: 'center', color: 'rgba(255,255,255,0.6)', fontSize: 14 }}>
          Checkout cancelled — no charge was made.
        </div>
      )}

      {/* Nav */}
      <div style={{ padding: '20px 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: `1px solid ${C.primary}18` }}>
        <div onClick={() => window.location.href = '/'} style={{ cursor: 'pointer' }}>
          <div style={{ fontSize: 18, fontWeight: 800, letterSpacing: 0, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Sensor Logic</div>
        </div>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <button onClick={onGetStarted} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.45)', cursor: 'pointer', fontSize: 14 }}>Sign In</button>
          <button onClick={() => window.location.href = '/demo'} style={{ background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, border: 'none', borderRadius: 24, color: 'white', padding: '8px 22px', fontWeight: 'bold', fontSize: 14, cursor: 'pointer' }}>Get Started</button>
        </div>
      </div>

      {/* Hero */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '90px 24px 80px', textAlign: 'center' }}>
        <WaveLogo size={64} />
        <div style={{ height: 24 }} />
        <div style={{ fontSize: 'clamp(40px, 7vw, 88px)', fontWeight: 600, letterSpacing: 0, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', lineHeight: 1.4, marginBottom: 16 }}>Sensor Logic</div>
        <div style={{ fontSize: 'clamp(15px, 2vw, 22px)', color: 'rgba(255,255,255,0.55)', fontStyle: 'italic', marginBottom: 18, letterSpacing: 0.5 }}>"When it makes sense to censor"</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 52 }}>
          <div style={{ height: 1, width: 48, background: `linear-gradient(90deg, transparent, ${C.primary}66)` }} />
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', letterSpacing: 1 }}>by O.A.R. Technologies Inc.</div>
          <div style={{ height: 1, width: 48, background: `linear-gradient(90deg, ${C.teal}66, transparent)` }} />
        </div>
        <div style={{ fontSize: 'clamp(14px, 1.8vw, 18px)', color: 'rgba(255,255,255,0.38)', maxWidth: 540, lineHeight: 1.8, marginBottom: 52 }}>
          Profanity detection and censoring software for podcasters and creators.{' '}
          <span style={{ color: 'rgba(255,255,255,0.65)', fontWeight: 600 }}>Dirty file in. Clean file out.</span>{' '}
          No re-listening required.
        </div>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={() => window.location.href = '/demo'} style={{ background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, border: 'none', borderRadius: 32, color: 'white', padding: '16px 44px', fontWeight: 'bold', fontSize: 16, cursor: 'pointer', boxShadow: `0 0 48px ${C.primary}55` }}>
            Get Early Access
          </button>
          <a href="/demo" style={{ display: 'flex', alignItems: 'center', background: 'transparent', border: `1px solid ${C.primary}44`, borderRadius: 32, color: C.primary, padding: '16px 44px', fontWeight: 'bold', fontSize: 16, cursor: 'pointer', textDecoration: 'none' }}>
            See It Live
          </a>
        </div>
      </div>

      {/* Features */}
      <div style={{ padding: '80px 40px', backgroundColor: C.bgMid }}>
        <div style={{ textAlign: 'center', fontSize: 'clamp(20px, 3vw, 32px)', fontWeight: 800, marginBottom: 12 }}>Everything a creator needs.</div>
        <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.35)', fontSize: 14, marginBottom: 56 }}>Upload raw. Export broadcast-ready. Done.</div>
        <div style={{ display: 'flex', gap: 24, justifyContent: 'center', flexWrap: 'wrap', maxWidth: 1100, margin: '0 auto' }}>
          {[
            { icon: <IcoMic size={32} col={C.primary}/>, title: 'Upload Anything', body: 'Audio or video. MP3, MP4, WAV — drop it in and it gets to work immediately.' },
            { icon: <IcoCpu size={32} col={C.primary}/>, title: 'Auto-Detect Profanity', body: 'Every flagged curse word found and timestamped automatically. No manual scrubbing.' },
            { icon: <IcoDoc size={32} col={C.primary}/>, title: 'Full Transcript', body: 'Word-by-word transcript with speaker labels. Click any word to jump to that moment.' },
            { icon: <IcoVolumeX size={32} col={C.primary}/>, title: 'Live Censor Preview', body: 'Hear exactly what your audience will hear before you export. Mute or bleep in real time.' },
            { icon: <IcoUpload size={32} col={C.primary}/>, title: 'Export Clean', body: 'One click. Broadcast-ready MP3 or video with every flagged curse word removed.' },
            { icon: <IcoList size={32} col={C.primary}/>, title: 'Show Notes & Chapters', body: 'Show notes and YouTube chapter markers generated automatically — ready to copy and paste.' },
          ].map(f => (
            <div key={f.title} style={{ backgroundColor: C.bgLight, borderRadius: 16, padding: '28px 24px', width: 220, border: `1px solid ${C.primary}18`, flex: '1 1 180px', maxWidth: 260 }}>
              <div style={{ marginBottom: 14 }}>{f.icon}</div>
              <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 10, color: 'white' }}>{f.title}</div>
              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.7 }}>{f.body}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Pricing */}
      <div style={{ padding: '90px 24px', backgroundColor: C.bg, textAlign: 'center' }}>
        <div style={{ fontSize: 'clamp(20px, 3vw, 36px)', fontWeight: 900, marginBottom: 12 }}>Simple Pricing.</div>
        <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 15, marginBottom: 60 }}>Pick the plan that fits how you create.</div>
        <style>{`
          @media (max-width: 768px) {
            .pricing-row { flex-direction: column !important; align-items: stretch !important; }
            .pricing-card { flex: 1 1 auto !important; width: 100% !important; }
          }
        `}</style>
        <div style={{ maxWidth: 1050, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 24 }}>

          {/* Row 1 — Clipper, Family, Family Plus */}
          <div className="pricing-row" style={{ display: 'flex', gap: 24, justifyContent: 'center', alignItems: 'stretch' }}>

            {/* Clipper */}
            <div className="pricing-card" style={{ backgroundColor: C.bgMid, borderRadius: 20, padding: '40px 32px', flex: '0 0 300px', border: `1px solid ${C.primary}28`, textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 2, color: C.primary, marginBottom: 12, textTransform: 'uppercase' }}>Clipper</div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, marginBottom: 8 }}>
                <div style={{ fontSize: 52, fontWeight: 900, lineHeight: 1 }}>$4.99</div>
                <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.35)', marginBottom: 6 }}>/month</div>
              </div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, lineHeight: 1.7, marginBottom: 32 }}>For short-form creators who want professional-sounding clips without the manual work.</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 36 }}>
                {['Transcription', 'Auto profanity detection', 'Mute or bleep censoring', 'Clean MP3 & video export', '1.5 hrs of processing / month'].map(f => (
                  <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>
                    <span style={{ color: C.teal, fontWeight: 'bold' }}>✓</span> {f}
                  </div>
                ))}
              </div>
              <button onClick={() => onSubscribe('clipper')} style={{ width: '100%', padding: '14px', borderRadius: 12, border: `1px solid ${C.primary}66`, background: 'transparent', color: C.primary, fontWeight: 'bold', fontSize: 15, cursor: 'pointer', marginTop: 'auto' }}>Subscribe</button>
            </div>

            {/* Family */}
            <div className="pricing-card" style={{ backgroundColor: C.bgMid, borderRadius: 20, padding: '40px 32px', flex: '0 0 300px', border: `1px solid ${C.primary}44`, textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 2, color: C.primary, marginBottom: 12, textTransform: 'uppercase' }}>Family</div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, marginBottom: 8 }}>
                <div style={{ fontSize: 52, fontWeight: 900, lineHeight: 1 }}>$19.99</div>
                <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.35)', marginBottom: 6 }}>/month</div>
              </div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', marginBottom: 16 }}>For content you own. Personal in-home viewing only.</div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, lineHeight: 1.7, marginBottom: 32 }}>Filter language in movies and home videos you already own, for private in-home family viewing. Watch your filtered content directly on your dashboard.</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 36 }}>
                {['20 hours of watching & listening', 'Profanity detection', 'Mute or bleep censoring', 'Live censor preview on dashboard', 'Private in-home viewing only — no downloads, exports, or redistribution'].map(f => (
                  <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>
                    <span style={{ color: C.teal, fontWeight: 'bold' }}>✓</span> {f}
                  </div>
                ))}
              </div>
              <button onClick={() => onSubscribe('family')} style={{ width: '100%', padding: '14px', borderRadius: 12, border: `1px solid ${C.primary}66`, background: 'transparent', color: C.primary, fontWeight: 'bold', fontSize: 15, cursor: 'pointer', marginTop: 'auto' }}>Subscribe</button>
            </div>

            {/* Family Plus */}
            <div className="pricing-card" style={{ backgroundColor: C.bgMid, borderRadius: 20, padding: '40px 32px', flex: '0 0 300px', border: `1px solid ${C.primary}44`, textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 2, color: C.primary, marginBottom: 12, textTransform: 'uppercase' }}>Family Plus</div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, marginBottom: 8 }}>
                <div style={{ fontSize: 52, fontWeight: 900, lineHeight: 1 }}>$39.99</div>
                <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.35)', marginBottom: 6 }}>/month</div>
              </div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', marginBottom: 16 }}>For content you own. Personal in-home viewing only.</div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, lineHeight: 1.7, marginBottom: 32 }}>Everything in Family, with double the monthly hours for bigger households or heavier watchers.</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 36 }}>
                {['Everything in Family', '40 hours of watching & listening', 'Profanity detection', 'Mute or bleep censoring', 'Live censor preview on dashboard', 'Private in-home viewing only — no downloads, exports, or redistribution'].map(f => (
                  <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>
                    <span style={{ color: C.teal, fontWeight: 'bold' }}>✓</span> {f}
                  </div>
                ))}
              </div>
              <button onClick={() => onSubscribe('family_plus')} style={{ width: '100%', padding: '14px', borderRadius: 12, border: `1px solid ${C.primary}66`, background: 'transparent', color: C.primary, fontWeight: 'bold', fontSize: 15, cursor: 'pointer', marginTop: 'auto' }}>Subscribe</button>
            </div>

          </div>

          {/* Row 2 — Creator, Enterprise */}
          <div className="pricing-row" style={{ display: 'flex', gap: 24, justifyContent: 'center', alignItems: 'stretch' }}>

            {/* Creator */}
            <div className="pricing-card" style={{ backgroundColor: C.bgMid, borderRadius: 20, padding: '40px 32px', flex: '0 0 300px', border: `2px solid ${C.teal}88`, textAlign: 'left', position: 'relative', boxShadow: `0 0 48px ${C.teal}14`, display: 'flex', flexDirection: 'column' }}>
              <div style={{ position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, borderRadius: 20, padding: '4px 18px', fontSize: 11, fontWeight: 'bold', letterSpacing: 1, whiteSpace: 'nowrap' }}>MOST POPULAR</div>
              <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 2, color: C.teal, marginBottom: 12, textTransform: 'uppercase' }}>Creator</div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, marginBottom: 8 }}>
                <div style={{ fontSize: 52, fontWeight: 900, lineHeight: 1 }}>$300</div>
                <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.35)', marginBottom: 6 }}>/month</div>
              </div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, lineHeight: 1.7, marginBottom: 32 }}>The complete post-production tool for podcasters and long form content creators.</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 36 }}>
                {['Everything in Clipper', 'Full transcript with speaker labels', 'Interactive waveform viewer', 'Live censor preview before export', 'Show notes generator', 'YouTube chapter markers', 'Playback speed, loop & autoplay', 'Full media library', '3 hrs of processing / week (~12 hrs/month)'].map(f => (
                  <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>
                    <span style={{ color: C.teal, fontWeight: 'bold' }}>✓</span> {f}
                  </div>
                ))}
              </div>
              <button onClick={() => onSubscribe('creator')} style={{ width: '100%', padding: '14px', borderRadius: 12, border: 'none', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, color: 'white', fontWeight: 'bold', fontSize: 15, cursor: 'pointer', boxShadow: `0 0 24px ${C.teal}44`, marginTop: 'auto' }}>Subscribe</button>
            </div>

            {/* Enterprise */}
            <div className="pricing-card" style={{ backgroundColor: C.bgMid, borderRadius: 20, padding: '40px 32px', flex: '0 0 300px', border: `1px solid ${C.primary}66`, textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 2, color: C.primary, marginBottom: 12, textTransform: 'uppercase' }}>Enterprise</div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, marginBottom: 8 }}>
                <div style={{ fontSize: 52, fontWeight: 900, lineHeight: 1 }}>Custom</div>
              </div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, lineHeight: 1.7, marginBottom: 32 }}>Built for podcast networks and multi-show operations. Tailored pricing based on your volume.</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 36 }}>
                {['Everything in Creator', 'Multiple shows under one account', 'Custom processing hours', 'Shared custom word list across shows', 'Branded exports', 'Dedicated support', 'Early access to new features', 'Annual contract option'].map(f => (
                  <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>
                    <span style={{ color: C.teal, fontWeight: 'bold' }}>✓</span> {f}
                  </div>
                ))}
              </div>
              <a href="mailto:support@sensorlogic.io?subject=Enterprise Plan Inquiry" style={{ display: 'block', width: '100%', padding: '14px', borderRadius: 12, border: `1px solid ${C.primary}66`, background: 'transparent', color: C.primary, fontWeight: 'bold', fontSize: 15, cursor: 'pointer', textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box', marginTop: 'auto' }}>Contact Us</a>
            </div>

          </div>

        </div>
        <div style={{ marginTop: 28, color: 'rgba(255,255,255,0.18)', fontSize: 12 }}>Processing time resets monthly and does not roll over.</div>
      </div>

      {/* Contact Us */}
      <ContactSection />

      {/* Bottom CTA */}
      <div style={{ padding: '80px 24px', textAlign: 'center', backgroundColor: C.bgMid }}>
        <div style={{ fontSize: 'clamp(22px, 3.5vw, 42px)', fontWeight: 900, marginBottom: 16, lineHeight: 1.2 }}>Ready to clean up your content?</div>
        <div style={{ color: 'rgba(255,255,255,0.35)', marginBottom: 44, fontSize: 15 }}>Join creators who are already publishing cleaner, faster.</div>
        <button onClick={() => window.location.href = '/demo'} style={{ background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, border: 'none', borderRadius: 32, color: 'white', padding: '18px 52px', fontWeight: 'bold', fontSize: 17, cursor: 'pointer', boxShadow: `0 0 48px ${C.primary}44` }}>
          See It Live
        </button>
        <div style={{ marginTop: 72, color: 'rgba(255,255,255,0.12)', fontSize: 12, display: 'flex', alignItems: 'center', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
          <span>© 2026 O.A.R. Technologies Inc. · SENSOR</span>
          <a href="/terms" style={{ color: 'rgba(255,255,255,0.25)', textDecoration: 'none', fontSize: 12 }} onMouseEnter={e => e.target.style.color = C.primary} onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.25)'}>Terms of Service</a>
          <a href="/dmca" style={{ color: 'rgba(255,255,255,0.25)', textDecoration: 'none', fontSize: 12 }} onMouseEnter={e => e.target.style.color = C.primary} onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.25)'}>Copyright / DMCA</a>
        </div>
      </div>

    </div>
  );
}

function AuthCard({ children }) {
  return (
    <div style={{ ...S.app, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ backgroundColor: C.bgMid, borderRadius: 16, padding: 40, width: '100%', maxWidth: 400, border: `1px solid ${C.primary}33`, boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div onClick={() => window.location.href = '/'} style={{ fontSize: 26, fontWeight: 900, letterSpacing: 4, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', cursor: 'pointer' }}>SENSOR</div>
          <div style={{ color: C.primary + '66', fontSize: 10, fontStyle: 'italic', marginTop: 2 }}>by O.A.R. Technologies Inc.</div>
        </div>
        {children}
      </div>
    </div>
  );
}

function CreateAccountScreen({ plan, onSuccess, onSignIn, onBack }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const planInfo = PLANS[plan];

  const submit = async () => {
    if (!name.trim()) { setError('Please enter your name.'); return; }
    if (!email.trim()) { setError('Please enter your email.'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    setError(''); setLoading(true);
    try {
      const cred = await createUserWithEmailAndPassword(auth, email, password);
      await updateProfile(cred.user, { displayName: name.trim() });
      await setDoc(doc(db, 'users', cred.user.uid), { name: name.trim(), email, pendingPlan: plan || null, createdAt: new Date().toISOString(), signedUpAt: new Date().toISOString(), dropoffAlertSent: false, device: navigator.userAgent }, { merge: true });
      onSuccess();
    } catch (e) {
      setError(e.code === 'auth/email-already-in-use' ? 'An account with this email already exists. Sign in instead.' : e.message);
    }
    setLoading(false);
  };

  return (
    <AuthCard>
      {planInfo && (
        <div style={{ background: `${C.primary}18`, border: `1px solid ${C.primary}33`, borderRadius: 10, padding: '10px 14px', marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>Selected plan</div>
          <div style={{ fontSize: 13, fontWeight: 'bold', color: C.primary }}>{planInfo.name} · {planInfo.price}/mo</div>
        </div>
      )}
      <div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 20 }}>Create your account</div>
      {[['Name', 'text', name, setName], ['Email', 'email', email, setEmail], ['Password', 'password', password, setPassword]].map(([label, type, val, setter]) => (
        <div key={label} style={{ marginBottom: 14 }}>
          <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginBottom: 4 }}>{label}</div>
          <input style={{ ...S.input, width: '100%', boxSizing: 'border-box' }} type={type} value={val} onChange={e => setter(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()} placeholder={label === 'Name' ? 'First and last name' : ''} />
        </div>
      ))}
      {error && <div style={{ color: C.censor, fontSize: 12, marginBottom: 12 }}>{error}</div>}
      <button onClick={submit} disabled={loading} style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, color: 'white', fontWeight: 'bold', fontSize: 14, cursor: 'pointer', marginBottom: 10, marginTop: 4 }}>
        {loading ? 'Creating account...' : 'Create Account & Continue'}
      </button>
      <div style={{ textAlign: 'center', fontSize: 11, color: 'rgba(255,255,255,0.3)', marginBottom: 14, lineHeight: 1.6 }}>
        By creating an account, you agree to our{' '}
        <a href="/terms" style={{ color: C.primary, textDecoration: 'none' }}>Terms of Service</a>
        {' '}and{' '}
        <a href="/privacy" style={{ color: C.primary, textDecoration: 'none' }}>Privacy Policy</a>.
      </div>
      <div style={{ textAlign: 'center', fontSize: 12, color: 'rgba(255,255,255,0.35)' }}>
        Already have an account?{' '}
        <button onClick={onSignIn} style={{ background: 'none', border: 'none', color: C.primary, fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}>Sign in</button>
      </div>
      <div style={{ textAlign: 'center', marginTop: 8 }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.25)', fontSize: 11, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
      </div>
    </AuthCard>
  );
}

function PlanConfirmScreen({ plan, onConfirm, onBack }) {
  const [loading, setLoading] = useState(false);
  const planInfo = PLANS[plan];
  if (!planInfo) return null;

  const handleConfirm = async () => { setLoading(true); await onConfirm(); };

  return (
    <AuthCard>
      <div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 6 }}>Review your plan</div>
      <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', marginBottom: 24 }}>You'll be redirected to Stripe to complete payment.</div>
      <div style={{ background: `${C.primary}10`, border: `1px solid ${C.primary}33`, borderRadius: 12, padding: '20px 24px', marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <div style={{ fontSize: 16, fontWeight: 'bold' }}>{planInfo.name}</div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 22, fontWeight: 900, color: C.teal }}>{planInfo.price}</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>/ {planInfo.period}</div>
          </div>
        </div>
        <div style={{ height: 1, background: `${C.primary}22`, marginBottom: 14 }} />
        {planInfo.features.map(f => (
          <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'rgba(255,255,255,0.6)', marginBottom: 8 }}>
            <span style={{ color: C.teal, fontWeight: 'bold', fontSize: 10 }}>✓</span> {f}
          </div>
        ))}
      </div>
      <button onClick={handleConfirm} disabled={loading} style={{ width: '100%', padding: '13px', borderRadius: 8, border: 'none', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, color: 'white', fontWeight: 'bold', fontSize: 14, cursor: 'pointer', marginBottom: 12 }}>
        {loading ? 'Redirecting...' : `Continue to Payment →`}
      </button>
      <div style={{ textAlign: 'center', fontSize: 11, color: 'rgba(255,255,255,0.2)', marginBottom: 12 }}>Secured by Stripe · Cancel anytime</div>
      <div style={{ textAlign: 'center' }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.25)', fontSize: 11, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
      </div>
    </AuthCard>
  );
}

function PaywallScreen({ user, onChoosePlan, paymentStatus }) {
  return (
    <div style={{ ...S.app, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ backgroundColor: C.bgMid, borderRadius: 16, padding: 40, width: '100%', maxWidth: 480, border: `1px solid ${C.primary}33`, boxSizing: 'border-box', textAlign: 'center' }}>
        <div style={{ fontSize: 26, fontWeight: 900, letterSpacing: 4, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: 8 }}>SENSOR</div>
        {paymentStatus === 'cancelled' && <div style={{ background: '#333', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'rgba(255,255,255,0.5)', marginBottom: 20 }}>Checkout was cancelled — no charge was made.</div>}
        <div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8 }}>Choose a plan to get started</div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', marginBottom: 28 }}>Hi{user.displayName ? `, ${user.displayName.split(' ')[0]}` : ''}. Your account is ready — subscribe to unlock SENSOR.</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
          {Object.entries(PLANS).map(([key, p]) => (
            <button key={key} onClick={() => onChoosePlan(key)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', borderRadius: 10, border: key === 'creator' ? `1px solid ${C.teal}88` : `1px solid ${C.primary}33`, background: key === 'creator' ? `${C.teal}10` : `${C.primary}08`, color: 'white', cursor: 'pointer', fontFamily: 'inherit' }}>
              <div style={{ fontWeight: 'bold', fontSize: 14 }}>{p.name}</div>
              <div style={{ fontSize: 14, color: key === 'creator' ? C.teal : C.primary, fontWeight: 'bold' }}>{p.price}<span style={{ fontSize: 11, fontWeight: 'normal', color: 'rgba(255,255,255,0.4)' }}>/mo</span></div>
            </button>
          ))}
        </div>
        <button onClick={() => signOut(auth)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.2)', fontSize: 11, cursor: 'pointer', fontFamily: 'inherit' }}>Sign out</button>
      </div>
    </div>
  );
}

function SignInScreen({ onBack, onSubscribe }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const submit = async () => {
    setError(''); setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  const sendReset = async () => {
    if (!email) { setError('Enter your email above first.'); return; }
    setError(''); setLoading(true);
    try {
      const { sendPasswordResetEmail } = await import('firebase/auth');
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  return (
    <AuthCard>
      <div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 20 }}>Sign in</div>
      <div style={{ marginBottom: 14 }}>
        <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginBottom: 4 }}>Email</div>
        <input style={{ ...S.input, width: '100%', boxSizing: 'border-box' }} type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()} />
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginBottom: 4 }}>Password</div>
        <input style={{ ...S.input, width: '100%', boxSizing: 'border-box' }} type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()} />
      </div>
      {error && <div style={{ color: C.censor, fontSize: 12, marginBottom: 12 }}>{error}</div>}
      {resetSent && <div style={{ color: C.teal, fontSize: 12, marginBottom: 12 }}>Password reset email sent — check your inbox.</div>}
      <button onClick={submit} disabled={loading} style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, color: 'white', fontWeight: 'bold', fontSize: 14, cursor: 'pointer', marginBottom: 12 }}>
        {loading ? 'Signing in...' : 'Sign In'}
      </button>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <button onClick={sendReset} style={{ background: 'none', border: 'none', color: C.primary + '88', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}>Forgot password?</button>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.25)', fontSize: 11, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
      </div>
    </AuthCard>
  );
}

// ── Root ──────────────────────────────────────────────────────────────────────
const SEEK_BAR_CSS = `
  input[type=range].seekbar { -webkit-appearance: none; appearance: none; background: transparent; cursor: pointer; }
  input[type=range].seekbar::-webkit-slider-runnable-track { height: 4px; border-radius: 2px; background: rgba(255,255,255,0.15); }
  input[type=range].seekbar::-webkit-slider-thumb { -webkit-appearance: none; width: 12px; height: 12px; border-radius: 50%; background: #40A0DC; cursor: pointer; margin-top: -4px; box-shadow: 0 0 4px rgba(64,160,220,0.8); border: none; transition: transform 0.1s; }
  input[type=range].seekbar:hover::-webkit-slider-thumb { transform: scale(1.3); }
  input[type=range].seekbar::-moz-range-thumb { width: 12px; height: 12px; border-radius: 50%; background: #40A0DC; cursor: pointer; border: none; }
  input[type=range].seekbar::-moz-range-track { height: 4px; border-radius: 2px; background: rgba(255,255,255,0.15); }
  :fullscreen { width: 100vw !important; height: 100vh !important; }
  :-webkit-full-screen { width: 100vw !important; height: 100vh !important; }
  :fullscreen video { width: 100vw !important; height: 100vh !important; max-height: 100vh !important; object-fit: contain; }
  :-webkit-full-screen video { width: 100vw !important; height: 100vh !important; max-height: 100vh !important; object-fit: contain; }
  @keyframes sensorWaveBig {
    0%, 100% { transform: scaleY(0.2); opacity: 0.5; }
    50%       { transform: scaleY(1);   opacity: 1; }
  }
`;

export default function App() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [screen, setScreen] = useState('landing'); // landing | signin | create | confirm | paywall
  const [pendingPlan, setPendingPlan] = useState(null);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const isDemo = window.location.pathname === '/demo';

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = SEEK_BAR_CSS;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get('payment');
    if (payment) { setPaymentStatus(payment); window.history.replaceState({}, '', '/'); }
  }, []);

  useEffect(() => {
    return onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        const snap = await getDoc(doc(db, 'users', u.uid));
        setUserData(snap.exists() ? snap.data() : {});
      } else {
        setUserData(null);
      }
      setAuthLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!userData || !user) return;
    const now = new Date();
    const periodMs = 30 * 24 * 60 * 60 * 1000;
    const updates = {};
    const prevPlan = userData.lastKnownPlan;
    const currPlan = userData.plan;
    if (prevPlan !== undefined && prevPlan !== currPlan && PLAN_LIMITS[currPlan]?.canExport && currPlan !== 'family') {
      updates.processingSecondsUsed = 0;
      updates.usagePeriodStart = now.toISOString();
    }
    if (currPlan && currPlan !== prevPlan) updates.lastKnownPlan = currPlan;
    if (updates.usagePeriodStart === undefined) {
      const start = new Date(userData.usagePeriodStart || userData.signedUpAt || now.toISOString());
      let ps = new Date(start);
      while (now - ps >= periodMs) ps = new Date(ps.getTime() + periodMs);
      if (ps.getTime() !== start.getTime()) {
        updates.processingSecondsUsed = 0;
        updates.usagePeriodStart = ps.toISOString();
      }
    }
    // Rolling 30-day watch reset (Family plans only)
    if (isFamily(userData)) {
      const wStart = new Date(userData.watchPeriodStart || userData.signedUpAt || now.toISOString());
      let wp = new Date(wStart);
      while (now - wp >= periodMs) wp = new Date(wp.getTime() + periodMs);
      if (wp.getTime() !== wStart.getTime()) {
        updates.watchSecondsUsed = 0;
        updates.watchPeriodStart = wp.toISOString();
        updates.bonusHoursPurchasedThisCycle = 0;
      }
    }

    if (Object.keys(updates).length > 0) {
      updateDoc(doc(db, 'users', user.uid), updates).catch(() => {});
      setUserData(prev => ({ ...prev, ...updates }));
    }
  }, [userData?.plan, userData?.usagePeriodStart, userData?.lastKnownPlan, userData?.watchPeriodStart, user?.uid]);

  const startCheckout = async (plan) => {
    setCheckoutLoading(true);
    try {
      const createSession = httpsCallable(functions, 'createCheckoutSession');
      const result = await createSession({ plan });
      window.location.href = result.data.url;
    } catch (err) {
      console.error('Checkout error:', err);
      setCheckoutLoading(false);
    }
  };

  const handleSubscribe = (plan) => {
    setPendingPlan(plan);
    if (user) { setScreen('confirm'); }
    else { setScreen('create'); }
  };

  if (isDemo) return <DemoApp />;
  if (authLoading) return <div style={{ ...S.app, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>Loading...</div>;
  if (checkoutLoading) return <AnalyzingOverlay label="PAYMENT PROCESSING" sub="Redirecting to secure checkout…" />;
  if (window.location.pathname === '/dmca') return <DmcaPage />;
  if (window.location.pathname === '/terms') return <TermsPage />;
  if (window.location.pathname === '/privacy') return <PrivacyPage />;

  if (user) {
    if (!userData) return <div style={{ ...S.app, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>Loading...</div>;
    if (!userData.plan) {
      if (isAdmin(user)) {
        const adminData = { ...userData, plan: 'creator', planName: 'Creator' };
        updateDoc(doc(db, 'users', user.uid), { plan: 'creator', planName: 'Creator' }).catch(() => {});
        return <SensorApp user={user} userData={adminData} setUserData={setUserData} paymentStatus={paymentStatus} />;
      }
      if (screen === 'confirm' && pendingPlan) return <PlanConfirmScreen plan={pendingPlan} onConfirm={() => startCheckout(pendingPlan)} onBack={() => setScreen('paywall')} />;
      return <PaywallScreen user={user} onChoosePlan={(plan) => { setPendingPlan(plan); setScreen('confirm'); }} paymentStatus={paymentStatus} />;
    }
    return <SensorApp user={user} userData={userData} setUserData={setUserData} paymentStatus={paymentStatus} />;
  }

  if (screen === 'create') return <CreateAccountScreen plan={pendingPlan} onSuccess={() => setScreen('confirm')} onSignIn={() => setScreen('signin')} onBack={() => setScreen('landing')} />;
  if (screen === 'confirm') return <PlanConfirmScreen plan={pendingPlan} onConfirm={() => startCheckout(pendingPlan)} onBack={() => setScreen('create')} />;
  if (screen === 'signin') return <SignInScreen onBack={() => setScreen('landing')} onSubscribe={handleSubscribe} />;
  return <LandingPage onGetStarted={() => setScreen('signin')} onSubscribe={handleSubscribe} paymentStatus={paymentStatus} />;
}

// ── Demo App (investor view — no login required) ──────────────────────────────
const OWNER_UID = 'FY3w2EdfniezfVwZ5PARxkQ0kwd2';

function DemoApp() {
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = SEEK_BAR_CSS;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    getDocs(collection(db, 'demo', 'showcase', 'media')).then(snap => {
      const items = snap.docs.map(d => {
        const data = d.data();
        return {
          id: d.id, ...data,
          censorPoints: migrateCensorPoints(data.censorPoints),
          chapters: data.chapters || [],
          transcript: data.transcript || null,
          transcriptStoragePath: data.transcriptStoragePath || null,
        };
      });
      if (items.length === 0) { setError('No demo media found.'); }
      else { setMediaList(items); }
      setLoading(false);
    }).catch(() => { setError('Failed to load demo.'); setLoading(false); });
  }, []);

  if (loading) return (
    <div style={{ ...S.app, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
      <div onClick={() => window.location.href = '/'} style={{ fontSize: 24, fontWeight: 900, letterSpacing: 3, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', cursor: 'pointer' }}>SENSOR</div>
      <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14 }}>Loading demo...</div>
    </div>
  );

  if (error) return (
    <div style={{ ...S.app, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
      <div onClick={() => window.location.href = '/'} style={{ fontSize: 24, fontWeight: 900, letterSpacing: 3, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', cursor: 'pointer' }}>SENSOR</div>
      <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14 }}>{error}</div>
    </div>
  );

  return <SensorApp user={null} isDemo={true} demoMediaList={mediaList} />;
}

// ── Watch Meter (Family plans) ────────────────────────────────────────────────
function WatchMeter({ watchPct, watchHoursUsed, maxWatchHours, watchHoursLeft, watchResetDateStr, onUpgrade, onAddHours, canBuyBonus }) {
  const state = watchPct >= 100 ? 'cap' : watchPct >= 80 ? 'near' : 'ok';
  const barGradient = state === 'cap'
    ? 'linear-gradient(90deg, #E74C3C, #F59E0B)'
    : state === 'near'
    ? 'linear-gradient(90deg, #40A0DC, #2DD4BF 30%, #A8B645 60%, #F59E0B)'
    : 'linear-gradient(90deg, #40A0DC, #2DD4BF)';
  const borderColor = state === 'cap' ? '#E74C3C55' : state === 'near' ? '#F59E0B44' : '#40A0DC22';
  const icon = state === 'cap' ? '⏸' : state === 'near' ? '⏳' : '🎧';
  const title = state === 'cap' ? "That's a wrap for this month!" : state === 'near' ? 'Getting close' : 'Your watch & listen time';
  const titleColor = state === 'cap' ? '#E74C3C' : 'white';

  return (
    <div style={{ backgroundColor: '#111D28', borderRadius: 12, padding: '14px 16px', border: `1px solid ${borderColor}`, fontFamily: "'Montserrat', sans-serif" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, fontWeight: 700, fontSize: 13, color: titleColor }}>
          <span style={{ fontSize: 15 }}>{icon}</span> {title}
        </div>
        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>Resets {watchResetDateStr}</div>
      </div>
      <div style={{ height: 8, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 4, overflow: 'hidden', marginBottom: 10 }}>
        <div style={{ width: `${Math.min(100, watchPct)}%`, height: '100%', background: barGradient, borderRadius: 4, transition: 'width 0.5s ease' }} />
      </div>
      {state === 'cap' ? (
        <>
          <div style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.55)', lineHeight: 1.65, marginBottom: 14 }}>
            You've used all {maxWatchHours} hours — nice work! Want to keep watching now, or your hours refill free on{' '}
            <span style={{ color: '#2DD4BF', fontWeight: 700 }}>{watchResetDateStr}</span>.
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={canBuyBonus ? onAddHours : undefined} disabled={!canBuyBonus} style={{ flex: 1, padding: '11px', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg, #40A0DC, #2DD4BF)', color: 'white', fontWeight: 700, fontSize: 12, cursor: canBuyBonus ? 'pointer' : 'not-allowed', fontFamily: "'Montserrat', sans-serif", opacity: canBuyBonus ? 1 : 0.45 }}>
              {canBuyBonus ? 'Add 10 hours — $10' : 'Limit reached this cycle'}
            </button>
            <button onClick={onUpgrade} style={{ flex: 1, padding: '11px', borderRadius: 10, border: '1px solid #2DD4BF55', background: 'rgba(45,212,191,0.08)', color: '#2DD4BF', fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif" }}>
              Upgrade to Family Plus
            </button>
          </div>
        </>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'rgba(255,255,255,0.75)' }}>{watchHoursUsed} of {maxWatchHours} hours</div>
          {state === 'near'
            ? <div style={{ fontSize: 12, color: '#F59E0B', fontWeight: 600 }}>{watchHoursLeft} hour{watchHoursLeft !== 1 ? 's' : ''} left this month</div>
            : <div style={{ fontSize: 12, color: '#2DD4BF' }}>Plenty left — enjoy! 🎧</div>
          }
        </div>
      )}
    </div>
  );
}

// ── Sensor App ────────────────────────────────────────────────────────────────
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
const bufferOffset = isIOS ? 0.65 : 0.5;

function SensorApp({ user, userData, setUserData, isDemo = false, demoMediaList = [], paymentStatus }) {
  const [mediaList, setMediaList] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [censorOn, setCensorOn] = useState(isDemo);
  const [censorStyle, setCensorStyle] = useState('mute');
  const [scanPresets, setScanPresets] = useState({});
  const [pinnedId, setPinnedId] = useState(null);
  const [exportCensorMode, setExportCensorMode] = useState('mute');
  const [renamingId, setRenamingId] = useState(null);
  const [renameValue, setRenameValue] = useState('');
  const [toast, setToast] = useState(null);
  const [showWordPanel, setShowWordPanel] = useState(false);
  const [customWords, setCustomWords] = useState([]);
  const [wordInput, setWordInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('date');
  const [currentMedia, setCurrentMedia] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [loopOn, setLoopOn] = useState(false);
  const [autoPlayNext, setAutoPlayNext] = useState(false);
  const [censorWindow, setCensorWindow] = useState(0);
  const [analyzing, setAnalyzing] = useState(new Set());
  const [uploadProgress, setUploadProgress] = useState({});
  const [exportProgress, setExportProgress] = useState({});
  const [enhancing, setEnhancing] = useState({});
  const [waveforms, setWaveforms] = useState({});
  const [loadingWaveform, setLoadingWaveform] = useState(new Set());
  const [expandedTranscript, setExpandedTranscript] = useState(null); // mediaId
  const [showNotesCopied, setShowNotesCopied] = useState(null);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [mobileTab, setMobileTab] = useState('library');
  const [urlInput, setUrlInput] = useState('');
  const [urlImporting, setUrlImporting] = useState(false);
  const [transcriptMode, setTranscriptMode] = useState({});
  const [speakerMode, setSpeakerMode] = useState({});
  const [clips, setClips] = useState({});
  const [subtitleMedias, setSubtitleMedias] = useState(new Set());
  const [exportSubtitles, setExportSubtitles] = useState(false);
  const [transcriptLoading, setTranscriptLoading] = useState(new Set());
  const [selectedCensorIdxs, setSelectedCensorIdxs] = useState(new Set());
  const [lastClickedCensorIdx, setLastClickedCensorIdx] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);

  const audioRef = useRef(null);
  const videoRef = useRef(null);
  const pendingPlayRef = useRef(false);
  const bleepCtxRef = useRef(null);
  const bleepOscRef = useRef(null);
  const bleepGainRef = useRef(null);
  const rafRef = useRef(null);
  const censorTimeoutsRef = useRef([]);
  const fsContainerRef = useRef(null);
  const controlsTimerRef = useRef(null);
  const [showVideoControls, setShowVideoControls] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const isDraggingRef = useRef(false);
  const uploadTasksRef = useRef({});
  const exportAbortRef = useRef({});
  const watchAccRef = useRef(0);
  const lastWatchTimeRef = useRef(null);
  const userDataRef = useRef(userData); userDataRef.current = userData;

  const isUserFamily   = !isDemo && isFamily(userData) && !isAdmin(user);
  const showWatchMeter = !isDemo && isFamily(userData);
  const planWatchSecs  = PLAN_LIMITS[userData?.plan]?.maxWatchSeconds ?? Infinity;
  const bonusWatchSecs = userData?.bonusWatchSeconds ?? 0;
  const maxWatchSecs   = planWatchSecs === Infinity ? Infinity : planWatchSecs + bonusWatchSecs;
  const watchSecsUsed  = userData?.watchSecondsUsed ?? 0;
  const watchPct       = isUserFamily ? Math.min(100, (watchSecsUsed / maxWatchSecs) * 100) : 0;
  const watchHoursUsed = Math.floor(watchSecsUsed / 3600);
  const maxWatchHours  = maxWatchSecs === Infinity ? Infinity : Math.round(maxWatchSecs / 3600);
  const watchHoursLeft = Math.max(0, Math.ceil((maxWatchSecs - watchSecsUsed) / 3600));
  const watchResetDateStr = getWatchResetDate(userData);
  const watchGate = isUserFamily ? (watchPct >= 100 ? 'cap' : watchPct >= 80 ? 'near' : null) : null;
  const bonusPurchasesThisCycle = userData?.bonusHoursPurchasedThisCycle ?? 0;
  const canBuyBonus = bonusPurchasesThisCycle < 2;

  const exportGate = isDemo ? null :
    !canExport(user, userData) ? 'family' :
    !canProcess(user, userData) ? 'cap' : null;
  const processGate = isDemo ? null :
    !canProcess(user, userData) ? 'cap' : null;
  const resetDateStr = getResetDate(userData);

  const handleUpgrade = async () => {
    try {
      const createPortal = httpsCallable(functions, 'createPortalSession');
      const result = await createPortal({});
      window.location.href = result.data.url;
    } catch (e) { console.error(e); }
  };

  const handleAddHours = async () => {
    try {
      const createBonus = httpsCallable(functions, 'createBonusHoursSession');
      const result = await createBonus({});
      window.location.href = result.data.url;
    } catch (e) { console.error(e); }
  };

  const flushWatchTimeRef = useRef(null);
  flushWatchTimeRef.current = () => {
    if (watchAccRef.current <= 0 || !user || !isUserFamily) return;
    const toAdd = Math.round(watchAccRef.current);
    watchAccRef.current = 0;
    const ud = userDataRef.current;
    const newTotal = (ud?.watchSecondsUsed ?? 0) + toAdd;
    const planCap = PLAN_LIMITS[ud?.plan]?.maxWatchSeconds ?? Infinity;
    const bonusRemaining = ud?.bonusWatchSeconds ?? 0;
    const prevOverflow = Math.max(0, (ud?.watchSecondsUsed ?? 0) - planCap);
    const newOverflow = Math.max(0, newTotal - planCap);
    const bonusConsumed = Math.round(newOverflow - prevOverflow);
    const firestoreUpdate = { watchSecondsUsed: newTotal };
    if (bonusConsumed > 0 && bonusRemaining > 0) {
      firestoreUpdate.bonusWatchSeconds = Math.max(0, bonusRemaining - bonusConsumed);
    }
    updateDoc(doc(db, 'users', user.uid), firestoreUpdate).catch(() => {});
    if (setUserData) setUserData(prev => ({
      ...prev,
      watchSecondsUsed: newTotal,
      ...(bonusConsumed > 0 && bonusRemaining > 0
        ? { bonusWatchSeconds: Math.max(0, bonusRemaining - bonusConsumed) }
        : {}),
    }));
  };

  const censorOnRef = useRef(censorOn); censorOnRef.current = censorOn;
  const censorStyleRef = useRef(censorStyle); censorStyleRef.current = censorStyle;
  const volumeRef = useRef(volume); volumeRef.current = volume;
  const censorWindowRef = useRef(censorWindow); censorWindowRef.current = censorWindow;
  const currentMediaRef = useRef(currentMedia); currentMediaRef.current = currentMedia;
  const mediaListRef = useRef(mediaList); mediaListRef.current = mediaList;

  useEffect(() => { loadUserData(); }, []);
  useEffect(() => {
    if (isDemo) return;
    getDocs(collection(db, 'demo', 'showcase', 'media')).then(snap => {
      if (!snap.empty) {
        const sourceId = snap.docs[0].data().sourceId;
        if (sourceId) setPinnedId(sourceId);
      }
    }).catch(() => {});
  }, []);
  useEffect(() => {
    if (!isUserFamily) return;
    const id = setInterval(() => flushWatchTimeRef.current?.(), 30000);
    return () => { clearInterval(id); flushWatchTimeRef.current?.(); };
  }, [isUserFamily, user?.uid]);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  useEffect(() => {
    if (!censorOn) { stopBleep(); const p = getPlayer(currentMedia); if (p) p.muted = false; }
  }, [censorOn]);
  useEffect(() => {
    if (currentMedia && !waveforms[currentMedia.id] && !loadingWaveform.has(currentMedia.id) && !isMobile && (currentMedia.duration || 0) < 1200) {
      generateWaveform(currentMedia);
    }
  }, [currentMedia?.id]);

  // Active word index — binary search for the last word whose start <= currentTime
  const activeWordIdx = useMemo(() => {
    const words = currentMedia?.transcript?.words;
    if (!words?.length) return -1;
    let lo = 0, hi = words.length - 1, result = -1;
    while (lo <= hi) {
      const mid = (lo + hi) >> 1;
      if (words[mid].start <= currentTime) { result = mid; lo = mid + 1; }
      else hi = mid - 1;
    }
    return result;
  }, [currentTime, currentMedia?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const el = document.getElementById('ts-active-word');
    if (el) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [activeWordIdx]);

  const clearCensorTimeouts = () => {
    censorTimeoutsRef.current.forEach(id => clearTimeout(id));
    censorTimeoutsRef.current = [];
  };

  // ── 60fps censor loop (requestAnimationFrame) ─────────────────────────────
  const startCensorLoop = () => {
    if (rafRef.current) return;
    const tick = () => {
      const media = currentMediaRef.current;
      const p = media ? (media.isVideo ? videoRef.current : audioRef.current) : null;
      if (!p || p.ended) { rafRef.current = null; return; }
      // Keep loop alive during pause/buffer — just skip the muting logic
      rafRef.current = requestAnimationFrame(tick);
      if (p.paused) return;
      const t = p.currentTime;
      if (censorOnRef.current) {
        const points = (mediaListRef.current.find(m => m.id === media.id) || media)?.censorPoints || [];
        const inCensor = points.some(pt => t >= pt.start - bufferOffset && t <= pt.end + 0.5 + censorWindowRef.current);
        p.muted = inCensor;
        if (censorStyleRef.current !== 'mute' && inCensor) startBleep();
        else if (!inCensor) stopBleep();
      } else {
        p.muted = false;
        stopBleep();
      }
    };
    rafRef.current = requestAnimationFrame(tick);
  };

  const stopCensorLoop = () => {
    if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = null; }
  };

  // ── Censor sound playback ──────────────────────────────────────────────────
  // AudioContext survives the session; gain + BufferSource are rebuilt every play
  // (BufferSource is single-use — reusing it after a file change gives a dead/silent source)
  const initBleepAudio = () => {
    if (!bleepCtxRef.current) {
      try {
        bleepCtxRef.current = new AudioContext();
      } catch (e) {
        console.log('bleep context error:', e);
        return;
      }
    }
    const ctx = bleepCtxRef.current;
    try { bleepOscRef.current?.stop(); } catch (e) {}
    try { bleepOscRef.current?.disconnect(); } catch (e) {}
    try { bleepGainRef.current?.disconnect(); } catch (e) {}
    bleepOscRef.current = null;
    bleepGainRef.current = null;
    try {
      const gain = ctx.createGain();
      gain.gain.value = 0;
      gain.connect(ctx.destination);
      const sr = ctx.sampleRate;
      const buf = ctx.createBuffer(1, Math.floor(sr * 0.5), sr);
      const d = buf.getChannelData(0);
      for (let i = 0; i < d.length; i++) d[i] = 0.25 * Math.sin(2 * Math.PI * 1000 * i / sr);
      const src = ctx.createBufferSource();
      src.buffer = buf;
      src.loop = true;
      src.connect(gain);
      src.start();
      bleepGainRef.current = gain;
      bleepOscRef.current = src;
    } catch (e) { console.log('bleep source error:', e); }
  };

  const startBleep = () => {
    if (censorStyleRef.current === 'mute') return;
    const ctx = bleepCtxRef.current;
    if (!ctx || ctx.state !== 'running') return;
    if (bleepGainRef.current) bleepGainRef.current.gain.value = 1;
  };

  const stopBleep = () => {
    if (bleepGainRef.current) bleepGainRef.current.gain.value = 0;
  };

  const loadUserData = async () => {
    if (isDemo) {
      setMediaList(demoMediaList);
      return;
    }
    try {
      const mediaSnap = await getDocs(collection(db, 'users', user.uid, 'media'));
      setMediaList(mediaSnap.docs.map(d => {
        const data = d.data();
        return {
          id: d.id, ...data,
          censorPoints: migrateCensorPoints(data.censorPoints),
          chapters: data.chapters || [],
          transcript: data.transcript || null,
          transcriptStoragePath: data.transcriptStoragePath || null,
        };
      }));
      const playlistSnap = await getDocs(collection(db, 'users', user.uid, 'playlists'));
      setPlaylists(playlistSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      const wordDoc = await getDoc(doc(db, 'users', user.uid, 'settings', 'customWords'));
      if (wordDoc.exists()) setCustomWords(wordDoc.data().words || []);
    } catch (e) { console.error('Load error:', e); }
  };

  const loadTranscriptIfNeeded = async (media) => {
    if (media.transcript) return media.transcript;
    if (!media.transcriptStoragePath) return null;
    if (transcriptLoading.has(media.id)) return null;
    setTranscriptLoading(prev => new Set([...prev, media.id]));
    try {
      const tRef = ref(storage, media.transcriptStoragePath);
      const url = await getDownloadURL(tRef);
      const res = await fetch(url);
      const t = await res.json();
      setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, transcript: t } : m));
      setCurrentMedia(prev => prev?.id === media.id ? { ...prev, transcript: t } : prev);
      return t;
    } catch (e) {
      console.error('Failed to load transcript:', e);
      return null;
    } finally {
      setTranscriptLoading(prev => { const n = new Set(prev); n.delete(media.id); return n; });
    }
  };

  const saveCustomWords = async (words) => {
    await setDoc(doc(db, 'users', user.uid, 'settings', 'customWords'), { words });
  };
  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(null), 4000);
  };

  const addCustomWord = (word) => {
    const w = word.trim().toLowerCase();
    if (!w || customWords.includes(w)) return;
    const updated = [...customWords, w];
    setCustomWords(updated); saveCustomWords(updated); setWordInput('');
    const alreadyAnalyzed = mediaList.some(m => m.transcript || (m.censorPoints && m.censorPoints.length > 0));
    if (alreadyAnalyzed) showToast('Word added. Re-run Profanity Detection on your files to apply it.');
  };
  const removeCustomWord = (word) => {
    const updated = customWords.filter(w => w !== word);
    setCustomWords(updated); saveCustomWords(updated);
  };

  // ── Upload ─────────────────────────────────────────────────────────────────
  const pickMedia = (videoOnly) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = videoOnly ? 'video/*' : 'audio/*,video/*';
    input.multiple = true;
    input.onchange = async (e) => { for (const file of e.target.files) await uploadMedia(file); };
    input.click();
  };

  const uploadMedia = async (file) => {
    const id = Date.now().toString();
    const VIDEO_EXTS = ['mp4','mov','mkv','avi','webm','wmv','m4v','flv','ts','mts'];
    const fileExt = file.name.split('.').pop().toLowerCase();
    const isVideo = file.type.startsWith('video/') || VIDEO_EXTS.includes(fileExt);
    const safeName = file.name.replace(/[^a-zA-Z0-9._\-\s]/g, '_');
    const storageRef = ref(storage, `users/${user.uid}/media/${id}_${safeName}`);
    const task = uploadBytesResumable(storageRef, file);
    uploadTasksRef.current[id] = task;
    task.on('state_changed',
      snap => setUploadProgress(p => ({ ...p, [id]: Math.round(snap.bytesTransferred / snap.totalBytes * 100) })),
      err => {
        delete uploadTasksRef.current[id];
        setUploadProgress(p => { const n = { ...p }; delete n[id]; return n; });
        if (err.code !== 'storage/canceled') { console.error(err); alert('Upload failed: ' + err.message); }
      },
      async () => {
        delete uploadTasksRef.current[id];
        const url = await getDownloadURL(task.snapshot.ref);
        const mediaDoc = { name: file.name, isVideo, url, storagePath: storageRef.fullPath, censorPoints: [], chapters: [], transcript: null, duration: 1, dateAdded: new Date().toISOString() };
        const docRef = await addDoc(collection(db, 'users', user.uid, 'media'), mediaDoc);
        setMediaList(prev => [...prev, { id: docRef.id, ...mediaDoc }]);
        setUploadProgress(p => { const n = { ...p }; delete n[id]; return n; });
      }
    );
  };

  // ── Import from URL via Cloud Run downloader ──────────────────────────────
  const importFromUrl = async () => {
    const url = urlInput.trim();
    if (!url) return;
    setUrlImporting(true);
    try {
      const res = await fetch('https://sensor-downloader-159407237683.us-central1.run.app/download', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || `Server error ${res.status}`);
      }
      const blob = await res.blob();
      const fileName = url.split('/').pop().split('?')[0] || 'imported_video.mp4';
      const file = new File([blob], fileName.endsWith('.mp4') ? fileName : fileName + '.mp4', { type: 'video/mp4' });
      setUrlInput('');
      await uploadMedia(file);
    } catch (e) {
      alert('Import failed: ' + e.message);
    }
    setUrlImporting(false);
  };

  // ── Waveform ───────────────────────────────────────────────────────────────
  const generateWaveform = async (media) => {
    setLoadingWaveform(prev => new Set([...prev, media.id]));
    try {
      const res = await fetch(media.url);
      const arrayBuffer = await res.arrayBuffer();
      const audioCtx = new AudioContext();
      const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);
      audioCtx.close();
      const data = audioBuffer.getChannelData(0);
      const samples = 300;
      const blockSize = Math.floor(data.length / samples);
      const wave = [];
      for (let i = 0; i < samples; i++) {
        let peak = 0;
        for (let j = 0; j < blockSize; j++) {
          const abs = Math.abs(data[i * blockSize + j] || 0);
          if (abs > peak) peak = abs;
        }
        wave.push(peak);
      }
      const max = Math.max(...wave, 0.001);
      setWaveforms(prev => ({ ...prev, [media.id]: wave.map(v => Math.pow(v / max, 0.6)) }));
    } catch (e) { console.log('Waveform failed:', e.message); }
    setLoadingWaveform(prev => { const n = new Set(prev); n.delete(media.id); return n; });
  };

  // ── Word matching ──────────────────────────────────────────────────────────
  const stem = (w) => w
    .replace(/ing$/, '').replace(/ings$/, '')
    .replace(/ed$/, '').replace(/er$/, '').replace(/ers$/, '')
    .replace(/tion$/, '').replace(/ly$/, '')
    .replace(/ies$/, 'y').replace(/ied$/, 'y')
    .replace(/s$/, '');

  const isWordFlagged = (word, preset = 'monetization') => {
    const w = word.toLowerCase().replace(/[^a-z']/g, '').replace(/'s$/, '').replace(/'$/, '');
    if (!w || w.length < 2) return false;
    const base = preset === 'clean' ? FULLY_CLEAN : MONETIZATION_SAFE;
    const all = [...base, ...customWords];
    if (all.includes(w)) return true;
    const ws = stem(w);
    if (ws && ws !== w && all.some(word => stem(word) === ws)) return true;
    return false;
  };

  // ── AI detect with speaker labels + transcript ─────────────────────────────
  // Runs server-side now (Cloud Function `aiDetect`) — the AssemblyAI key
  // never touches the client. See functions/index.js for the actual
  // transcription/word-matching logic (kept in exact parity with what used
  // to run here).
  const autoDetect = async (media) => {
    setAnalyzing(prev => new Set([...prev, media.id]));
    try {
      const runAiDetect = httpsCallable(functions, 'aiDetect');
      const { data: result } = await runAiDetect({
        mediaId: media.id,
        preset: scanPresets[media.id] || 'monetization',
        speakerMode: speakerMode[media.id] || 'multi',
      });

      const updated = result.censorPoints || [];
      setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, censorPoints: updated, transcript: null } : m));
      if (currentMedia?.id === media.id) setCurrentMedia(prev => ({ ...prev, censorPoints: updated, transcript: null }));

      if (result.flaggedCount > 0) {
        alert(`✅ Flagged ${result.flaggedCount} word${result.flaggedCount === 1 ? '' : 's'}!`);
      } else {
        alert('No new flagged words detected.');
      }
    } catch (e) { alert('Error: ' + (e.message || e)); }
    setAnalyzing(prev => { const n = new Set(prev); n.delete(media.id); return n; });
  };

  // ── Audio processing pipeline (shared) ────────────────────────────────────
  const processAudio = async (media, onStage, signal) => {
    onStage('Fetching audio...', 5);
    const res = await fetch(media.url, signal ? { signal } : {});
    if (!res.ok) throw new Error(`Fetch failed (HTTP ${res.status})`);
    const arrayBuffer = await res.arrayBuffer();

    onStage('Analyzing audio...', 15);
    const audioCtx = new AudioContext();
    const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);
    audioCtx.close();

    onStage('Reducing background noise...', 30);
    applyNoiseGate(audioBuffer);

    onStage('Equalizing voices...', 50);
    const offlineCtx = new OfflineAudioContext(
      audioBuffer.numberOfChannels, audioBuffer.length, audioBuffer.sampleRate
    );
    const source = offlineCtx.createBufferSource();
    source.buffer = audioBuffer;
    const hp = offlineCtx.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 80;
    const lowCut = offlineCtx.createBiquadFilter(); lowCut.type = 'lowshelf'; lowCut.frequency.value = 300; lowCut.gain.value = -3;
    const presence = offlineCtx.createBiquadFilter(); presence.type = 'peaking'; presence.frequency.value = 3000; presence.Q.value = 0.8; presence.gain.value = 4;
    const air = offlineCtx.createBiquadFilter(); air.type = 'highshelf'; air.frequency.value = 10000; air.gain.value = 2;
    source.connect(hp); hp.connect(lowCut); lowCut.connect(presence); presence.connect(air); air.connect(offlineCtx.destination);
    source.start(0);
    const processed = await offlineCtx.startRendering();

    onStage('Muting profanity...', 68);
    applyCensoring(processed, media.censorPoints || [], censorStyle);

    onStage('Normalizing loudness to -16 LUFS...', 80);
    normalizeLoudness(processed);

    onStage('Trimming silence...', 90);
    return trimSilence(processed);
  };

  // ── Enhance & Export WAV ───────────────────────────────────────────────────
  const enhanceAndExport = async (media) => {
    const controller = new AbortController();
    exportAbortRef.current[media.id] = controller;
    const setStage = (stage, pct) => setEnhancing(prev => ({ ...prev, [media.id]: { stage, pct } }));
    try {
      const trimmed = await processAudio(media, setStage, controller.signal);
      setStage('Encoding WAV...', 96);
      const wavBuffer = encodeWAV(trimmed);
      const blob = new Blob([wavBuffer], { type: 'audio/wav' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url;
      a.download = `${media.name.replace(/\.[^.]+$/, '')}_enhanced.wav`;
      a.click(); URL.revokeObjectURL(url);
      delete exportAbortRef.current[media.id];
      setStage('Done! ✅', 100);
      setTimeout(() => setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; }), 2500);
    } catch (e) {
      delete exportAbortRef.current[media.id];
      if (e.name === 'AbortError') { setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; }); return; }
      alert('Enhance failed: ' + e.message);
      setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; });
    }
  };

  // ── Export MP3 ─────────────────────────────────────────────────────────────
  const exportMP3 = async (media, opts = {}) => {
    const controller = new AbortController();
    exportAbortRef.current[media.id] = controller;
    const clip = opts.useClip ? clips[media.id] : null;
    const setStage = (stage, pct) => setEnhancing(prev => ({ ...prev, [media.id]: { stage, pct } }));
    try {
      setStage('Sending to server...', 5);
      const body = {
        video_url: media.url,
        censor_points: media.censorPoints || [],
        censor_window: censorWindow,
        censor_mode: exportCensorMode,
        filename: media.name.replace(/\.[^.]+$/, ''),
        is_video: false,
        output_format: 'mp3',
      };
      if (clip?.start != null) body.clip_start = clip.start;
      if (clip?.end != null) body.clip_end = clip.end;
      const response = await fetch('https://sensor-downloader-159407237683.us-central1.run.app/process-video', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: controller.signal,
      });
      if (!response.ok) { const err = await response.json().catch(() => ({})); throw new Error(err.detail || `Server error ${response.status}`); }
      setStage('Processing audio...', 70);
      const data = await response.json();
      setStage('Downloading...', 88);
      const a = document.createElement('a'); a.href = data.download_url; a.download = data.filename;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      delete exportAbortRef.current[media.id];
      setStage('Done! ✅', 100);
      if (user && data.processing_seconds) {
        const newSecs = (userData?.processingSecondsUsed || 0) + data.processing_seconds;
        updateDoc(doc(db, 'users', user.uid), { processingSecondsUsed: newSecs }).catch(() => {});
        if (setUserData) setUserData(prev => ({ ...prev, processingSecondsUsed: newSecs }));
      }
      setTimeout(() => setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; }), 2500);
    } catch (e) {
      delete exportAbortRef.current[media.id];
      if (e.name === 'AbortError') { setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; }); return; }
      alert('MP3 export failed: ' + e.message);
      setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; });
    }
  };

  // ── Export Video (server-side Cloud Run) ──────────────────────────────────
  const exportVideoFile = async (media, opts = {}) => {
    if (!media.isVideo) { exportMP3(media, opts); return; }
    const controller = new AbortController();
    exportAbortRef.current[media.id] = controller;
    const clip = opts.useClip ? clips[media.id] : null;
    const setStage = (stage, pct) => setEnhancing(prev => ({ ...prev, [media.id]: { stage, pct } }));
    try {
      setStage('Sending to server...', 5);
      const body = {
        video_url: media.url,
        censor_points: media.censorPoints || [],
        censor_window: censorWindow,
        censor_mode: exportCensorMode,
        filename: media.name.replace(/\.[^.]+$/, ''),
      };
      if (clip?.start != null) body.clip_start = clip.start;
      if (clip?.end != null) body.clip_end = clip.end;
      if (exportSubtitles) {
        const t = media.transcript || await loadTranscriptIfNeeded(media);
        if (t) body.subtitle_lines = generateSubtitleLines({ ...media, transcript: t });
      }
      const response = await fetch('https://sensor-downloader-159407237683.us-central1.run.app/process-video', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: controller.signal,
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.detail || `Server error ${response.status}`);
      }
      setStage('Uploading to storage...', 75);
      const data = await response.json();
      setStage('Downloading clean video...', 88);
      const a = document.createElement('a'); a.href = data.download_url; a.download = data.filename;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      delete exportAbortRef.current[media.id];
      setStage('Done! ✅', 100);
      if (user && data.processing_seconds) {
        const newSecs = (userData?.processingSecondsUsed || 0) + data.processing_seconds;
        updateDoc(doc(db, 'users', user.uid), { processingSecondsUsed: newSecs }).catch(() => {});
        if (setUserData) setUserData(prev => ({ ...prev, processingSecondsUsed: newSecs }));
      }
      setTimeout(() => setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; }), 2500);
    } catch (e) {
      delete exportAbortRef.current[media.id];
      if (e.name === 'AbortError') { setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; }); return; }
      alert('Video export failed: ' + e.message);
      setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; });
    }
  };

  // ── Simple Export (no EQ) ──────────────────────────────────────────────────
  const exportMedia = async (media) => {
    const controller = new AbortController();
    exportAbortRef.current[media.id] = controller;
    const setStage = (stage, pct) => setEnhancing(prev => ({ ...prev, [media.id]: { stage, pct } }));
    try {
      setStage('Sending to server...', 5);
      const response = await fetch('https://sensor-downloader-159407237683.us-central1.run.app/process-video', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          video_url: media.url,
          censor_points: media.censorPoints || [],
          censor_window: censorWindow,
          censor_mode: exportCensorMode,
          filename: media.name.replace(/\.[^.]+$/, ''),
          is_video: false,
          output_format: 'wav',
        }),
        signal: controller.signal,
      });
      if (!response.ok) { const err = await response.json().catch(() => ({})); throw new Error(err.detail || `Server error ${response.status}`); }
      setStage('Processing audio...', 70);
      const data = await response.json();
      setStage('Downloading...', 88);
      const a = document.createElement('a'); a.href = data.download_url; a.download = data.filename;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      delete exportAbortRef.current[media.id];
      setStage('Done! ✅', 100);
      if (user && data.processing_seconds) {
        const newSecs = (userData?.processingSecondsUsed || 0) + data.processing_seconds;
        updateDoc(doc(db, 'users', user.uid), { processingSecondsUsed: newSecs }).catch(() => {});
        if (setUserData) setUserData(prev => ({ ...prev, processingSecondsUsed: newSecs }));
      }
      setTimeout(() => setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; }), 2500);
    } catch (e) {
      delete exportAbortRef.current[media.id];
      if (e.name === 'AbortError') { setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; }); return; }
      alert('WAV export failed: ' + e.message);
      setEnhancing(prev => { const n = { ...prev }; delete n[media.id]; return n; });
    }
  };

  // ── Chapter markers ────────────────────────────────────────────────────────
  const addChapter = async (media) => {
    const t = currentMedia?.id === media.id ? currentTime : 0;
    const title = prompt(`Chapter title at ${fmtChapter(t)}:`);
    if (!title) return;
    const updated = [...(media.chapters || []), { time: t, title }].sort((a, b) => a.time - b.time);
    await updateDoc(doc(db, 'users', user.uid, 'media', media.id), { chapters: updated }).catch(() => {});
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, chapters: updated } : m));
    if (currentMedia?.id === media.id) setCurrentMedia(prev => ({ ...prev, chapters: updated }));
  };

  const removeChapter = async (media, idx) => {
    const updated = media.chapters.filter((_, i) => i !== idx);
    await updateDoc(doc(db, 'users', user.uid, 'media', media.id), { chapters: updated }).catch(() => {});
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, chapters: updated } : m));
    if (currentMedia?.id === media.id) setCurrentMedia(prev => ({ ...prev, chapters: updated }));
  };

  const copyChapters = (media) => {
    const text = (media.chapters || []).map(c => `${fmtChapter(c.time)} ${c.title}`).join('\n');
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      setShowNotesCopied(media.id + '_chapters');
      setTimeout(() => setShowNotesCopied(null), 2000);
    });
  };

  // ── Show notes ─────────────────────────────────────────────────────────────
  const copyShowNotes = async (media) => {
    const t = media.transcript || await loadTranscriptIfNeeded(media);
    const lines = [];
    lines.push(media.name.replace(/\.[^.]+$/, ''));
    lines.push('');
    if (media.chapters?.length) {
      lines.push('CHAPTERS');
      media.chapters.forEach(c => lines.push(`${fmtChapter(c.time)} ${c.title}`));
      lines.push('');
    }
    if (t?.utterances?.length) {
      lines.push('TRANSCRIPT');
      t.utterances.forEach(u => lines.push(`[${u.speaker || 'Speaker'}]: ${u.text}`));
    } else if (t?.text) {
      lines.push('TRANSCRIPT');
      lines.push(t.text);
    }
    navigator.clipboard.writeText(lines.join('\n')).then(() => {
      setShowNotesCopied(media.id + '_notes');
      setTimeout(() => setShowNotesCopied(null), 2000);
    });
  };

  const censorWordText = (text, mediaId) => {
    const preset = scanPresets[mediaId] || 'monetization';
    if (isWordFlagged(text, preset)) return '*'.repeat(text.replace(/[^a-zA-Z]/g, '').length || text.length);
    return text;
  };

  const generateSubtitleLines = (media) => {
    const t = media.transcript;
    if (!t?.words?.length) return [];
    const chunkSize = 8;
    const lines = [];
    for (let i = 0; i < t.words.length; i += chunkSize) {
      const chunk = t.words.slice(i, i + chunkSize);
      lines.push({ start: chunk[0].start, end: chunk[chunk.length - 1].end, text: chunk.map(w => censorWordText(w.text, media.id)).join(' ') });
    }
    return lines;
  };

  const getCurrentSubtitle = (media, time) => {
    const t = media.transcript;
    if (!t?.words?.length) return '';
    const chunkSize = 8;
    for (let i = 0; i < t.words.length; i += chunkSize) {
      const chunk = t.words.slice(i, i + chunkSize);
      if (time >= chunk[0].start - 0.2 && time <= chunk[chunk.length - 1].end + 0.4) {
        return chunk.map(w => censorWordText(w.text, media.id)).join(' ');
      }
    }
    return '';
  };

  const cleanWord = (text, mediaId) => {
    const preset = scanPresets[mediaId] || 'monetization';
    if (isWordFlagged(text, preset)) return '*'.repeat(text.replace(/[^a-zA-Z]/g, '').length || text.length);
    return text;
  };

  const downloadTranscript = async (media, mode) => {
    const t = media.transcript || await loadTranscriptIfNeeded(media);
    if (!t) return;
    const edited = (mode || transcriptMode[media.id] || 'unedited') === 'edited';
    const lines = [];
    lines.push(media.name.replace(/\.[^.]+$/, '') + (edited ? ' (Clean)' : ''));
    lines.push('');
    if (t.utterances?.length && t.words?.length) {
      t.utterances.forEach(u => {
        lines.push(`[${u.speaker || 'Speaker'}] (${fmt(u.start)})`);
        if (edited) {
          const utterWords = t.words.filter(w => w.start >= u.start && w.end <= u.end + 0.1);
          lines.push(utterWords.length ? utterWords.map(w => cleanWord(w.text, media.id)).join(' ') : u.text);
        } else {
          lines.push(u.text);
        }
        lines.push('');
      });
    } else if (t.words?.length && edited) {
      lines.push(t.words.map(w => cleanWord(w.text, media.id)).join(' '));
    } else {
      lines.push(t.text || '');
    }
    const blob = new Blob([lines.join('\n')], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${media.name.replace(/\.[^.]+$/, '')}_transcript${edited ? '_clean' : ''}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const openTranscriptInTab = async (media) => {
    const t = media.transcript || await loadTranscriptIfNeeded(media);
    if (!t) return;
    const lines = [];
    lines.push(`<h2>${media.name.replace(/\.[^.]+$/, '')}</h2>`);
    if (t.utterances?.length) {
      t.utterances.forEach(u => {
        lines.push(`<p><strong>[${u.speaker || 'Speaker'}]</strong> <em>${fmt(u.start)}</em><br/>${u.text}</p>`);
      });
    } else {
      lines.push(`<p>${t.text || ''}</p>`);
    }
    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Transcript</title><style>body{font-family:sans-serif;max-width:800px;margin:40px auto;padding:0 20px;line-height:1.6;color:#222;}h2{color:#111;}strong{color:#555;}em{font-size:0.85em;color:#888;}</style></head><body>${lines.join('')}</body></html>`;
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  // ── Playback ───────────────────────────────────────────────────────────────
  const safeAudioUrl = (url) => {
    if (!url) return url;
    const q = url.indexOf('?');
    const path = q >= 0 ? url.substring(0, q) : url;
    const query = q >= 0 ? url.substring(q) : '';
    return path.replace(/#/g, '%23') + query;
  };

  const getPlayer = (media) => {
    if (!media) return null;
    return media.isVideo ? videoRef.current : audioRef.current;
  };

  // Select media (load without playing) so seek bar works before first play
  const selectMedia = (media) => {
    if (currentMedia?.id === media.id) return;
    if (isMobile) setMobileTab('player');
    const prev = getPlayer(currentMedia);
    if (prev) { prev.pause(); prev.src = ''; }
    stopBleep(); stopCensorLoop();
    setIsPlaying(false); setCurrentTime(0);
    setCurrentMedia(media);
    // Load into player without playing
    setTimeout(() => {
      const p = media.isVideo ? videoRef.current : audioRef.current;
      if (!p) return;
      if (media.isVideo) { p.src = media.url; p.load(); }
      else { p.src = safeAudioUrl(media.url); p.load(); }
      p.playbackRate = playbackSpeed;
    }, 50);
  };

  const playPause = async (media) => {
    if (watchGate === 'cap') return;
    if (isMobile) setMobileTab('player');
    initBleepAudio();
    const _ctx = bleepCtxRef.current;
    if (_ctx?.state === 'suspended' || _ctx?.state === 'interrupted') await _ctx.resume();
    if (currentMedia?.id === media.id) {
      const p = getPlayer(media);
      if (!p) return;
      if (p.paused) { startCensorLoop(); p.play().then(() => { setIsPlaying(true); }).catch(() => {}); }
      else { p.pause(); setIsPlaying(false); stopCensorLoop(); stopBleep(); }
      return;
    }
    const prev = getPlayer(currentMedia);
    if (prev) { prev.pause(); prev.src = ''; }
    stopBleep();
    setIsPlaying(false); setCurrentTime(0);
    pendingPlayRef.current = true;
    setCurrentMedia(media);
  };

  useEffect(() => {
    if (!pendingPlayRef.current || !currentMedia) return;
    pendingPlayRef.current = false;
    const p = currentMedia.isVideo ? videoRef.current : audioRef.current;
    if (!p) return;
    if (currentMedia.isVideo) { p.src = currentMedia.url; p.load(); }
    else { p.src = safeAudioUrl(currentMedia.url); p.load(); }
    p.muted = true; p.playbackRate = playbackSpeed;
    startCensorLoop();
    p.play().then(() => {
      p.volume = volume; setIsPlaying(true);
    }).catch(e => console.log('Play interrupted:', e.message));
  }, [currentMedia]);

  const handlePause = () => {
    lastWatchTimeRef.current = null;
    setIsPlaying(false);
    flushWatchTimeRef.current?.();
  };

  const handleTimeUpdate = (media) => {
    const p = getPlayer(media);
    if (!p || currentMedia?.id !== media.id) return;
    const t = p.currentTime;
    if (!isDraggingRef.current) setCurrentTime(t);
    // Accumulate watch seconds for Family plans (ignore seeks via delta cap)
    if (isUserFamily && !p.paused && !isDraggingRef.current) {
      const prev = lastWatchTimeRef.current;
      if (prev !== null) {
        const delta = t - prev;
        if (delta > 0 && delta < 2) watchAccRef.current += delta;
      }
      lastWatchTimeRef.current = t;
    }
    startCensorLoop();
  };

  const handleEnded = () => {
    setIsPlaying(false);
    stopCensorLoop();
    stopBleep();
    if (loopOn) {
      const p = getPlayer(currentMedia);
      if (p) { p.currentTime = 0; p.play().catch(() => {}); setIsPlaying(true); }
    } else if (autoPlayNext) {
      const list = getList();
      const idx = list.findIndex(m => m.id === currentMedia?.id);
      if (idx < list.length - 1) playPause(list[idx + 1]);
    }
  };

  const handleLoadedMetadata = (media) => {
    const p = getPlayer(media);
    if (!p) return;
    const dur = p.duration || 1;
    updateDoc(doc(db, 'users', user.uid, 'media', media.id), { duration: dur }).catch(() => {});
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, duration: dur } : m));
    setCurrentMedia(prev => prev?.id === media.id ? { ...prev, duration: dur } : prev);
  };

  const skipSeconds = (s) => {
    const p = getPlayer(currentMedia);
    if (!p) return;
    p.currentTime = Math.max(0, Math.min(p.currentTime + s, currentMedia?.duration || 0));
  };

  const markCensor = (media) => {
    if (currentMedia?.id !== media.id) return;
    const p = getPlayer(media);
    if (!p) return;
    const t = p.currentTime;
    const newPoint = { start: Math.max(0, t - 0.2), end: t + 1.0 };
    const updated = [...media.censorPoints, newPoint].sort((a, b) => a.start - b.start);
    updateDoc(doc(db, 'users', user.uid, 'media', media.id), { censorPoints: updated }).catch(() => {});
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, censorPoints: updated } : m));
    setCurrentMedia(prev => ({ ...prev, censorPoints: updated }));
  };

  const deleteCensorAt = (media, idx) => {
    const updated = media.censorPoints.filter((_, i) => i !== idx);
    updateDoc(doc(db, 'users', user.uid, 'media', media.id), { censorPoints: updated }).catch(() => {});
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, censorPoints: updated } : m));
    setCurrentMedia(prev => prev?.id === media.id ? { ...prev, censorPoints: updated } : prev);
    setSelectedCensorIdxs(new Set());
    setLastClickedCensorIdx(null);
    setContextMenu(null);
  };

  const deleteSelectedCensors = (media) => {
    const updated = media.censorPoints.filter((_, i) => !selectedCensorIdxs.has(i));
    updateDoc(doc(db, 'users', user.uid, 'media', media.id), { censorPoints: updated }).catch(() => {});
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, censorPoints: updated } : m));
    setCurrentMedia(prev => prev?.id === media.id ? { ...prev, censorPoints: updated } : prev);
    setSelectedCensorIdxs(new Set());
    setLastClickedCensorIdx(null);
    setContextMenu(null);
  };

  const deleteAllCensors = (media) => {
    if (!window.confirm(`Delete all ${media.censorPoints.length} timestamps? This cannot be undone.`)) return;
    updateDoc(doc(db, 'users', user.uid, 'media', media.id), { censorPoints: [] }).catch(() => {});
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, censorPoints: [] } : m));
    setCurrentMedia(prev => prev?.id === media.id ? { ...prev, censorPoints: [] } : prev);
    setSelectedCensorIdxs(new Set());
    setLastClickedCensorIdx(null);
  };

  const undoCensor = (media) => {
    if (!media.censorPoints.length) return;
    const updated = media.censorPoints.slice(0, -1);
    updateDoc(doc(db, 'users', user.uid, 'media', media.id), { censorPoints: updated }).catch(() => {});
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, censorPoints: updated } : m));
    if (currentMedia?.id === media.id) setCurrentMedia(prev => ({ ...prev, censorPoints: updated }));
  };

  const deleteMedia = async (media) => {
    if (currentMedia?.id === media.id) {
      const p = getPlayer(media);
      if (p) { p.pause(); p.src = ''; }
      stopBleep();
      setCurrentMedia(null); setCurrentTime(0); setIsPlaying(false);
    }
    try { await deleteObject(ref(storage, media.storagePath)); } catch (e) {}
    await deleteDoc(doc(db, 'users', user.uid, 'media', media.id));
    setMediaList(prev => prev.filter(m => m.id !== media.id));
  };

  const resetControlsTimer = () => {
    setShowVideoControls(true);
    clearTimeout(controlsTimerRef.current);
    controlsTimerRef.current = setTimeout(() => setShowVideoControls(false), 5000);
  };

  const toggleFullscreen = () => {
    const el = fsContainerRef.current;
    if (!el) return;
    if (!document.fullscreenElement) {
      el.requestFullscreen().catch(() => {});
    } else {
      document.exitFullscreen().catch(() => {});
    }
  };

  useEffect(() => {
    const onFSChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onFSChange);
    return () => document.removeEventListener('fullscreenchange', onFSChange);
  }, []);

  const togglePiP = async () => {
    const v = videoRef.current;
    if (!v) return;
    try {
      if (document.pictureInPictureElement) await document.exitPictureInPicture();
      else await v.requestPictureInPicture();
    } catch (e) {}
  };

  const pinAsDemo = async (media) => {
    try {
      const snap = await getDocs(collection(db, 'demo', 'showcase', 'media'));
      await Promise.all(snap.docs.map(d => deleteDoc(doc(db, 'demo', 'showcase', 'media', d.id))));
      if (pinnedId === media.id) {
        setPinnedId(null);
        return;
      }
      await addDoc(collection(db, 'demo', 'showcase', 'media'), {
        sourceId: media.id,
        name: media.name,
        url: media.url,
        duration: media.duration || 0,
        isVideo: media.isVideo || false,
        censorPoints: media.censorPoints || [],
        transcript: media.transcript || null,
        chapters: media.chapters || [],
      });
      setPinnedId(media.id);
    } catch (e) { alert('Error setting demo: ' + e.message); }
  };

  const renameMedia = async (media, newName) => {
    const trimmed = (newName || '').trim();
    setRenamingId(null);
    if (!trimmed || trimmed === media.name) return;
    await updateDoc(doc(db, 'users', user.uid, 'media', media.id), { name: trimmed });
    setMediaList(prev => prev.map(m => m.id === media.id ? { ...m, name: trimmed } : m));
  };

  useEffect(() => { const p = getPlayer(currentMedia); if (p) p.volume = volume; }, [volume]);
  useEffect(() => { const p = getPlayer(currentMedia); if (p) p.playbackRate = playbackSpeed; }, [playbackSpeed]);
  useEffect(() => {
    const handler = (e) => {
      if (e.target.tagName === 'INPUT') return;
      if (e.code === 'Space' && currentMedia) { e.preventDefault(); playPause(currentMedia); }
      if (e.code === 'KeyB' && currentMedia) markCensor(currentMedia);
      if (e.code === 'KeyZ' && currentMedia) undoCensor(currentMedia);
      if (e.code === 'ArrowRight') skipSeconds(5);
      if (e.code === 'ArrowLeft') skipSeconds(-5);
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [currentMedia, volume, censorOn]);

  const getList = () => {
    let list = selectedPlaylist
      ? mediaList.filter(m => playlists.find(p => p.id === selectedPlaylist)?.mediaIds?.includes(m.id))
      : [...mediaList];
    if (searchQuery) list = list.filter(m => m.name.toLowerCase().includes(searchQuery.toLowerCase()));
    if (sortBy === 'name') list.sort((a, b) => a.name.localeCompare(b.name));
    else if (sortBy === 'duration') list.sort((a, b) => (a.duration || 0) - (b.duration || 0));
    else list.sort((a, b) => new Date(a.dateAdded) - new Date(b.dateAdded));
    return list;
  };

  // ── Sub-components ─────────────────────────────────────────────────────────
  const EnhanceProgress = ({ mediaId }) => {
    const info = enhancing[mediaId];
    if (!info) return null;
    return (
      <div style={{ padding: '6px 0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <div style={{ fontSize: 11, color: C.teal }}>{info.stage}</div>
          {exportAbortRef.current[mediaId] && (
            <button onClick={() => exportAbortRef.current[mediaId]?.abort()} style={{ background: 'none', border: `1px solid ${C.censor}55`, borderRadius: 4, color: C.censor, fontSize: 10, cursor: 'pointer', padding: '2px 7px', fontFamily: 'inherit' }}>Cancel</button>
          )}
        </div>
        <div style={{ height: 4, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 2 }}>
          <div style={{ width: `${info.pct}%`, height: '100%', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, borderRadius: 2, transition: 'width 0.4s ease' }} />
        </div>
      </div>
    );
  };

  const SeekBar = ({ media, isCurrent }) => {
    const wave = waveforms[media.id];
    const isLoading = loadingWaveform.has(media.id);
    const [hoverTime, setHoverTime] = useState(null);
    const [hoverX, setHoverX] = useState(0);
    const barRef = useRef(null);
    const seekInputRef = useRef(null);

    // Sync input position from currentTime when not dragging
    useEffect(() => {
      if (seekInputRef.current && isCurrent && !isDraggingRef.current) {
        seekInputRef.current.value = currentTime;
      }
    }, [currentTime, isCurrent]);

    const onMouseMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      setHoverX(e.clientX - rect.left);
      setHoverTime(pct * (media.duration || 0));
    };

    const seek = (t) => {
      if (!isCurrent) { selectMedia(media); setTimeout(() => { const p = getPlayer(media); if (p) { p.currentTime = t; setCurrentTime(t); } }, 150); return; }
      const p = getPlayer(media);
      if (p) p.currentTime = t;
    };

    return (
      <div>
        {isCurrent && (
          <div style={{ marginBottom: 2 }}>
            {wave
              ? <WaveformCanvas data={wave} currentTime={currentTime} duration={media.duration} censorPoints={media.censorPoints}
                  onClick={seek} hoverTime={hoverTime} hoverX={hoverX} onMouseMove={onMouseMove} onMouseLeave={() => setHoverTime(null)} />
              : <div style={{ height: 80 }} />
            }
          </div>
        )}
        <div ref={barRef} style={{ position: 'relative', padding: '4px 0' }}
          onMouseMove={isCurrent ? onMouseMove : undefined}
          onMouseLeave={() => setHoverTime(null)}>
          {hoverTime !== null && (
            <div style={{ position: 'absolute', left: Math.max(20, Math.min(hoverX, (barRef.current?.offsetWidth || 200) - 20)), top: -22, transform: 'translateX(-50%)', backgroundColor: 'rgba(0,0,0,0.85)', color: 'white', padding: '2px 7px', borderRadius: 4, fontSize: 11, pointerEvents: 'none', whiteSpace: 'nowrap', zIndex: 10, border: `1px solid ${C.primary}44` }}>
              {fmt(hoverTime)}
            </div>
          )}
          <input ref={seekInputRef} type="range" className="seekbar" min={0} max={media.duration || 1} step="any"
            defaultValue={isCurrent ? currentTime : 0}
            onMouseDown={() => { isDraggingRef.current = true; }}
            onInput={e => seek(+e.target.value)}
            onMouseUp={e => { isDraggingRef.current = false; setCurrentTime(+e.target.value); }}
            onTouchEnd={e => { isDraggingRef.current = false; }}
            style={{ width: '100%', opacity: 1, display: 'block', height: 20, cursor: 'pointer' }}
          />
          {!wave && media.censorPoints?.map((pt, i) => (
            <div key={i} style={{ position: 'absolute', left: `${(pt.start / (media.duration || 1)) * 100}%`, width: `${Math.max(0.5, ((pt.end - pt.start) / (media.duration || 1)) * 100)}%`, top: '35%', height: '30%', backgroundColor: C.censor, borderRadius: 2, opacity: 0.65, pointerEvents: 'none' }} />
          ))}
        </div>
      </div>
    );
  };

  const TranscriptPanel = ({ media }) => {
    const t = media.transcript;
    if (!t) return null;
    const seekTo = (time) => {
      const p = getPlayer(media);
      if (p && currentMedia?.id === media.id) { p.currentTime = time; setCurrentTime(time); }
    };
    const hasSpeakers = t.utterances?.length > 0;

    return (
      <div style={{ backgroundColor: '#0A1520', borderTop: `1px solid ${C.primary}18`, padding: '10px 12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', letterSpacing: 1 }}>TRANSCRIPT</div>
          <div style={{ flex: 1 }} />
          <button onClick={() => copyShowNotes(media)} style={{ ...S.btn(C.teal), fontSize: 11, padding: '3px 8px' }}>
            {showNotesCopied === media.id + '_notes' ? '✅ Copied!' : '📋 Copy Show Notes'}
          </button>
          {media.chapters?.length > 0 && (
            <button onClick={() => copyChapters(media)} style={{ ...S.btn(C.primary), fontSize: 11, padding: '3px 8px' }}>
              {showNotesCopied === media.id + '_chapters' ? 'Copied!' : 'Copy YouTube Chapters'}
            </button>
          )}
        </div>

        {hasSpeakers ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 220, overflowY: 'auto' }}>
            {t.utterances.map((u, i) => {
              const speakerIdx = u.speaker ? u.speaker.charCodeAt(u.speaker.length - 1) % SPEAKER_COLORS.length : 0;
              const color = SPEAKER_COLORS[speakerIdx];
              return (
                <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 3, flexShrink: 0, alignItems: 'center' }}>
                    <div style={{ ...S.chip(color), whiteSpace: 'nowrap', cursor: 'pointer' }} onClick={() => seekTo(u.start)}>
                      {u.speaker || 'Spkr'}
                    </div>
                    <div onClick={() => seekTo(u.start)} style={{ fontSize: 10, color: C.primary + '99', cursor: 'pointer', whiteSpace: 'nowrap' }}>{fmt(u.start)}</div>
                  </div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
                    {t.words.filter(w => w.start >= u.start && w.end <= u.end + 0.1).map((w, wi) => {
                      const gIdx = t.words.indexOf(w);
                      const isActive = gIdx === activeWordIdx;
                      return (
                        <span key={wi} onClick={() => seekTo(w.start)} title={fmt(w.start)}
                          id={isActive ? 'ts-active-word' : undefined}
                          style={{ cursor: 'pointer', color: isActive ? '#fff' : (w.flagged ? C.censor : 'rgba(255,255,255,0.75)'), fontWeight: (isActive || w.flagged) ? 'bold' : 'normal', marginRight: 3, textDecoration: 'underline', textDecorationColor: isActive ? C.primary + 'bb' : (w.flagged ? C.censor + '88' : 'rgba(255,255,255,0.15)'), backgroundColor: isActive ? C.primary + '22' : 'transparent', borderRadius: 2, padding: isActive ? '0 2px' : undefined }}>
                          {w.text}
                        </span>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.55)', lineHeight: 1.9, maxHeight: 180, overflowY: 'auto' }}>
            {t.words.map((w, i) => {
              const isActive = i === activeWordIdx;
              return (
                <span key={i} onClick={() => seekTo(w.start)} title={fmt(w.start)}
                  id={isActive ? 'ts-active-word' : undefined}
                  style={{ cursor: 'pointer', color: isActive ? '#fff' : (w.flagged ? C.censor : 'rgba(255,255,255,0.75)'), fontWeight: (isActive || w.flagged) ? 'bold' : 'normal', marginRight: 3, textDecoration: 'underline', textDecorationColor: isActive ? C.primary + 'bb' : (w.flagged ? C.censor + '88' : 'rgba(255,255,255,0.15)'), backgroundColor: isActive ? C.primary + '22' : 'transparent', borderRadius: 2, padding: isActive ? '0 2px' : undefined }}>
                  {w.text}
                </span>
              );
            })}
          </div>
        )}

        {media.chapters?.length > 0 && (
          <div style={{ marginTop: 10, borderTop: `1px solid ${C.primary}18`, paddingTop: 8 }}>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 6, letterSpacing: 1 }}>CHAPTERS</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {media.chapters.map((c, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span onClick={() => seekTo(c.time)} style={{ ...S.chip(C.teal), cursor: 'pointer', flexShrink: 0 }}>{fmtChapter(c.time)}</span>
                  <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', flex: 1 }}>{c.title}</span>
                  <span onClick={() => removeChapter(media, i)} style={{ color: C.censor, cursor: 'pointer', fontSize: 12, opacity: 0.6 }}>✕</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const list = getList();

  // ── Mobile Layout ──────────────────────────────────────────────────────────
  if (isMobile) {
    return (
      <div style={{ backgroundColor: C.bg, height: '100dvh', fontFamily: "'Montserrat', sans-serif", color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {toast && (
          <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', backgroundColor: C.bgLight, border: `1px solid ${C.primary}55`, borderRadius: 10, padding: '12px 20px', fontSize: 13, color: 'rgba(255,255,255,0.85)', zIndex: 9999, boxShadow: '0 4px 24px #0008', whiteSpace: 'nowrap' }}>
            ⚠️ {toast}
          </div>
        )}
        <audio ref={audioRef} style={{ display: 'none' }}
          onTimeUpdate={() => { if (currentMedia && !currentMedia.isVideo) handleTimeUpdate(currentMedia); }}
          onEnded={handleEnded}
          onPlay={() => setIsPlaying(true)}
          onPause={handlePause}
          onLoadedMetadata={() => { if (currentMedia && !currentMedia.isVideo) handleLoadedMetadata(currentMedia); }}
        />
        <div style={{ backgroundColor: C.bg, borderBottom: `1px solid ${C.primary}26`, padding: '0 12px', display: 'flex', alignItems: 'center', height: 52, flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
            <WaveLogo compact size={28} />
            <div onClick={() => window.location.href = '/'} style={{ fontSize: 16, fontWeight: 900, letterSpacing: 2, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', cursor: 'pointer' }}>SENSOR</div>
            {isDemo && <div style={{ fontSize: 9, fontWeight: 'bold', color: C.teal, border: `1px solid ${C.teal}55`, borderRadius: 10, padding: '2px 7px', letterSpacing: 1 }}>DEMO</div>}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {isDemo && (
              <select value={censorStyle} onChange={e => setCensorStyle(e.target.value)} style={{ ...S.input, fontSize: 11, padding: '4px 8px' }}>
                {CENSOR_SOUNDS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            )}
            <button onClick={() => setCensorOn(!censorOn)} style={{ padding: '7px 12px', borderRadius: 20, border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: 11, background: censorOn ? `linear-gradient(90deg, #1a7a4a, ${C.censorOn})` : `linear-gradient(90deg, #8b1a1a, ${C.censor})`, color: 'white', whiteSpace: 'nowrap' }}>
              {censorOn ? 'ON' : 'OFF'}
            </button>
          </div>
        </div>

        {Object.keys(uploadProgress).length > 0 && (
          <div style={{ backgroundColor: C.bgMid, padding: '8px 12px', flexShrink: 0 }}>
            {Object.entries(uploadProgress).map(([id, pct]) => (
              <div key={id}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 11, color: C.teal, marginBottom: 4 }}>
                  <span>Uploading...</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>{pct}%</span>
                    <button onClick={() => uploadTasksRef.current[id]?.cancel()} style={{ background: 'none', border: `1px solid ${C.censor}55`, borderRadius: 4, color: C.censor, fontSize: 10, cursor: 'pointer', padding: '2px 7px', fontFamily: 'inherit' }}>Cancel</button>
                  </div>
                </div>
                <div style={{ height: 4, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 2 }}>
                  <div style={{ width: `${pct}%`, height: '100%', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, borderRadius: 2, transition: 'width 0.3s ease' }} />
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ flex: 1, overflowY: 'auto' }}>
          {mobileTab === 'library' && (
            <div style={{ padding: '12px' }}>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <input style={{ ...S.input, flex: 1 }} placeholder="Search..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
                <select style={{ ...S.input }} value={sortBy} onChange={e => setSortBy(e.target.value)}>
                  <option value="date">Date</option><option value="name">Name</option><option value="duration">Duration</option>
                </select>
              </div>
              {!isDemo && <>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <button style={{ flex: 1, padding: '14px 10px', borderRadius: 10, border: `1px solid ${C.primary}44`, background: C.primary + '18', color: C.primary, fontWeight: 'bold', fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }} onClick={() => pickMedia(false)}><IcoMusic size={16} col={C.primary}/> Add Audio</button>
                <button style={{ flex: 1, padding: '14px 10px', borderRadius: 10, border: `1px solid ${C.teal}44`, background: C.teal + '18', color: C.teal, fontWeight: 'bold', fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }} onClick={() => pickMedia(true)}><IcoFilm size={16} col={C.teal}/> Add Video</button>
              </div>
              </>}

              {list.length === 0 && <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.2)', marginTop: 40, fontSize: 14 }}>No media yet.</div>}

              {list.map(media => {
                const isCurrent = currentMedia?.id === media.id;
                const playing = isCurrent && isPlaying;
                const isAnalyzing = analyzing.has(media.id);
                const enh = enhancing[media.id];
                const expPct = exportProgress[media.id];
                return (
                  <div key={media.id} style={{ ...S.card(isCurrent), marginBottom: 10 }}>
                    <div style={{ padding: '12px', display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div onClick={() => selectMedia(media)} style={{ width: 44, height: 44, borderRadius: 10, backgroundColor: media.isVideo ? C.teal + '1e' : C.primary + '26', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}>{media.isVideo ? <IcoFilm size={20} col={C.teal}/> : <IcoMusic size={20} col={C.primary}/>}</div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        {renamingId === media.id
                          ? <input autoFocus value={renameValue} onChange={e => setRenameValue(e.target.value)} onBlur={() => renameMedia(media, renameValue)} onKeyDown={e => { if (e.key === 'Enter') renameMedia(media, renameValue); if (e.key === 'Escape') setRenamingId(null); }} style={{ ...S.input, fontSize: 14, width: '100%', maxWidth: '100%', padding: '2px 6px', boxSizing: 'border-box' }} />
                          : <div onClick={() => selectMedia(media)} onDoubleClick={() => { setRenamingId(media.id); setRenameValue(media.name); }} style={{ fontSize: 14, fontWeight: isCurrent ? 'bold' : 'normal', color: isCurrent ? 'white' : 'rgba(255,255,255,0.7)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }}>{media.name}</div>
                        }
                        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>{isCurrent ? `${fmt(currentTime)} / ${fmt(media.duration)}` : fmt(media.duration)}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                        <button onClick={() => { const p = getPlayer(media); if (p && isCurrent) { p.currentTime = Math.max(0, p.currentTime - 5); setCurrentTime(p.currentTime); } else { selectMedia(media); } }} style={{ width: 34, height: 34, borderRadius: 8, backgroundColor: 'rgba(255,255,255,0.06)', border: 'none', color: 'rgba(255,255,255,0.5)', fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⏮</button>
                        <button onClick={() => playPause(media)} style={{ width: 48, height: 48, borderRadius: 24, backgroundColor: isCurrent ? C.primary + '33' : 'rgba(255,255,255,0.08)', border: `1px solid ${isCurrent ? C.primary + '66' : 'transparent'}`, color: isCurrent ? C.primary : 'rgba(255,255,255,0.5)', fontSize: 22, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{playing ? '⏸' : '▶'}</button>
                        <button onClick={() => { const p = getPlayer(media); if (p && isCurrent) { p.currentTime = Math.min(media.duration || 0, p.currentTime + 5); setCurrentTime(p.currentTime); } }} style={{ width: 34, height: 34, borderRadius: 8, backgroundColor: 'rgba(255,255,255,0.06)', border: 'none', color: 'rgba(255,255,255,0.5)', fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⏭</button>
                      </div>
                      {!isDemo && <button onClick={() => { if (window.confirm(`Delete "${media.name}"? This cannot be undone.`)) deleteMedia(media); }} style={{ width: 38, height: 38, borderRadius: 8, backgroundColor: 'rgba(255,255,255,0.04)', border: 'none', color: C.censor + '99', fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><IcoTrash size={16} /></button>}
                    </div>
                    {isCurrent && <div style={{ padding: '0 12px 8px' }}><SeekBar media={media} isCurrent={true} /></div>}
                    <div style={{ padding: '0 12px 12px' }}>
                      {enh ? <EnhanceProgress mediaId={media.id} /> : (
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          <div style={{ display: 'flex', width: '100%', gap: 4, marginBottom: 4 }}>
                            {[['monetization', 'Monetization Safe'], ['clean', 'Fully Clean']].map(([val, label]) => (
                              <button key={val} onClick={() => setScanPresets(prev => ({ ...prev, [media.id]: val }))} style={{ flex: 1, padding: '5px 4px', fontSize: 10, fontWeight: 'bold', borderRadius: 6, border: `1px solid ${(scanPresets[media.id] || 'monetization') === val ? C.teal : C.primary + '44'}`, background: (scanPresets[media.id] || 'monetization') === val ? C.teal + '22' : 'transparent', color: (scanPresets[media.id] || 'monetization') === val ? C.teal : 'rgba(255,255,255,0.4)', cursor: 'pointer' }}>{label}</button>
                            ))}
                          </div>
                          {processGate
                            ? <div style={{ flex: 1, fontSize: 11, color: 'rgba(255,255,255,0.35)', textAlign: 'center', padding: '8px 4px' }}>Limit reached · resets {resetDateStr}</div>
                            : isAnalyzing
                            ? <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}><ProcessingWave /></div>
                            : <button onClick={isDemo ? undefined : () => autoDetect(media)} style={{ ...S.btn(C.teal), flex: 1, justifyContent: 'center', padding: '8px', cursor: isDemo ? 'not-allowed' : 'pointer' }}><IcoStar size={12} /> Profanity Detection</button>
                          }
                          <button onClick={isDemo ? undefined : () => addChapter(media)} style={{ ...S.btn(C.primary), flex: 1, justifyContent: 'center', padding: '8px', cursor: isDemo ? 'not-allowed' : 'pointer' }}><IcoClock size={12} /> Chapter</button>
                          {exportGate
                            ? <div style={{ flex: 3, fontSize: 11, color: 'rgba(255,255,255,0.35)', textAlign: 'center', padding: '8px 4px' }}>{exportGate === 'family' ? 'View-only — upgrade to export' : `Monthly limit · resets ${resetDateStr}`}</div>
                            : <>
                              {expPct != null
                                ? <div style={{ fontSize: 12, color: C.primary, flex: 1, textAlign: 'center', padding: '8px 0' }}>{expPct}%</div>
                                : <button onClick={isDemo ? undefined : () => exportMedia(media)} style={{ ...S.btn(C.primary), flex: 1, justifyContent: 'center', padding: '8px', cursor: isDemo ? 'not-allowed' : 'pointer' }}><IcoDownload size={12} /> WAV</button>
                              }
                              <button onClick={isDemo ? undefined : () => media.isVideo ? exportVideoFile(media) : exportMP3(media)} style={{ backgroundColor: C.teal + '33', border: `1px solid ${C.teal}88`, borderRadius: 8, color: C.teal, padding: '8px', fontSize: 12, cursor: isDemo ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, fontWeight: 'bold', flex: 2 }}><IcoUpload size={12} /> Export Clean {media.isVideo ? 'Video' : 'MP3'}</button>
                            </>
                          }
                        </div>
                      )}
                    </div>
                    {(media.transcript || media.transcriptStoragePath) && (
                      <div style={{ padding: '0 12px 10px' }}>
                        <button onClick={() => isDemo ? openTranscriptInTab(media) : downloadTranscript(media)} style={{ ...S.btn(C.primary), width: '100%', justifyContent: 'center', fontSize: 11 }}>
                          <IcoDoc size={12} /> {isDemo ? 'View Transcript' : 'Download Transcript'}
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
              {showWatchMeter && (
                <div style={{ marginTop: 4 }}>
                  <WatchMeter watchPct={watchPct} watchHoursUsed={watchHoursUsed} maxWatchHours={maxWatchHours} watchHoursLeft={watchHoursLeft} watchResetDateStr={watchResetDateStr} onUpgrade={handleUpgrade} onAddHours={handleAddHours} canBuyBonus={canBuyBonus} />
                </div>
              )}
            </div>
          )}

          {mobileTab === 'player' && (
            <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: 14 }}>
              {!currentMedia
                ? <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.2)', marginTop: 60, fontSize: 14 }}>Nothing playing yet — go to Library and tap ▶ on a file.</div>
                : (<>
                  {currentMedia.isVideo
                    ? <div ref={fsContainerRef} style={{ position: 'relative', borderRadius: 14, overflow: 'hidden', backgroundColor: '#000' }}
                        onMouseMove={resetControlsTimer} onTouchStart={resetControlsTimer}>
                        <video ref={videoRef} src={currentMedia.url} style={{ width: '100%', display: 'block' }} onTimeUpdate={() => handleTimeUpdate(currentMedia)} onEnded={handleEnded} onLoadedMetadata={() => handleLoadedMetadata(currentMedia)} onPlay={() => { setIsPlaying(true); resetControlsTimer(); }} onPause={handlePause} />
                        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(13,27,42,0.97))', padding: '28px 16px 14px', transition: 'opacity 0.3s', opacity: showVideoControls ? 1 : 0, pointerEvents: showVideoControls ? 'auto' : 'none' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, position: 'relative' }}>
                            <button onClick={() => { const p = videoRef.current; if (p) { p.currentTime = Math.max(0, p.currentTime - 5); setCurrentTime(p.currentTime); } }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.85)', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: 0 }}>⏮</button>
                            <button onClick={() => playPause(currentMedia)} style={{ backgroundColor: '#2DD4BF33', border: '1px solid #2DD4BF88', borderRadius: 10, width: 52, height: 52, color: '#2DD4BF', fontSize: 22, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: 0 }}>{isPlaying ? '⏸' : '▶'}</button>
                            <button onClick={() => { const p = videoRef.current; if (p) { p.currentTime = Math.min(currentMedia.duration || 0, p.currentTime + 5); setCurrentTime(p.currentTime); } }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.85)', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: 0 }}>⏭</button>
                            <button onClick={() => { const p = videoRef.current; if (p) { p.pause(); p.src = ''; } setCurrentMedia(null); setCurrentTime(0); setIsPlaying(false); }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.45)', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: 0 }}>⏹</button>
                            <div style={{ position: 'absolute', right: 0, display: 'flex', gap: 6 }}>
                              <button onClick={togglePiP} style={{ background: 'none', border: 'none', width: 30, height: 30, color: 'rgba(255,255,255,0.45)', fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⧉</button>
                              <button onClick={toggleFullscreen} style={{ background: 'none', border: 'none', width: 30, height: 30, color: 'rgba(255,255,255,0.45)', fontSize: 15, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⤢</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    : <div style={{ width: '100%', aspectRatio: '1', borderRadius: 18, backgroundColor: C.bgMid, border: `1px solid ${C.primary}22`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><IcoMusic size={72} col={C.primary + '55'}/></div>
                  }
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 15, fontWeight: 'bold', color: 'white', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{currentMedia.name}</div>
                    <div style={{ fontSize: 12, color: C.primary + '88', marginTop: 4 }}>{fmt(currentTime)} / {fmt(currentMedia.duration)}</div>
                  </div>
                  <SeekBar media={currentMedia} isCurrent={true} />
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 24 }}>
                    <button onClick={() => skipSeconds(-10)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.45)', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      <span style={{ fontSize: 26 }}>⏪</span><span style={{ fontSize: 10 }}>10s</span>
                    </button>
                    <button onClick={() => playPause(currentMedia)} style={{ width: 70, height: 70, borderRadius: 35, background: `linear-gradient(135deg, ${C.primary}, ${C.teal})`, border: 'none', color: 'white', fontSize: 30, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: `0 4px 20px ${C.primary}44` }}>
                      {isPlaying ? '⏸' : '▶'}
                    </button>
                    <button onClick={() => skipSeconds(10)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.45)', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      <span style={{ fontSize: 26 }}>⏩</span><span style={{ fontSize: 10 }}>10s</span>
                    </button>
                  </div>
                  {!isDemo && <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={() => markCensor(currentMedia)} style={{ ...S.btn(C.censor), flex: 1, justifyContent: 'center', padding: '11px' }}><IcoFlag size={12} /> Mark</button>
                    <button onClick={() => undoCensor(currentMedia)} style={{ ...S.btn(C.primary), flex: 1, justifyContent: 'center', padding: '11px' }}><IcoUndo size={12} /> Undo</button>
                    <button onClick={() => addChapter(currentMedia)} style={{ ...S.btn(C.teal), flex: 1, justifyContent: 'center', padding: '11px' }}><IcoClock size={12} /> Chapter</button>
                  </div>}
                  {enhancing[currentMedia.id]
                    ? <EnhanceProgress mediaId={currentMedia.id} />
                    : <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', width: '100%', gap: 4, marginBottom: 4 }}>
                          {[['monetization', 'Monetization Safe'], ['clean', 'Fully Clean']].map(([val, label]) => (
                            <button key={val} onClick={() => setScanPresets(prev => ({ ...prev, [currentMedia.id]: val }))} style={{ flex: 1, padding: '6px 4px', fontSize: 11, fontWeight: 'bold', borderRadius: 6, border: `1px solid ${(scanPresets[currentMedia.id] || 'monetization') === val ? C.teal : C.primary + '44'}`, background: (scanPresets[currentMedia.id] || 'monetization') === val ? C.teal + '22' : 'transparent', color: (scanPresets[currentMedia.id] || 'monetization') === val ? C.teal : 'rgba(255,255,255,0.4)', cursor: 'pointer' }}>{label}</button>
                          ))}
                        </div>
                        {processGate
                          ? <div style={{ flex: 1, fontSize: 11, color: 'rgba(255,255,255,0.35)', textAlign: 'center', padding: '10px 4px' }}>Limit reached · resets {resetDateStr}</div>
                          : analyzing.has(currentMedia.id)
                          ? <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}><ProcessingWave /></div>
                          : <button onClick={isDemo ? undefined : () => autoDetect(currentMedia)} style={{ ...S.btn(C.teal), flex: 1, justifyContent: 'center', padding: '10px', cursor: isDemo ? 'not-allowed' : 'pointer' }}><IcoStar size={12} /> Profanity Detection</button>
                        }
                        {currentMedia.isVideo && !isDemo && (
                          <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', border: `1px solid ${C.primary}44`, alignSelf: 'center' }}>
                            {['mute', 'bleep'].map(m => (
                              <button key={m} onClick={() => setExportCensorMode(m)} style={{ padding: '6px 10px', fontSize: 11, fontWeight: 'bold', border: 'none', background: exportCensorMode === m ? C.teal + '33' : 'transparent', color: exportCensorMode === m ? C.teal : 'rgba(255,255,255,0.35)', cursor: 'pointer', textTransform: 'uppercase' }}>{m}</button>
                            ))}
                          </div>
                        )}
                        {exportGate
                          ? <div style={{ flex: 3, fontSize: 11, color: 'rgba(255,255,255,0.35)', textAlign: 'center', padding: '10px 4px' }}>{exportGate === 'family' ? 'View-only — upgrade to export' : `Monthly limit · resets ${resetDateStr}`}</div>
                          : <>
                            <button onClick={isDemo ? undefined : () => currentMedia.isVideo ? exportVideoFile(currentMedia) : exportMP3(currentMedia)} style={{ backgroundColor: C.teal + '33', border: `1px solid ${C.teal}88`, borderRadius: 8, color: C.teal, padding: '10px', fontSize: 13, cursor: isDemo ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, fontWeight: 'bold', flex: 2 }}><IcoUpload size={12} /> Export Clean {currentMedia.isVideo ? 'Video' : 'MP3'}</button>
                            <button onClick={isDemo ? undefined : () => exportMedia(currentMedia)} style={{ ...S.btn(C.primary), flex: 1, justifyContent: 'center', padding: '10px', cursor: isDemo ? 'not-allowed' : 'pointer' }}><IcoDownload size={12} /> WAV</button>
                          </>
                        }
                      </div>
                  }
                  {(currentMedia.transcript || currentMedia.transcriptStoragePath) && (
                    <button onClick={() => isDemo ? openTranscriptInTab(currentMedia) : downloadTranscript(currentMedia)} style={{ ...S.btn(C.primary), justifyContent: 'center', width: '100%', marginTop: 8 }}><IcoDoc size={12} /> {isDemo ? 'View Transcript' : 'Download Transcript'}</button>
                  )}
                </>)
              }
            </div>
          )}

          {mobileTab === 'settings' && (
            <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ backgroundColor: C.bgMid, borderRadius: 12, padding: '12px 14px' }}>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 8, letterSpacing: 1 }}>CENSOR SOUND</div>
                <select value={censorStyle} onChange={e => setCensorStyle(e.target.value)} style={{ ...S.input, width: '100%', fontSize: 14 }}>
                  {CENSOR_SOUNDS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
              </div>
              <div style={{ backgroundColor: C.bgMid, borderRadius: 12, padding: '12px 14px' }}>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 8, letterSpacing: 1 }}>VOLUME</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>🔉</span>
                  <input type="range" min={0} max={1} step={0.01} value={volume} onChange={e => setVolume(+e.target.value)} style={{ flex: 1, accentColor: C.primary }} />
                  <span>🔊</span>
                  <span style={{ fontSize: 12, color: C.primary, width: 36 }}>{Math.round(volume * 100)}%</span>
                </div>
              </div>
              <div style={{ backgroundColor: C.bgMid, borderRadius: 12, padding: '12px 14px' }}>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 8, letterSpacing: 1 }}>PLAYBACK SPEED</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  {[0.5, 1.0, 1.5, 2.0].map(s => (
                    <button key={s} onClick={() => setPlaybackSpeed(s)} style={{ ...S.iconBtn(playbackSpeed === s), flex: 1, justifyContent: 'center', padding: '9px 0', fontWeight: 'bold', fontSize: 13 }}>{s}x</button>
                  ))}
                </div>
              </div>
              <div style={{ backgroundColor: C.bgMid, borderRadius: 12, padding: '12px 14px' }}>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 8, letterSpacing: 1 }}>PLAYBACK OPTIONS</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => setLoopOn(!loopOn)} style={{ ...S.iconBtn(loopOn), flex: 1, justifyContent: 'center', padding: '10px', fontSize: 13 }}><IcoRepeat size={13} /> Loop</button>
                  <button onClick={() => setAutoPlayNext(!autoPlayNext)} style={{ ...S.iconBtn(autoPlayNext), flex: 1, justifyContent: 'center', padding: '10px', fontSize: 13 }}>⏭ Auto-Next</button>
                </div>
              </div>
              <div style={{ backgroundColor: C.bgMid, borderRadius: 12, padding: '12px 14px' }}>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 8, letterSpacing: 1 }}>
                  EXTENDED MUTE — <span style={{ color: C.censor }}>+{censorWindow.toFixed(2)}s after word ends</span>
                </div>
                <input type="range" min={0} max={3} step={0.05} value={censorWindow} onChange={e => setCensorWindow(+e.target.value)} style={{ width: '100%', accentColor: C.censor }} />
              </div>
              <div style={{ backgroundColor: C.bgMid, borderRadius: 12, padding: '12px 14px' }}>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 8, letterSpacing: 1 }}>CUSTOM FLAG WORDS</div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                  <input style={{ ...S.input, flex: 1 }} placeholder="Add a word to flag..." value={wordInput} onChange={e => setWordInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && addCustomWord(wordInput)} />
                  <button onClick={() => addCustomWord(wordInput)} style={{ ...S.btn(C.censor) }}>Add</button>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {customWords.map(w => (
                    <div key={w} style={{ ...S.chip(C.censor), display: 'flex', alignItems: 'center', gap: 5, fontSize: 12 }}>
                      {w} <span onClick={() => removeCustomWord(w)} style={{ cursor: 'pointer', opacity: 0.6 }}>✕</span>
                    </div>
                  ))}
                  {customWords.length === 0 && <div style={{ color: 'rgba(255,255,255,0.2)', fontSize: 11 }}>No custom words yet.</div>}
                </div>
              </div>
              <div style={{ backgroundColor: C.bgMid, borderRadius: 12, padding: '12px 14px' }}>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 6, letterSpacing: 1 }}>ACCOUNT</div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', marginBottom: 2 }}>{userData?.name || user.displayName || ''}</div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 6 }}>{user.email}</div>
                {userData?.planName && (
                  <div style={{ display: 'inline-block', background: `${C.teal}22`, border: `1px solid ${C.teal}44`, borderRadius: 20, padding: '3px 10px', fontSize: 10, fontWeight: 'bold', color: C.teal, letterSpacing: 1, marginBottom: 10 }}>{userData.planName.toUpperCase()} PLAN</div>
                )}
                {!isDemo && userData?.stripeCustomerId && (
                  <button onClick={async () => {
                    try {
                      const createPortal = httpsCallable(functions, 'createPortalSession');
                      const result = await createPortal({});
                      window.location.href = result.data.url;
                    } catch (e) { console.error(e); }
                  }} style={{ ...S.btn(C.primary), justifyContent: 'center', width: '100%', padding: '8px', marginBottom: 8, fontSize: 11 }}>Manage Billing</button>
                )}
                <button onClick={() => signOut(auth)} style={{ ...S.btn(C.censor), justifyContent: 'center', width: '100%', padding: '10px' }}>Sign Out</button>
              </div>
            </div>
          )}
        </div>

        <div style={{ backgroundColor: C.bgMid, borderTop: `1px solid ${C.primary}22`, display: 'flex', flexShrink: 0, paddingBottom: 'env(safe-area-inset-bottom)' }}>
          {[{ id: 'library', icon: '📚', label: 'Library' }, { id: 'player', icon: '▶', label: 'Player' }, { id: 'settings', icon: '⚙️', label: 'Settings' }].map(tab => (
            <button key={tab.id} onClick={() => setMobileTab(tab.id)} style={{ flex: 1, padding: '10px 0', background: 'none', border: 'none', borderTop: `2px solid ${mobileTab === tab.id ? C.primary : 'transparent'}`, color: mobileTab === tab.id ? C.primary : 'rgba(255,255,255,0.3)', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
              <span style={{ fontSize: 20 }}>{tab.icon}</span>
              <span style={{ fontSize: 10, fontWeight: mobileTab === tab.id ? 'bold' : 'normal' }}>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  // ── Desktop Layout ─────────────────────────────────────────────────────────
  return (
    <div style={S.app} onClick={() => { if (contextMenu) setContextMenu(null); if (selectedCensorIdxs.size > 0) { setSelectedCensorIdxs(new Set()); setLastClickedCensorIdx(null); } }}>
      {analyzing.has(currentMedia?.id) && <AnalyzingCard />}
      {contextMenu && (
        <div style={{ position: 'fixed', top: contextMenu.y, left: contextMenu.x, backgroundColor: C.bgMid, border: `1px solid ${C.primary}44`, borderRadius: 8, zIndex: 9999, boxShadow: '0 4px 20px rgba(0,0,0,0.5)', minWidth: 160 }}
          onClick={e => e.stopPropagation()}>
          <div style={{ padding: '6px 10px', fontSize: 10, color: 'rgba(255,255,255,0.35)', borderBottom: `1px solid ${C.primary}22`, letterSpacing: 1 }}>
            {selectedCensorIdxs.size > 1 ? `${selectedCensorIdxs.size} TIMESTAMPS SELECTED` : `TIMESTAMP ${fmt(contextMenu.media.censorPoints[contextMenu.idx]?.start)}`}
          </div>
          <div onClick={() => selectedCensorIdxs.size > 1 ? deleteSelectedCensors(contextMenu.media) : deleteCensorAt(contextMenu.media, contextMenu.idx)} style={{ padding: '10px 14px', fontSize: 13, color: C.censor, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
            onMouseEnter={e => e.currentTarget.style.background = `${C.censor}22`}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
            <IcoTrash size={12} /> {selectedCensorIdxs.size > 1 ? `Delete selected (${selectedCensorIdxs.size})` : 'Delete timestamp'}
          </div>
          <div onClick={() => setContextMenu(null)} style={{ padding: '10px 14px', fontSize: 13, color: 'rgba(255,255,255,0.4)', cursor: 'pointer', borderTop: `1px solid ${C.primary}22` }}
            onMouseEnter={e => e.currentTarget.style.background = `${C.primary}11`}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
            Cancel
          </div>
        </div>
      )}
      <audio ref={audioRef} style={{ display: 'none' }}
        onTimeUpdate={() => { if (currentMedia && !currentMedia.isVideo) handleTimeUpdate(currentMedia); }}
        onEnded={handleEnded}
        onPlay={() => setIsPlaying(true)}
        onPause={handlePause}
        onLoadedMetadata={() => { if (currentMedia && !currentMedia.isVideo) handleLoadedMetadata(currentMedia); }}
      />
      <div style={S.appBar}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
          <WaveLogo />
          <div>
            <div onClick={() => window.location.href = '/'} style={{ fontSize: 18, fontWeight: 900, letterSpacing: 2, background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', cursor: 'pointer' }}>SENSOR</div>
            <div style={{ fontSize: 9, color: C.primary + '88', fontStyle: 'italic' }}>"When it makes sense to censor"</div>
          </div>
          <div style={{ fontSize: 9, color: C.primary + '55', marginLeft: 8 }}>by O.A.R. Technologies Inc.</div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {isDemo
            ? <div style={{ fontSize: 11, fontWeight: 'bold', color: C.teal, border: `1px solid ${C.teal}55`, borderRadius: 20, padding: '4px 12px', letterSpacing: 1, display: 'flex', alignItems: 'center', gap: 4 }}><IcoEye size={11} col={C.teal}/> DEMO</div>
            : <>
                {userData?.planName && <div style={{ fontSize: 9, fontWeight: 'bold', color: C.teal, border: `1px solid ${C.teal}44`, borderRadius: 20, padding: '3px 10px', letterSpacing: 1 }}>{userData.planName.toUpperCase()}</div>}
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>{user?.displayName || user?.email}</div>
                {isAdmin(user) && (
                  <select
                    value={userData?.plan || ''}
                    onChange={async e => {
                      const p = e.target.value;
                      const names = { clipper: 'Clipper', family: 'Family Plan', family_plus: 'Family Plus', creator: 'Creator', enterprise: 'Enterprise' };
                      await updateDoc(doc(db, 'users', user.uid), { plan: p, planName: names[p] || p }).catch(() => {});
                      if (setUserData) setUserData(prev => ({ ...prev, plan: p, planName: names[p] || p }));
                    }}
                    style={{ ...S.input, fontSize: 10, padding: '3px 8px', borderColor: `${C.primary}55`, color: C.primary, background: `${C.primary}11`, cursor: 'pointer' }}
                    title="Admin: switch plan"
                  >
                    <option value="clipper">Clipper</option>
                    <option value="family">Family</option>
                    <option value="family_plus">Family Plus</option>
                    <option value="creator">Creator</option>
                    <option value="enterprise">Enterprise</option>
                  </select>
                )}
                <button onClick={() => setShowWordPanel(!showWordPanel)} style={{ ...S.btn(showWordPanel ? C.teal : C.primary), borderRadius: 20 }}>
                  <IcoPencilSVG size={12} /> Custom Words{customWords.length > 0 ? ` (${customWords.length})` : ''}
                </button>
              </>
          }
          <button onClick={() => setCensorOn(!censorOn)} style={{ padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: 11, background: censorOn ? `linear-gradient(90deg, #1a7a4a, ${C.censorOn})` : `linear-gradient(90deg, #8b1a1a, ${C.censor})`, color: 'white' }}>
            {censorOn ? 'SENSOR ON' : 'SENSOR OFF'}
          </button>
          {!isDemo && <button onClick={() => signOut(auth)} style={{ ...S.btn(C.primary) }}>Sign Out</button>}
        </div>
      </div>

      {/* ── Editor Overlay (desktop only) ── */}
      {currentMedia && !isMobile && (
        <div style={{ position: 'fixed', top: 60, left: 0, right: 0, bottom: 0, zIndex: 100, backgroundColor: C.bg, display: 'flex', flexDirection: 'column' }}>

          {/* Top strip — click to go back to library */}
          <div style={{ height: 44, backgroundColor: C.bgMid, borderBottom: `1px solid ${C.primary}22`, display: 'flex', alignItems: 'center', padding: '0 16px', gap: 10, flexShrink: 0 }}>
            <button onClick={() => { const p = getPlayer(currentMedia); if (p) { p.pause(); if (currentMedia?.isVideo) p.src = ''; } setCurrentMedia(null); setIsPlaying(false); setCurrentTime(0); }} style={{ background: 'none', border: 'none', color: C.primary, fontSize: 13, cursor: 'pointer', padding: '0 8px 0 0', fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: 4 }}>← Library</button>
            <div style={{ color: 'rgba(255,255,255,0.15)', fontSize: 14 }}>|</div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
              {currentMedia.isVideo ? <IcoFilm size={12} col="rgba(255,255,255,0.5)"/> : <IcoMusic size={12} col="rgba(255,255,255,0.5)"/>} {currentMedia.name}
            </div>
            <div style={{ fontSize: 11, color: C.primary + '88', flexShrink: 0 }}>{fmt(currentTime)} / {fmt(currentMedia.duration)}</div>
          </div>

          {/* Editor body */}
          <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>

            {/* Main area */}
            <div style={{ flex: 1, overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>

              {/* Video player */}
              {currentMedia.isVideo && (
                <div ref={fsContainerRef} style={{ position: 'relative', backgroundColor: '#000', borderRadius: 10, overflow: 'hidden', width: '100%', height: 'calc(100vh - 220px)', flexShrink: 0 }}
                  onMouseMove={resetControlsTimer} onMouseEnter={resetControlsTimer} onKeyDown={resetControlsTimer} tabIndex={-1}>
                  <video ref={videoRef} src={currentMedia.url}
                    style={{ width: '100%', height: '100%', display: 'block', objectFit: 'contain' }}
                    onTimeUpdate={() => handleTimeUpdate(currentMedia)} onEnded={handleEnded}
                    onLoadedMetadata={() => handleLoadedMetadata(currentMedia)}
                    onPlay={() => { setIsPlaying(true); resetControlsTimer(); }}
                    onPause={handlePause}
                  />

                  {/* Live subtitle overlay */}
                  {subtitleMedias.has(currentMedia.id) && currentMedia.transcript && (() => {
                    const sub = getCurrentSubtitle(currentMedia, currentTime);
                    return sub ? (
                      <div style={{ position: 'absolute', bottom: 108, left: '50%', transform: 'translateX(-50%)', maxWidth: '75%', textAlign: 'center', fontSize: 16, fontWeight: 'bold', color: 'white', backgroundColor: 'rgba(0,0,0,0.72)', padding: '5px 16px', borderRadius: 6, pointerEvents: 'none', zIndex: 3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {sub}
                      </div>
                    ) : null;
                  })()}

                  {/* Bottom controls overlay */}
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 2, background: 'linear-gradient(transparent, rgba(0,0,0,0.85))', transition: 'opacity 0.3s', opacity: showVideoControls ? 1 : 0, pointerEvents: showVideoControls ? 'auto' : 'none' }}>
                    <div style={{ padding: '0 12px 4px' }}><SeekBar media={currentMedia} isCurrent={true} /></div>
                    <div style={{ padding: '8px 16px 14px', position: 'relative' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, position: 'relative' }}>
                        <button onClick={() => { const p = videoRef.current; if (p) { p.currentTime = Math.max(0, p.currentTime - 5); setCurrentTime(p.currentTime); } }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.85)', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>⏮</button>
                        <button onClick={() => playPause(currentMedia)} style={{ backgroundColor: '#2DD4BF33', border: '1px solid #2DD4BF88', borderRadius: 10, width: 52, height: 52, color: '#2DD4BF', fontSize: 22, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>{isPlaying ? '⏸' : '▶'}</button>
                        <button onClick={() => { const p = videoRef.current; if (p) { p.currentTime = Math.min(currentMedia.duration || 0, p.currentTime + 5); setCurrentTime(p.currentTime); } }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.85)', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>⏭</button>
                        <button onClick={() => { const p = videoRef.current; if (p) { p.pause(); p.src = ''; } setCurrentMedia(null); setCurrentTime(0); setIsPlaying(false); }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.45)', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>⏹</button>
                        <div style={{ position: 'absolute', left: 0, display: 'flex', gap: 4 }}>
                          <button onClick={() => setClips(prev => ({ ...prev, [currentMedia.id]: { ...(prev[currentMedia.id] || {}), start: currentTime } }))} style={{ background: 'rgba(255,255,255,0.1)', border: `1px solid ${C.primary}55`, borderRadius: 6, color: clips[currentMedia.id]?.start != null ? C.primary : 'rgba(255,255,255,0.4)', fontSize: 10, fontWeight: 'bold', cursor: 'pointer', padding: '4px 8px' }}>[ IN</button>
                          <button onClick={() => setClips(prev => ({ ...prev, [currentMedia.id]: { ...(prev[currentMedia.id] || {}), end: currentTime } }))} style={{ background: 'rgba(255,255,255,0.1)', border: `1px solid ${C.primary}55`, borderRadius: 6, color: clips[currentMedia.id]?.end != null ? C.primary : 'rgba(255,255,255,0.4)', fontSize: 10, fontWeight: 'bold', cursor: 'pointer', padding: '4px 8px' }}>OUT ]</button>
                        </div>
                        <div style={{ position: 'absolute', right: 0, display: 'flex', gap: 6 }}>
                          <button onClick={togglePiP} title="Picture in Picture" style={{ background: 'none', border: 'none', width: 30, height: 30, color: 'rgba(255,255,255,0.45)', fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⧉</button>
                          <button onClick={toggleFullscreen} title="Fullscreen" style={{ background: 'none', border: 'none', width: 30, height: 30, color: 'rgba(255,255,255,0.45)', fontSize: 15, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⤢</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Fullscreen mini side panel — only visible in fullscreen, auto-hides with controls */}
                  <div style={{ position: 'absolute', top: 0, right: 0, bottom: 0, width: 220, background: 'linear-gradient(to left, rgba(0,0,0,0.85) 70%, transparent)', transition: 'opacity 0.3s', opacity: isFullscreen && showVideoControls ? 1 : 0, pointerEvents: isFullscreen && showVideoControls ? 'auto' : 'none', display: 'flex', flexDirection: 'column', padding: '14px 10px', gap: 8, overflowY: 'auto', zIndex: 1 }}>
                    <button onClick={() => setCensorOn(!censorOn)} style={{ padding: '6px 10px', borderRadius: 20, border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: 10, background: censorOn ? `linear-gradient(90deg, #1a7a4a, ${C.censorOn})` : `linear-gradient(90deg, #8b1a1a, ${C.censor})`, color: 'white' }}>
                      {censorOn ? 'SENSOR ON' : 'SENSOR OFF'}
                    </button>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                      <IcoVolume size={11} col="rgba(255,255,255,0.4)"/>
                      <input type="range" min={0} max={1} step={0.01} value={volume} onChange={e => setVolume(+e.target.value)} style={{ flex: 1, accentColor: C.primary }} />
                    </div>
                    <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', border: `1px solid ${C.primary}44` }}>
                      {['mute', 'bleep'].map(m => (
                        <button key={m} onClick={() => setCensorStyle(m)} style={{ flex: 1, padding: '5px 0', fontSize: 10, fontWeight: 'bold', border: 'none', background: censorStyle === m ? C.primary + '44' : 'transparent', color: censorStyle === m ? 'white' : 'rgba(255,255,255,0.35)', cursor: 'pointer', textTransform: 'uppercase' }}>{m}</button>
                      ))}
                    </div>
                    <div style={{ height: 1, backgroundColor: 'rgba(255,255,255,0.1)' }} />
                    {analyzing.has(currentMedia.id)
                      ? <ProcessingWave />
                      : <button onClick={isDemo ? undefined : () => autoDetect(currentMedia)} style={{ ...S.btn(C.teal), cursor: isDemo ? 'not-allowed' : 'pointer', justifyContent: 'center', padding: '7px', fontSize: 11 }}><IcoStar size={12} /> Profanity Detection</button>
                    }
                    {enhancing[currentMedia.id] ? <EnhanceProgress mediaId={currentMedia.id} /> : (
                      <button onClick={isDemo ? undefined : () => currentMedia.isVideo ? exportVideoFile(currentMedia) : exportMP3(currentMedia)}
                        style={{ backgroundColor: C.teal + '33', border: `1px solid ${C.teal}88`, borderRadius: 8, color: C.teal, padding: '7px', fontSize: 11, cursor: isDemo ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, fontWeight: 'bold' }}>
                        <IcoUpload size={12} /> Export Clean
                      </button>
                    )}
                    <button onClick={isDemo ? undefined : () => exportMedia(currentMedia)} style={{ ...S.btn(C.primary), cursor: isDemo ? 'not-allowed' : 'pointer', justifyContent: 'center', padding: '7px', fontSize: 11 }}><IcoDownload size={12} /> WAV</button>
                    <button onClick={isDemo ? undefined : () => addChapter(currentMedia)} style={{ ...S.btn(C.primary), cursor: isDemo ? 'not-allowed' : 'pointer', justifyContent: 'center', padding: '7px', fontSize: 11 }}><IcoClock size={12} /> Chapter</button>
                    <div style={{ height: 1, backgroundColor: 'rgba(255,255,255,0.1)' }} />
                    {!isDemo && (
                      <div style={{ display: 'flex', gap: 5 }}>
                        <button onClick={() => markCensor(currentMedia)} style={{ ...S.iconBtn(false), flex: 1, justifyContent: 'center', padding: '6px', fontSize: 11 }} title="Mark (B)"><IcoFlag size={12} /> Mark</button>
                        <button onClick={() => undoCensor(currentMedia)} style={{ ...S.iconBtn(false), flex: 1, justifyContent: 'center', padding: '6px', fontSize: 11 }} title="Undo (Z)"><IcoUndo size={12} /> Undo</button>
                      </div>
                    )}
                    {currentMedia.censorPoints?.length > 0 && (
                      <details>
                        <summary style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', cursor: 'pointer', userSelect: 'none', letterSpacing: 1 }}>TIMESTAMPS ({currentMedia.censorPoints.length})</summary>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3, marginTop: 6, maxHeight: 120, overflowY: 'auto' }}>
                          {currentMedia.censorPoints.map((pt, i) => (
                            <div key={i}
                              style={{ ...S.chip(C.censor), fontSize: 9, cursor: 'pointer', outline: selectedCensorIdxs.has(i) ? `2px solid white` : 'none', opacity: selectedCensorIdxs.size > 0 && !selectedCensorIdxs.has(i) ? 0.4 : 1 }}
                              onClick={(e) => { const p = videoRef.current; if (p) { p.currentTime = Math.max(0, pt.start - 0.5); setCurrentTime(p.currentTime); } if (e.shiftKey && lastClickedCensorIdx !== null) { const mn = Math.min(lastClickedCensorIdx, i), mx = Math.max(lastClickedCensorIdx, i); const r = new Set(); for (let j = mn; j <= mx; j++) r.add(j); setSelectedCensorIdxs(r); } else { const s = new Set(selectedCensorIdxs); if (s.has(i)) s.delete(i); else s.add(i); setSelectedCensorIdxs(s); setLastClickedCensorIdx(i); } }}
                              onContextMenu={(e) => { e.preventDefault(); if (!selectedCensorIdxs.has(i)) { setSelectedCensorIdxs(new Set([i])); setLastClickedCensorIdx(i); } setContextMenu({ x: e.clientX, y: e.clientY, media: currentMedia, idx: i }); }}>
                              {fmt(pt.start)}
                            </div>
                          ))}
                        </div>
                      </details>
                    )}
                  </div>
                </div>
              )}

              {/* Audio seekbar + controls */}
              {!currentMedia.isVideo && (
                <>
                  <SeekBar media={currentMedia} isCurrent={true} />
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                    <button onClick={() => { const p = getPlayer(currentMedia); if (p) { p.currentTime = Math.max(0, p.currentTime - 5); setCurrentTime(p.currentTime); } }} style={{ ...S.iconBtn(false), fontSize: 18, padding: 10 }}>⏮</button>
                    <button onClick={() => playPause(currentMedia)} style={{ backgroundColor: C.teal + '33', border: `1px solid ${C.teal}88`, borderRadius: 8, color: C.teal, padding: 12, fontSize: 24, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{isPlaying ? '⏸' : '▶'}</button>
                    <button onClick={() => { const p = getPlayer(currentMedia); if (p) { p.currentTime = Math.min(currentMedia.duration || 0, p.currentTime + 5); setCurrentTime(p.currentTime); } }} style={{ ...S.iconBtn(false), fontSize: 18, padding: 10 }}>⏭</button>
                  </div>
                  {currentMedia.censorPoints?.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {currentMedia.censorPoints.map((pt, i) => (
                        <div key={i}
                          style={{ ...S.chip(C.censor), cursor: 'pointer', outline: selectedCensorIdxs.has(i) ? `2px solid white` : 'none', opacity: selectedCensorIdxs.size > 0 && !selectedCensorIdxs.has(i) ? 0.4 : 1 }}
                          onClick={(e) => { const p = getPlayer(currentMedia); if (p) { p.currentTime = Math.max(0, pt.start - 0.5); setCurrentTime(p.currentTime); } if (e.shiftKey && lastClickedCensorIdx !== null) { const mn = Math.min(lastClickedCensorIdx, i), mx = Math.max(lastClickedCensorIdx, i); const r = new Set(); for (let j = mn; j <= mx; j++) r.add(j); setSelectedCensorIdxs(r); } else { const s = new Set(selectedCensorIdxs); if (s.has(i)) s.delete(i); else s.add(i); setSelectedCensorIdxs(s); setLastClickedCensorIdx(i); } }}
                          onContextMenu={(e) => { e.preventDefault(); if (!selectedCensorIdxs.has(i)) { setSelectedCensorIdxs(new Set([i])); setLastClickedCensorIdx(i); } setContextMenu({ x: e.clientX, y: e.clientY, media: currentMedia, idx: i }); }}>
                          {fmt(pt.start)}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Right side panel */}
            <div style={{ width: 230, borderLeft: `1px solid ${C.primary}22`, padding: '14px 12px', display: 'flex', flexDirection: 'column', gap: 10, overflowY: 'auto', backgroundColor: C.bgMid, flexShrink: 0 }}>

              <button onClick={() => setCensorOn(!censorOn)} style={{ padding: '8px 12px', borderRadius: 20, border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: 11, background: censorOn ? `linear-gradient(90deg, #1a7a4a, ${C.censorOn})` : `linear-gradient(90deg, #8b1a1a, ${C.censor})`, color: 'white', width: '100%' }}>
                {censorOn ? 'SENSOR ON' : 'SENSOR OFF'}
              </button>

              <div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 5, letterSpacing: 1 }}>VOLUME</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 11, opacity: 0.4 }}>🔉</span>
                  <input type="range" min={0} max={1} step={0.01} value={volume} onChange={e => setVolume(+e.target.value)} style={{ flex: 1, accentColor: C.primary }} />
                  <span style={{ fontSize: 11, color: C.primary + '88', width: 32 }}>{Math.round(volume * 100)}%</span>
                </div>
              </div>

              <div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 5, letterSpacing: 1 }}>SCAN MODE</div>
                <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', border: `1px solid ${C.primary}44` }}>
                  {[['monetization', 'Mon. Safe'], ['clean', 'Fully Clean']].map(([val, lbl]) => {
                    const active = (scanPresets[currentMedia.id] || 'monetization') === val;
                    return <button key={val} onClick={() => setScanPresets(prev => ({ ...prev, [currentMedia.id]: val }))} style={{ flex: 1, padding: '5px 4px', fontSize: 10, fontWeight: 'bold', border: 'none', background: active ? C.primary + '33' : 'transparent', color: active ? C.primary : 'rgba(255,255,255,0.35)', cursor: 'pointer' }}>{lbl}</button>;
                  })}
                </div>
              </div>

              <div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 5, letterSpacing: 1 }}>CENSOR SOUND</div>
                <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', border: `1px solid ${C.primary}44` }}>
                  {['mute', 'bleep'].map(m => (
                    <button key={m} onClick={() => setCensorStyle(m)} style={{ flex: 1, padding: '6px 0', fontSize: 10, fontWeight: 'bold', border: 'none', background: censorStyle === m ? C.primary + '44' : 'transparent', color: censorStyle === m ? 'white' : 'rgba(255,255,255,0.35)', cursor: 'pointer', textTransform: 'uppercase' }}>{m}</button>
                  ))}
                </div>
              </div>

              <div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 5, letterSpacing: 1 }}>SPEAKER MODE</div>
                <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', border: `1px solid ${C.primary}44` }}>
                  {[['single', 'Single'], ['multi', 'Multi']].map(([val, lbl]) => {
                    const active = (speakerMode[currentMedia.id] || 'multi') === val;
                    return <button key={val} onClick={() => setSpeakerMode(prev => ({ ...prev, [currentMedia.id]: val }))} style={{ flex: 1, padding: '6px 0', fontSize: 10, fontWeight: 'bold', border: 'none', background: active ? C.primary + '44' : 'transparent', color: active ? 'white' : 'rgba(255,255,255,0.35)', cursor: 'pointer' }}>{lbl}</button>;
                  })}
                </div>
              </div>

              {currentMedia.isVideo && (currentMedia.transcript || currentMedia.transcriptStoragePath) && (
                <div>
                  <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 5, letterSpacing: 1 }}>SUBTITLES</div>
                  <button onClick={() => { loadTranscriptIfNeeded(currentMedia); setSubtitleMedias(prev => { const n = new Set(prev); n.has(currentMedia.id) ? n.delete(currentMedia.id) : n.add(currentMedia.id); return n; }); }}
                    style={{ ...S.btn(subtitleMedias.has(currentMedia.id) ? C.teal : C.primary), justifyContent: 'center', padding: '6px', width: '100%', marginBottom: 5 }}>
                    {subtitleMedias.has(currentMedia.id) ? 'Subtitles ON' : 'Subtitles OFF'}
                  </button>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: 'rgba(255,255,255,0.4)', cursor: 'pointer' }}>
                    <input type="checkbox" checked={exportSubtitles} onChange={e => setExportSubtitles(e.target.checked)} />
                    Burn into export
                  </label>
                </div>
              )}

              {(
                <div>
                  <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 5, letterSpacing: 1 }}>CLIP</div>
                  <div style={{ display: 'flex', gap: 5, marginBottom: 5 }}>
                    <button onClick={() => setClips(prev => ({ ...prev, [currentMedia.id]: { ...(prev[currentMedia.id] || {}), start: currentTime } }))} style={{ ...S.btn(clips[currentMedia.id]?.start != null ? C.teal : C.primary), flex: 1, justifyContent: 'center', padding: '6px', fontSize: 10 }}>Set In</button>
                    <button onClick={() => setClips(prev => ({ ...prev, [currentMedia.id]: { ...(prev[currentMedia.id] || {}), end: currentTime } }))} style={{ ...S.btn(clips[currentMedia.id]?.end != null ? C.teal : C.primary), flex: 1, justifyContent: 'center', padding: '6px', fontSize: 10 }}>Set Out</button>
                  </div>
                  {clips[currentMedia.id]?.start != null && (
                    <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', marginBottom: 5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>{fmt(clips[currentMedia.id].start)} → {clips[currentMedia.id]?.end != null ? fmt(clips[currentMedia.id].end) : '--:--'}</span>
                      <button onClick={() => setClips(prev => { const n = { ...prev }; delete n[currentMedia.id]; return n; })} style={{ background: 'none', border: 'none', color: C.censor, fontSize: 10, cursor: 'pointer', fontFamily: 'inherit' }}>clear</button>
                    </div>
                  )}
                  {clips[currentMedia.id]?.start != null && clips[currentMedia.id]?.end != null && !isDemo && !exportGate && (
                    <button onClick={() => exportVideoFile(currentMedia, { useClip: true })} style={{ ...S.btn(C.teal), justifyContent: 'center', padding: '8px', width: '100%', fontWeight: 'bold' }}>
                      <IcoUpload size={11} /> Export Clip
                    </button>
                  )}
                </div>
              )}

              <div style={{ height: 1, backgroundColor: `${C.primary}22` }} />

              {processGate
                ? <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', textAlign: 'center', padding: '4px 0' }}>Limit reached · resets {resetDateStr}</div>
                : analyzing.has(currentMedia.id)
                ? <ProcessingWave />
                : <button onClick={isDemo ? undefined : () => autoDetect(currentMedia)} style={{ ...S.btn(C.teal), cursor: isDemo ? 'not-allowed' : 'pointer', justifyContent: 'center', padding: '10px' }}><IcoStar size={12} /> Profanity Detection</button>
              }

              {!isDemo && (
                <div>
                  <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 5, letterSpacing: 1 }}>EXPORT SOUND</div>
                  <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', border: `1px solid ${C.primary}44` }}>
                    {['mute', 'bleep'].map(m => (
                      <button key={m} onClick={() => setExportCensorMode(m)} style={{ flex: 1, padding: '7px 0', fontSize: 11, fontWeight: 'bold', border: 'none', background: exportCensorMode === m ? C.primary + '44' : 'rgba(255,255,255,0.05)', color: exportCensorMode === m ? 'white' : 'rgba(255,255,255,0.4)', cursor: 'pointer', textTransform: 'uppercase' }}>{m}</button>
                    ))}
                  </div>
                </div>
              )}
              {exportGate && !enhancing[currentMedia.id]
                ? <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', textAlign: 'center', padding: '4px 0' }}>{exportGate === 'family' ? 'View-only — upgrade to export' : `Monthly limit reached — resets ${resetDateStr}`}</div>
                : enhancing[currentMedia.id] ? <EnhanceProgress mediaId={currentMedia.id} /> : (
                <button onClick={isDemo ? undefined : () => currentMedia.isVideo ? exportVideoFile(currentMedia) : exportMP3(currentMedia)}
                  style={{ backgroundColor: C.teal + '33', border: `1px solid ${C.teal}88`, borderRadius: 8, color: C.teal, padding: '10px', fontSize: 12, cursor: isDemo ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, fontWeight: 'bold' }}>
                  <IcoUpload size={12} /> Export Clean {currentMedia.isVideo ? 'Video' : 'MP3'}
                </button>
              )}

              {!exportGate && (exportProgress[currentMedia.id] != null
                ? <div style={{ fontSize: 12, color: C.primary, textAlign: 'center' }}>{exportProgress[currentMedia.id]}%</div>
                : <button onClick={isDemo ? undefined : () => exportMedia(currentMedia)} style={{ ...S.btn(C.primary), cursor: isDemo ? 'not-allowed' : 'pointer', justifyContent: 'center', padding: '10px' }}><IcoDownload size={12} /> WAV</button>
              )}

              <button onClick={isDemo ? undefined : () => addChapter(currentMedia)} style={{ ...S.btn(C.primary), cursor: isDemo ? 'not-allowed' : 'pointer', justifyContent: 'center', padding: '10px' }}><IcoClock size={12} /> Chapter</button>

              {(currentMedia.transcript || currentMedia.transcriptStoragePath) && (
                isDemo
                  ? <button onClick={() => openTranscriptInTab(currentMedia)} style={{ ...S.btn(C.primary), justifyContent: 'center', padding: '10px' }}><IcoDoc size={12} /> View Transcript</button>
                  : <div>
                      <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 5, letterSpacing: 1 }}>TRANSCRIPT</div>
                      <div style={{ display: 'flex', gap: 5 }}>
                        <button onClick={() => downloadTranscript(currentMedia, 'unedited')} style={{ ...S.btn(C.primary), flex: 1, justifyContent: 'center', padding: '8px', fontSize: 11 }}><IcoDoc size={11} /> Unedited</button>
                        <button onClick={() => downloadTranscript(currentMedia, 'edited')} style={{ ...S.btn(C.teal), flex: 1, justifyContent: 'center', padding: '8px', fontSize: 11 }}><IcoDoc size={11} /> Clean</button>
                      </div>
                    </div>
              )}

              {currentMedia.censorPoints?.length > 0 && (
                <details>
                  <summary style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', cursor: 'pointer', userSelect: 'none', letterSpacing: 1, padding: '4px 0' }}>TIMESTAMPS ({currentMedia.censorPoints.length})</summary>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3, marginTop: 6, maxHeight: 150, overflowY: 'auto' }}>
                    {currentMedia.censorPoints.map((pt, i) => (
                      <div key={i}
                        style={{ ...S.chip(C.censor), fontSize: 10, cursor: 'pointer', outline: selectedCensorIdxs.has(i) ? `2px solid white` : 'none', opacity: selectedCensorIdxs.size > 0 && !selectedCensorIdxs.has(i) ? 0.4 : 1 }}
                        onClick={(e) => { const p = getPlayer(currentMedia); if (p) { p.currentTime = Math.max(0, pt.start - 0.5); setCurrentTime(p.currentTime); } if (e.shiftKey && lastClickedCensorIdx !== null) { const mn = Math.min(lastClickedCensorIdx, i), mx = Math.max(lastClickedCensorIdx, i); const r = new Set(); for (let j = mn; j <= mx; j++) r.add(j); setSelectedCensorIdxs(r); } else { const s = new Set(selectedCensorIdxs); if (s.has(i)) s.delete(i); else s.add(i); setSelectedCensorIdxs(s); setLastClickedCensorIdx(i); } }}
                        onContextMenu={(e) => { e.preventDefault(); if (!selectedCensorIdxs.has(i)) { setSelectedCensorIdxs(new Set([i])); setLastClickedCensorIdx(i); } setContextMenu({ x: e.clientX, y: e.clientY, media: currentMedia, idx: i }); }}>
                        {fmt(pt.start)}
                      </div>
                    ))}
                  </div>
                </details>
              )}

              {!isDemo && (<>
                <div style={{ height: 1, backgroundColor: `${C.primary}22` }} />
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => markCensor(currentMedia)} style={{ ...S.iconBtn(false), flex: 1, justifyContent: 'center', padding: '8px', fontSize: 13 }} title="Mark (B)"><IcoFlag size={12} /> Mark</button>
                  <button onClick={() => undoCensor(currentMedia)} style={{ ...S.iconBtn(false), flex: 1, justifyContent: 'center', padding: '8px', fontSize: 13 }} title="Undo (Z)"><IcoUndo size={12} /> Undo</button>
                  {selectedCensorIdxs.size > 0 && (
                    <button onClick={() => deleteSelectedCensors(currentMedia)} style={{ ...S.iconBtn(false), flex: 1, justifyContent: 'center', padding: '8px', fontSize: 13, color: C.censor, border: `1px solid ${C.censor}55` }} title="Delete selected"><IcoTrash size={12} /> Delete{selectedCensorIdxs.size > 1 ? ` (${selectedCensorIdxs.size})` : ''}</button>
                  )}
                  {currentMedia.censorPoints.length > 0 && (
                    <button onClick={() => deleteAllCensors(currentMedia)} style={{ ...S.iconBtn(false), flex: 1, justifyContent: 'center', padding: '8px', fontSize: 13, color: C.censor, border: `1px solid ${C.censor}55` }} title="Delete all timestamps"><IcoTrash size={12} /> Delete All</button>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => { if (window.confirm(`Delete "${currentMedia.name}"? This cannot be undone.`)) { deleteMedia(currentMedia); setCurrentMedia(null); } }} style={{ ...S.iconBtn(false), flex: 1, justifyContent: 'center', padding: '8px', fontSize: 13, color: C.censor }}><IcoTrash size={12} /> Delete</button>
                  <button onClick={() => pinAsDemo(currentMedia)} style={{ ...S.iconBtn(pinnedId === currentMedia.id), flex: 1, justifyContent: 'center', padding: '8px', fontSize: 13, color: pinnedId === currentMedia.id ? C.teal : undefined }}><IcoPin size={12} /> {pinnedId === currentMedia.id ? 'Unpin' : 'Pin'}</button>
                </div>
              </>)}

            </div>
          </div>
        </div>
      )}

      <div style={S.body}>
        {showWordPanel && (
          <div style={{ backgroundColor: '#0A1825', padding: '12px 16px', borderBottom: `1px solid ${C.censor}22` }}>
            <div style={{ fontSize: 13, fontWeight: 'bold', marginBottom: 10, color: 'rgba(255,255,255,0.8)' }}>
              ⚠️ Custom Flag Words
            </div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
              <input style={{ ...S.input, flex: 1 }} placeholder="Type a word to flag..." value={wordInput} onChange={e => setWordInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && addCustomWord(wordInput)} />
              <button onClick={() => addCustomWord(wordInput)} style={{ ...S.btn(C.censor) }}>Add</button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {customWords.map(w => (
                <div key={w} style={{ ...S.chip(C.censor), display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
                  {w} <span onClick={() => removeCustomWord(w)} style={{ cursor: 'pointer', opacity: 0.6 }}>✕</span>
                </div>
              ))}
              {customWords.length === 0 && <div style={{ color: 'rgba(255,255,255,0.2)', fontSize: 11 }}>No custom words yet.</div>}
            </div>
          </div>
        )}

        {Object.keys(uploadProgress).length > 0 && (
          <div style={{ backgroundColor: C.bgMid, padding: '8px 16px' }}>
            {Object.entries(uploadProgress).map(([id, pct]) => (
              <div key={id}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 11, color: C.teal, marginBottom: 4 }}>
                  <span>Uploading...</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>{pct}%</span>
                    <button onClick={() => uploadTasksRef.current[id]?.cancel()} style={{ background: 'none', border: `1px solid ${C.censor}55`, borderRadius: 4, color: C.censor, fontSize: 10, cursor: 'pointer', padding: '2px 7px', fontFamily: 'inherit' }}>Cancel</button>
                  </div>
                </div>
                <div style={{ height: 4, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 2 }}>
                  <div style={{ width: `${pct}%`, height: '100%', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, borderRadius: 2, transition: 'width 0.3s ease' }} />
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={S.controls}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <span style={{ fontSize: 12, opacity: 0.4 }}>🔉</span>
            <input type="range" min={0} max={1} step={0.01} value={volume} onChange={e => setVolume(+e.target.value)} style={{ flex: 1, accentColor: C.primary }} />
            <span style={{ fontSize: 12, opacity: 0.4 }}>🔊</span>
            <span style={{ fontSize: 11, color: C.primary + '88', width: 40 }}>{Math.round(volume * 100)}%</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>Speed</span>
            {[0.5, 1.0, 1.5, 2.0].map(s => (
              <button key={s} onClick={() => setPlaybackSpeed(s)} style={{ ...S.iconBtn(playbackSpeed === s), fontSize: 11, fontWeight: 'bold', padding: '3px 10px' }}>{s}x</button>
            ))}
            <button onClick={() => setLoopOn(!loopOn)} style={{ ...S.iconBtn(loopOn), fontSize: 11 }}><IcoRepeat size={14} /></button>
            <button onClick={() => setAutoPlayNext(!autoPlayNext)} style={{ ...S.iconBtn(autoPlayNext), fontSize: 11 }}>⏭</button>
            <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', marginLeft: 8 }}>Sensor sound</span>
            <select value={censorStyle} onChange={e => setCensorStyle(e.target.value)} style={{ ...S.input, fontSize: 12, padding: '3px 10px' }}>
              {CENSOR_SOUNDS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>Extended mute</span>
              <input type="range" min={0} max={3} step={0.05} value={censorWindow} onChange={e => setCensorWindow(+e.target.value)} style={{ width: 100, accentColor: C.censor }} />
              <span style={{ fontSize: 11, color: C.censor + 'bb' }}>+{censorWindow.toFixed(2)}s</span>
            </div>
          </div>
        </div>

        <div style={S.toolbar}>
          <input style={{ ...S.input, flex: 1, minWidth: 200 }} placeholder="Search..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
          <select style={{ ...S.input }} value={sortBy} onChange={e => setSortBy(e.target.value)}>
            <option value="date">Date</option><option value="name">Name</option><option value="duration">Duration</option>
          </select>
          {!isDemo && <>
            <button style={S.btn(C.primary)} onClick={() => pickMedia(false)}><IcoMusic size={12} /> Add Audio</button>
            <button style={S.btn(C.primary)} onClick={() => pickMedia(true)}><IcoFilm size={12} /> Add Video</button>
            <button style={S.btn(C.primary)} onClick={() => {
              const name = prompt('Playlist name:');
              if (name) addDoc(collection(db, 'users', user.uid, 'playlists'), { name, mediaIds: [] })
                .then(r => setPlaylists(prev => [...prev, { id: r.id, name, mediaIds: [] }]));
            }}>+ Playlist</button>
          </>}
          <select style={{ ...S.input }} value={selectedPlaylist || '__all__'} onChange={e => setSelectedPlaylist(e.target.value === '__all__' ? null : e.target.value)}>
            <option value="__all__">All Media</option>
            {playlists.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>

        <div style={S.hints}>
          {[['Space','Play/Pause'],['B','Mark Censor'],['Z','Undo'],['← →','Skip 5s']].map(([k,l]) => (
            <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <div style={{ ...S.chip(C.primary), fontSize: 10 }}>{k}</div>
              <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.2)' }}>{l}</span>
            </div>
          ))}
        </div>

        <div style={S.list}>
          {list.length === 0 && (
            <div style={{ textAlign: 'center', marginTop: 80, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke={C.primary + '44'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="17 8 12 3 7 8"/>
                <line x1="12" y1="3" x2="12" y2="15"/>
              </svg>
              <div style={{ fontSize: 15, color: 'rgba(255,255,255,0.3)', fontWeight: 600 }}>Drop a file here to get started</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.15)' }}>or click Add Audio / Add Video above</div>
            </div>
          )}
          {list.map(media => {
            const isCurrent = currentMedia?.id === media.id;
            const playing = isCurrent && isPlaying;
            const isAnalyzing = analyzing.has(media.id);
            const expPct = exportProgress[media.id];
            const enh = enhancing[media.id];

            return (
              <div key={media.id} style={S.card(isCurrent)}>
                <div style={{ padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div onClick={() => selectMedia(media)} style={{ width: 32, height: 32, borderRadius: 6, backgroundColor: media.isVideo ? C.teal + '1e' : C.primary + '26', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}>
                    {media.isVideo ? <IcoFilm size={16} col={C.teal}/> : <IcoMusic size={16} col={C.primary}/>}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    {renamingId === media.id
                      ? <input autoFocus value={renameValue} onChange={e => setRenameValue(e.target.value)} onBlur={() => renameMedia(media, renameValue)} onKeyDown={e => { if (e.key === 'Enter') renameMedia(media, renameValue); if (e.key === 'Escape') setRenamingId(null); }} style={{ ...S.input, fontSize: 13, width: '100%', maxWidth: '100%', padding: '2px 6px', boxSizing: 'border-box' }} />
                      : <div style={{ display: 'flex', alignItems: 'center', gap: 5, minWidth: 0 }}>
                          <div onClick={() => selectMedia(media)} onDoubleClick={() => { setRenamingId(media.id); setRenameValue(media.name); }} style={{ fontSize: 13, fontWeight: isCurrent ? 'bold' : 'normal', color: isCurrent ? 'white' : 'rgba(255,255,255,0.6)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }}>{media.name}</div>
                          <span onClick={() => { setRenamingId(media.id); setRenameValue(media.name); }} style={{ cursor: 'pointer', flexShrink: 0 }} title="Rename"><IcoPencilSVG size={11} col="rgba(255,255,255,0.2)"/></span>
                        </div>
                    }
                    {isCurrent && <div style={{ fontSize: 11, color: C.primary + '88' }}>{fmt(currentTime)} / {fmt(media.duration)}</div>}
                  </div>

                  {enh
                    ? <div style={{ minWidth: 180 }}><EnhanceProgress mediaId={media.id} /></div>
                    : (<>
                      {processGate
                        ? <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', maxWidth: 140 }}>Limit reached · resets {resetDateStr}</div>
                        : isAnalyzing
                        ? <ProcessingWave />
                        : <button onClick={isDemo ? undefined : () => autoDetect(media)} style={{ ...S.btn(C.teal), cursor: isDemo ? 'not-allowed' : 'pointer' }}><IcoStar size={12} /> Profanity Detection</button>
                      }
                      <button onClick={isDemo ? undefined : () => addChapter(media)} style={{ ...S.btn(C.primary), cursor: isDemo ? 'not-allowed' : 'pointer' }}><IcoClock size={12} /> Chapter</button>
                      {(media.transcript || media.transcriptStoragePath) && (
                        <button onClick={() => isDemo ? openTranscriptInTab(media) : downloadTranscript(media)} style={{ ...S.btn(C.primary) }}><IcoDoc size={12} /> {isDemo ? 'View Transcript' : 'Transcript'}</button>
                      )}
                      {media.isVideo && !isDemo && (
                        <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', border: `1px solid ${C.primary}44`, flexShrink: 0 }}>
                          {['mute', 'bleep'].map(m => (
                            <button key={m} onClick={() => setExportCensorMode(m)} style={{ padding: '4px 8px', fontSize: 10, fontWeight: 'bold', border: 'none', background: exportCensorMode === m ? C.teal + '33' : 'transparent', color: exportCensorMode === m ? C.teal : 'rgba(255,255,255,0.35)', cursor: 'pointer', textTransform: 'uppercase' }}>{m}</button>
                          ))}
                        </div>
                      )}
                      {exportGate
                        ? <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', maxWidth: 160 }}>{exportGate === 'family' ? 'View-only plan' : `Monthly limit · resets ${resetDateStr}`}</div>
                        : <>
                          <button onClick={isDemo ? undefined : () => media.isVideo ? exportVideoFile(media) : exportMP3(media)}
                            style={{ backgroundColor: C.teal + '33', border: `1px solid ${C.teal}88`, borderRadius: 8, color: C.teal, padding: '6px 14px', fontSize: 12, cursor: isDemo ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 5, fontWeight: 'bold' }}>
                            <IcoUpload size={12} /> Export Clean {media.isVideo ? 'Video' : 'MP3'}
                          </button>
                          {expPct != null
                            ? <div style={{ fontSize: 12, color: C.primary }}>{expPct}%</div>
                            : <button onClick={isDemo ? undefined : () => exportMedia(media)} style={{ ...S.btn(C.primary), cursor: isDemo ? 'not-allowed' : 'pointer' }}><IcoDownload size={12} /> WAV</button>
                          }
                        </>
                      }
                    </>)
                  }

                  <button onClick={() => { const p = getPlayer(media); if (p && isCurrent) { p.currentTime = Math.max(0, p.currentTime - 5); setCurrentTime(p.currentTime); } else { selectMedia(media); } }} style={{ ...S.iconBtn(false), fontSize: 14 }} title="Rewind 5s">⏮</button>
                  <button onClick={() => playPause(media)} style={{ backgroundColor: C.teal + '33', border: `1px solid ${C.teal}88`, borderRadius: 8, color: C.teal, padding: 8, fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{playing ? '⏸' : '▶'}</button>
                  <button onClick={() => { const p = getPlayer(media); if (p && isCurrent) { p.currentTime = Math.min(media.duration || 0, p.currentTime + 5); setCurrentTime(p.currentTime); } }} style={{ ...S.iconBtn(false), fontSize: 14 }} title="Forward 5s">⏭</button>
                  {!isDemo && <>
                    <button onClick={() => markCensor(media)} style={{ ...S.iconBtn(false), fontSize: 14 }} title="Mark censor (B)"><IcoFlag size={12} /></button>
                    <button onClick={() => undoCensor(media)} style={{ ...S.iconBtn(false), fontSize: 14 }} title="Undo last (Z)"><IcoUndo size={12} /></button>
                    <button onClick={() => { if (window.confirm(`Delete "${media.name}"? This cannot be undone.`)) deleteMedia(media); }} style={{ ...S.iconBtn(false), fontSize: 14, color: C.censor }}><IcoTrash size={14} /></button>
                  </>}
                  {!isDemo && <button onClick={() => pinAsDemo(media)} title={pinnedId === media.id ? 'Unpin from demo' : 'Pin as demo'} style={{ ...S.iconBtn(pinnedId === media.id), fontSize: 14, color: pinnedId === media.id ? C.teal : undefined }}><IcoPin size={14} /></button>}
                </div>

                {media.isVideo && isCurrent && !currentMedia && (
                  <div ref={fsContainerRef} style={{ position: 'relative', backgroundColor: '#000', borderRadius: 10, overflow: 'hidden', width: '100%', height: '100%' }}
                    onMouseMove={resetControlsTimer} onMouseEnter={resetControlsTimer}
                    onKeyDown={resetControlsTimer} tabIndex={-1}>
                    <video ref={videoRef} src={media.url} style={{ width: '100%', height: '100%', maxHeight: 380, display: 'block', objectFit: 'contain' }}
                      onTimeUpdate={() => handleTimeUpdate(media)} onEnded={handleEnded}
                      onLoadedMetadata={() => handleLoadedMetadata(media)}
                      onPlay={() => { setIsPlaying(true); resetControlsTimer(); }}
                      onPause={handlePause}
                    />
                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(0,0,0,0.85))', transition: 'opacity 0.3s', opacity: showVideoControls ? 1 : 0, pointerEvents: showVideoControls ? 'auto' : 'none' }}>
                      <div style={{ padding: '0 12px 4px' }}>
                        <SeekBar media={media} isCurrent={isCurrent} />
                      </div>
                      <div style={{ padding: '8px 16px 14px', position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, position: 'relative' }}>
                          <button onClick={() => { const p = videoRef.current; if (p) { p.currentTime = Math.max(0, p.currentTime - 5); setCurrentTime(p.currentTime); } }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.85)', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: 0 }}>⏮</button>
                          <button onClick={() => playPause(media)} style={{ backgroundColor: '#2DD4BF33', border: '1px solid #2DD4BF88', borderRadius: 10, width: 52, height: 52, color: '#2DD4BF', fontSize: 22, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: 0 }}>{isPlaying ? '⏸' : '▶'}</button>
                          <button onClick={() => { const p = videoRef.current; if (p) { p.currentTime = Math.min(media.duration || 0, p.currentTime + 5); setCurrentTime(p.currentTime); } }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.85)', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: 0 }}>⏭</button>
                          <button onClick={() => { const p = videoRef.current; if (p) { p.pause(); p.src = ''; } setCurrentMedia(null); setCurrentTime(0); setIsPlaying(false); }} style={{ background: 'none', border: 'none', width: 42, height: 42, color: 'rgba(255,255,255,0.45)', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: 0 }}>⏹</button>
                          <div style={{ position: 'absolute', right: 0, display: 'flex', gap: 6 }}>
                            <button onClick={togglePiP} title="Picture in Picture" style={{ background: 'none', border: 'none', width: 30, height: 30, color: 'rgba(255,255,255,0.45)', fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⧉</button>
                            <button onClick={toggleFullscreen} title="Fullscreen" style={{ background: 'none', border: 'none', width: 30, height: 30, color: 'rgba(255,255,255,0.45)', fontSize: 15, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⤢</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {media.censorPoints?.length > 0 && (
                  <details style={{ padding: '0 12px 6px 54px' }}>
                    <summary style={{ fontSize: 11, color: C.censor + 'cc', cursor: 'pointer', userSelect: 'none', listStyle: 'none', display: 'flex', alignItems: 'center', gap: 5 }}>
                      <span style={{ fontSize: 9, opacity: 0.7 }}>▶</span>
                      Timestamps ({media.censorPoints.length})
                    </summary>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 6 }}>
                      {media.censorPoints.map((pt, i) => (
                        <div key={i} style={{ ...S.chip(C.censor), cursor: 'pointer' }}
                          title="Click to preview"
                          onClick={() => {
                            selectMedia(media);
                            setTimeout(() => {
                              const p = getPlayer(media);
                              if (p) { p.currentTime = Math.max(0, pt.start - 0.5); setCurrentTime(p.currentTime); }
                            }, 150);
                          }}>
                          {fmt(pt.start)}
                        </div>
                      ))}
                    </div>
                  </details>
                )}

              </div>
            );
          })}
        </div>
        {showWatchMeter && !isFullscreen && (
          <div style={{ padding: '8px 12px', borderTop: `1px solid ${C.primary}18`, flexShrink: 0 }}>
            <WatchMeter watchPct={watchPct} watchHoursUsed={watchHoursUsed} maxWatchHours={maxWatchHours} watchHoursLeft={watchHoursLeft} watchResetDateStr={watchResetDateStr} onUpgrade={handleUpgrade} onAddHours={handleAddHours} canBuyBonus={canBuyBonus} />
          </div>
        )}
      </div>
    </div>
  );
}

// ── Waveform Canvas ───────────────────────────────────────────────────────────
function WaveformCanvas({ data, currentTime, duration, censorPoints, onClick, hoverTime, hoverX, onMouseMove, onMouseLeave }) {
  const canvasRef = useRef(null);
  const H = 80;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !data?.length) return;
    const ctx = canvas.getContext('2d');
    const w = canvas.width;
    const h = canvas.height;
    const mid = h / 2;
    ctx.clearRect(0, 0, w, h);

    const barW = w / data.length;
    const progress = duration ? currentTime / duration : 0;

    ctx.fillStyle = 'rgba(255,255,255,0.06)';
    ctx.fillRect(0, mid - 1, w, 1);

    data.forEach((amp, i) => {
      const x = i * barW;
      const half = Math.max(1.5, amp * (mid - 4));
      const played = (i / data.length) < progress;
      ctx.fillStyle = played ? '#40A0DC' : '#40A0DC2a';
      ctx.fillRect(x, mid - half, Math.max(1, barW - 1), half);
      ctx.fillStyle = played ? '#40A0DC99' : '#40A0DC18';
      ctx.fillRect(x, mid, Math.max(1, barW - 1), half);
    });

    for (const pt of censorPoints || []) {
      const x1 = (pt.start / (duration || 1)) * w;
      const x2 = (pt.end / (duration || 1)) * w;
      ctx.fillStyle = '#E74C3C44';
      ctx.fillRect(x1, 0, Math.max(3, x2 - x1), h);
      ctx.fillStyle = '#E74C3Ccc';
      ctx.fillRect(x1, 0, 2, h);
      ctx.fillRect(Math.max(x1 + 2, x2 - 2), 0, 2, h);
    }

    const px = progress * w;
    ctx.fillStyle = 'rgba(255,255,255,0.95)';
    ctx.fillRect(px - 1, 0, 2, h);
  }, [data, currentTime, duration, censorPoints]);

  const handleClick = (e) => {
    if (!onClick || !duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    onClick(((e.clientX - rect.left) / rect.width) * duration);
  };

  return (
    <div style={{ position: 'relative' }}>
      <canvas ref={canvasRef} width={900} height={H} onClick={handleClick}
        onMouseMove={onMouseMove} onMouseLeave={onMouseLeave}
        style={{ width: '100%', height: H, display: 'block', cursor: 'pointer', borderRadius: 6, backgroundColor: 'rgba(255,255,255,0.025)' }}
      />
      {hoverTime != null && (
        <div style={{ position: 'absolute', left: Math.max(20, hoverX), top: 4, transform: 'translateX(-50%)', backgroundColor: 'rgba(0,0,0,0.85)', color: 'white', padding: '2px 7px', borderRadius: 4, fontSize: 11, pointerEvents: 'none', whiteSpace: 'nowrap', border: `1px solid ${C.primary}44` }}>
          {fmt(hoverTime)}
        </div>
      )}
    </div>
  );
}

// ── Contact Section ───────────────────────────────────────────────────────────
function ContactSection() {
  const [form, setForm] = React.useState({ name: '', phone: '', email: '', message: '' });
  const [sent, setSent] = React.useState(false);
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));
  const inputStyle = { width: '100%', backgroundColor: 'rgba(255,255,255,0.06)', border: `1px solid ${C.primary}33`, borderRadius: 10, color: 'white', padding: '12px 14px', fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' };
  const submit = (e) => {
    e.preventDefault();
    const body = `Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}\n\nMessage:\n${form.message}`;
    window.location.href = `mailto:support@sensorlogic.io?subject=Contact from ${encodeURIComponent(form.name)}&body=${encodeURIComponent(body)}`;
    setSent(true);
  };
  return (
    <div style={{ padding: '90px 24px', backgroundColor: C.bg, textAlign: 'center' }}>
      <div style={{ fontSize: 'clamp(20px, 3vw, 36px)', fontWeight: 900, marginBottom: 12 }}>Contact Us</div>
      <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 15, marginBottom: 50 }}>We'd love to hear from you.</div>
      <form onSubmit={submit} style={{ maxWidth: 520, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16, textAlign: 'left' }}>
        <input required placeholder="Name" value={form.name} onChange={e => set('name', e.target.value)} style={inputStyle} />
        <input placeholder="Phone (optional)" value={form.phone} onChange={e => set('phone', e.target.value)} style={inputStyle} />
        <input required type="email" placeholder="Email" value={form.email} onChange={e => set('email', e.target.value)} style={inputStyle} />
        <textarea required placeholder="How can we help?" value={form.message} onChange={e => set('message', e.target.value)} rows={5}
          style={{ ...inputStyle, resize: 'vertical', lineHeight: 1.6 }} />
        <button type="submit" style={{ padding: '14px', borderRadius: 12, border: 'none', background: `linear-gradient(90deg, ${C.primary}, ${C.teal})`, color: 'white', fontWeight: 'bold', fontSize: 15, cursor: 'pointer', boxShadow: `0 0 24px ${C.primary}44` }}>
          {sent ? 'Opening your email app...' : 'Send Message'}
        </button>
        <div style={{ textAlign: 'center', fontSize: 13, color: 'rgba(255,255,255,0.25)', marginTop: 4 }}>
          For business inquiries, please email <span style={{ color: C.primary }}>support@sensorlogic.io</span>
        </div>
      </form>
    </div>
  );
}

// ── Wave Overlay Components ───────────────────────────────────────────────────
function barColor(i, total) {
  const t = total <= 1 ? 0 : i / (total - 1);
  const a = [0x40, 0xA0, 0xDC], b = [0x2D, 0xD4, 0xBF];
  const c = a.map((v, k) => Math.round(v + (b[k] - v) * t));
  return `rgb(${c[0]},${c[1]},${c[2]})`;
}

function AnalyzingOverlay({ label = 'PAYMENT PROCESSING', sub = 'Redirecting to secure checkout…', barCount = 16, height = 90 }) {
  return (
    <div role="status" style={{ position: 'fixed', inset: 0, zIndex: 99999, background: 'rgba(13,27,42,0.92)', backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 28, fontFamily: "'Montserrat', sans-serif" }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5, height }}>
        {Array.from({ length: barCount }).map((_, i) => (
          <span key={i} style={{ display: 'inline-block', width: 6, height: '100%', borderRadius: 4, background: barColor(i, barCount), transformOrigin: 'center', animation: 'sensorWaveBig 1.1s ease-in-out infinite', animationDelay: `${(i / barCount) * 0.9}s`, boxShadow: `0 0 12px ${barColor(i, barCount)}66` }} />
        ))}
      </div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 22, letterSpacing: 6, fontWeight: 900, background: 'linear-gradient(90deg, #40A0DC, #2DD4BF)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: 8 }}>{label}</div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', letterSpacing: 1 }}>{sub}</div>
      </div>
    </div>
  );
}

function AnalyzingCard({ label = 'ANALYZING AUDIO', sub = 'Detecting profanity…', barCount = 14, height = 60 }) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 99998, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
      <div style={{ width: 300, height: 300, backgroundColor: 'rgba(13,27,42,0.97)', border: '1px solid rgba(64,160,220,0.3)', borderRadius: 20, boxShadow: '0 8px 48px rgba(0,0,0,0.8)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20, pointerEvents: 'auto', fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4, height }}>
          {Array.from({ length: barCount }).map((_, i) => (
            <span key={i} style={{ display: 'inline-block', width: 5, height: '100%', borderRadius: 3, background: barColor(i, barCount), transformOrigin: 'center', animation: 'sensorWaveBig 1.1s ease-in-out infinite', animationDelay: `${(i / barCount) * 0.9}s`, boxShadow: `0 0 8px ${barColor(i, barCount)}55` }} />
          ))}
        </div>
        <div style={{ textAlign: 'center', padding: '0 20px' }}>
          <div style={{ fontSize: 14, letterSpacing: 4, fontWeight: 900, background: 'linear-gradient(90deg, #40A0DC, #2DD4BF)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: 6 }}>{label}</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', letterSpacing: 1 }}>{sub}</div>
        </div>
      </div>
    </div>
  );
}

function ProcessingWave() {
  const bars = 8;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, padding: '2px 8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 2, height: 18 }}>
        {Array.from({ length: bars }).map((_, i) => (
          <span key={i} style={{ display: 'inline-block', width: 3, height: '100%', borderRadius: 2, background: barColor(i, bars), transformOrigin: 'center', animation: 'sensorWaveBig 1.1s ease-in-out infinite', animationDelay: `${(i / bars) * 0.9}s` }} />
        ))}
      </div>
    </div>
  );
}

// ── Wave Logo ─────────────────────────────────────────────────────────────────
function WaveLogo({ size = 56, compact = false }) {
  const W = 200, H = 64, cy = 32, cx = 100, cr = 24;
  const lh = [8, 14, 20, 28, 36, 42, 48, 52];
  const rh = [52, 48, 42, 36, 28, 20, 14, 8];

  const inner = (
    <>
      <defs>
        <radialGradient id="wlcg" cx="35%" cy="35%">
          <stop offset="0%" stopColor="#1e3f80" />
          <stop offset="100%" stopColor="#0d1f3c" />
        </radialGradient>
      </defs>
      <circle cx={cx} cy={cy} r={cr} fill="url(#wlcg)" stroke="#40A0DC" strokeWidth="1.5" />
      <path d={`M ${cx-9} ${cy-4} L ${cx-9} ${cy+4} L ${cx-5} ${cy+4} L ${cx+2} ${cy+10} L ${cx+2} ${cy-10} L ${cx-5} ${cy-4} Z`} fill="white" opacity="0.92" />
      <line x1={cx-12} y1={cy+9} x2={cx+6} y2={cy-9} stroke="white" strokeWidth="2.2" strokeLinecap="round" opacity="0.92" />
    </>
  );

  if (compact) {
    return (
      <svg width={size} height={size} viewBox={`${cx - cr - 3} ${cy - cr - 3} ${(cr + 3) * 2} ${(cr + 3) * 2}`}>
        {inner}
      </svg>
    );
  }

  return (
    <svg width={Math.round(size * W / H)} height={size} viewBox={`0 0 ${W} ${H}`}>
      {lh.map((h, i) => (
        <rect key={`l${i}`} x={8 + i * 8} y={cy - h / 2} width={4} height={h} rx="2"
          fill="#40A0DC" opacity={0.28 + i * 0.1} />
      ))}
      {rh.map((h, i) => (
        <rect key={`r${i}`} x={132 + i * 8} y={cy - h / 2} width={4} height={h} rx="2"
          fill="#2DD4BF" opacity={0.28 + (7 - i) * 0.1} />
      ))}
      {inner}
    </svg>
  );
}
